export const additionalTexts = {
  1: (
    <div>
      <p>
        2023 йилнинг 1 декабрь куни Жиноят ишлари бўйича Фарғона туман суди таниқли блогер Олимжон
        Ҳайдаровни 8 йилга озодликдан маҳрум қилиш тўғрисида ҳукм чиқарган.
      </p>

      <p>
        Ҳайдаров Ўзбекистон жиноят кодексининг 139-моддаси (туҳмат) 2-қисми, 3-қисми “а” банди,
        140-моддаси (ҳақорат қилиш) 3-қисми “а” банди ва 165-моддаси (товламачилик) 2-қисми “б”
        бандида назарда тутилган жиноятларни содир этганликда айбдор деб топилган.
      </p>

      <img src="https://gdb.rferl.org/01000000-0a00-0242-fcad-08dbf26450e3.jpg" />

      <p>
        Адвокатлар блогерга қўйилган айблар "мутлақо асоссиз" экани ва суд терговида биронта айб ўз
        исботини топмаганини айтишган.
      </p>

      <p>
        Судда асосан, Олимжон Ҳайдаров ўз чиқишларида танқид қилган маҳаллий ҳокимият ва
        ҳуқуқ-тартибот идоралари вакиллари, жумладан, Қўқон шаҳар ҳокими Маъруфжон Усмонов,
        шунингдек, Фарғона вилояти Ўзбекистон тумани ИИББ ходими ҳамда Фарғона вилоятидаги
        бозорлардан бирининг таъсисчиси Ҳайдаровга қарши кўрсатма берган.
      </p>

      <p>
        2023 йилнинг 28 декабрида Фарғона вилоят судининг апелляция судлов ҳайъати блогер Олимжон
        Ҳайдаровга нисбатан чиқарилган 8 йиллик қамоқ жазосини ўзгаришсиз қолдирган.
      </p>

      <p>
        Шунингдек, суд Мажбурий ижро бюроси зиммасига ижтимоий тармоқлардаги Ҳайдаровга тегишли
        барча канал, саҳифа ва гуруҳларни ҳукм қонуний кучга киргандан сўнг ўчириш ёки блоклаш
        вазифасини юклади.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/txsVuxP_CgE?si=7eCBvGlKB205LXjd"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Фарғона вилоят суди тафтиш инстанцияси ҳам 2024 йилнинг 11 март куни биринчи инстанция
        судининг блогерга нисбатан чиқарган ҳукмини ўзгаришсиз қолдирди.
      </p>

      <p>
        Ўзбекистон Жиноят-процессуал кодексига киритилган ўзгартишга кўра, биринчи инстанция
        судининг қароридан норози тарафлар вилоят судига апелляция ёки кассация тартибида шикоят
        қилиши мумкин. Томонлар натижадан қониқмаса, иш мазкур судларда тафтиш тартибида кўриб
        чиқилиши мумкин эди. Тафтиш инстанцияси қарори ортидан Олимжон Ҳайдаров ва адвокатларида
        Олий судга мурожаат қилиш имкони қолган.
      </p>

      <p>Олимжон Ҳайдаров 2023 йилнинг 29 июль куни ҳибсга олинган эди.</p>

      <img src="https://gdb.rferl.org/01000000-0aff-0242-282e-08db90e2da6c.jpg" />

      <p>
        Жамоат фаоллари судни Олимжон Ҳайдаровга нисбатан одил ҳукм чиқаришга ундашди. Хусусан,
        виртуал оламда #FreeOlimjonHaydarov хештеги остида блогерни зудлик билан озодликка чиқариш
        талаб илгари сурилди.
      </p>

      <p>
        Сиёсатшунос Камолиддин Раббимов Фарғонада ўқилган ҳукм “Ўзбекистонда сўз эркинлиги ва давлат
        институтларининг танқидга тоқатлилиги устидан ҳам ҳукм” эканини урғулаган.
      </p>

      <p>
        “Қўрқинчли ҳукм! Демак, суднинг мақсади жамоатчиликни қўрқитиш бўлган ва бунга эришилди”,
        деб ёзди Раббимов.
      </p>

      <p>
        Олимжон Ҳайдаров Шавкат Мирзиёев ҳокимиятга келганидан буён энг узоқ муддатга қамалган
        блогер ҳисобланади.
      </p>

      <p>
        Олимжон Ҳайдаровнинг ўзи ҳибсга олинганидан кўп ўтмай ижтимоий тармоқларда эълон қилинган
        баёнотида ўзини “сиёсий маҳбус” деб атаб,&#xa0; қамалишини тўғридан-тўғри
        касбий-профессионал фаолияти билан боғлаган. У ўз фаолияти даврида йирик коррупцион
        схемаларни фош қилганини айтган.
      </p>

      <img src="https://gdb.rferl.org/01000000-c0a8-0242-5f66-08dbf27c861f.jpg" />

      <p>
        Human Rights Watch (HRW) халқаро инсон ҳуқуқлари ташкилоти Олимжон Ҳайдаровга нисбатан
        чиқарилган ҳукмни қоралаган.
      </p>
      <p>
        2023 йилнинг 5 декабрида эълон қилинган баёнотда ташкилотнинг Марказий Осиё бўйича вакили
        Мира Риттман “суднинг Ҳайдаровни саккиз йилга озодликдан маҳрум қилиш тўғрисидаги қарори
        Ўзбекистонда сўз ва матбуот эркинлигига салбий таъсир кўрсатиши"ни айтган.
      </p>
    </div>
  ),

  2: (
    <div>
      <p>
        Ҳукуматнинг диний сиёсатини танқид қилган блогер Фозилхўжа Орифхўжаев 2022 йил январида
        жамоат хавфсизлигига таҳдид солувчи материал эълон қилгани учун 7,5 йилга қамалган эди.
        Расман ҳукмнинг сабаби Facebook'даги 2021 йилдаги пост бўлиб, унда Орифхўжаев мусулмонлар
        ғайридинларни байрамлари билан табрикламаслиги кераклиги ҳақидаги мақолани маъқуллагани
        билан изоҳланган.
      </p>

      <p>
        Судья З. Нуриддинов раислигида юритилган суд ҳукмига кўра, судланувчи Орифхўжаев Ўзбекистон
        Жиноят кодексининг 244-1-моддаси (жамоат хавфсизлиги ва жамоат тартибига таҳдид соладиган
        материалларни тайёрлаш, сақлаш, тарқатиш ёки намойиш этиш) 3-қисми “г” бандида назарда
        тутилган жиноятни содир этганликда айбдор деб топилган. Блогер суд жараёнида ўзига
        билдирилган айбловларни тан олмаган.
      </p>

      <p>
        Бундан аввал Орифхўжаев ҳукуматпараст деб айтиладиган бошқа бир диндор блогер Аброр Мухтор
        Алий (Аброр Абдуазимов) билан тортишувдан кейин майда безорилик учун 15 кунлик маъмурий
        жазога тортилган.
      </p>

      <p>
        2021 йил 28 июнь куни ички ишлар ходимлари Орифхўжаевни чақиртириб, уни майда безориликда
        айблашиб, ҳибсга олишган ҳамда уяли телефонини тортиб олишган. Ўша куни суд блогерни 15
        суткага ҳибсга олиш тўғрисида ҳукм чиқарган.
      </p>

      <p>
        Орифхўжаев жазо муддатини ўтаётганида адвокати Сергей Майоровга COVID-19 пандемиясини баҳона
        қилиб, у билан учраштиришмаган.
      </p>

      <p>
        Диний эркинликларни назорат қилувчи Forum18 халқаро ташкилоти Ф. Орифхўжаев 15 кун ҳибсда
        сақланган пайтда қамоқхона маъмурлари унга нисбатан шафқатсиз муносабатда бўлишгани ҳақида
        хабар қилган.
      </p>

      <p>
        2021 йил 13 июль куни – Орифхўжаев озод этилиши керак бўлган кунда унинг адвокати С. Майоров
        чақирилиб, мижозига “оммавий ахборот воситалари ёки телекоммуникация воситаларидан ёки
        Интернетдан фойдаланган ҳолда жамоат хавфсизлиги ва жамоат тартибига таҳдид солувчи
        материалларни тарқатиш ёки кўрсатиш” айблови билан жиноят иши қўзғатилгани маълум қилинган.
      </p>

      <p>
        Орифхўжаев ишини кузатган халқаро ташкилотлар, жумладан, АҚШнинг Халқаро диний эркинлик
        бўйича комиссияси ва Human Rights Watch (HRW) блогерга нисбатан қийноқлар ва шафқатсиз
        муомалалар бўлгани, соғлиғи ёмонлашгани ва тегишли тиббий ёрдам кўрсатилмагани ҳақидаги
        даъволарни қайд этган.
      </p>

      <p>
        <a href="https://www.ozodlik.org/a/hrw-bloger-focilxo-ja-orifxo-jayev/31601898.html">
          HRW ташкилоти
        </a>{' '}
        2021 йилнинг 9 декабрида блогер Фозилхўжа Орифхўжаевга қўйилган барча айбловларни сиёсий дея
        атаб, Ўзбекистон расмийларини бу айбловларни олиб ташлаш ва блогерни озод қилишга чақирган.
      </p>

      <p>Фозилхўжа Орифхўжаев 2023 йилнинг декабрида шартли равишда озод қилинган.</p>

      <p>
        <a href="https://thediplomat.com/2023/12/a-tale-of-2-uzbek-bloggers-arifhojaev-freed-khaidarov-jailed/">
          The Diplomat
        </a>{' '}
        нашри блогер Орифхўжаев тақдирига бағишланган мақола чоп этди. Мақола муаллифи Кэтрин
        Пуцнинг ёзишича, сўнгги йилларда "Янги Ўзбекистон”да блогерларга босим кучайган.
      </p>
    </div>
  ),
  3: (
    <div>
      <p>
        2023 йил декабрида тармоқлардаги тахаллуси “Эмине Караманова” бўлган 47 яшар Лемара
        Мирзааҳмедова 7,5 йилга қамалган.
      </p>

      <p>
        2023 йилнинг 13 декабрь куни жиноят ишлари бўйича Тошкент вилояти судининг апелляция ҳайъати
        блогерга нисбатан қуйи инстанция суди ҳукмини ўзгаришсиз қолдирди.
      </p>

      <p>
        Эмине тармоқларда ҳукумат ва президент номига очиқ танқиди, шунингдек, қатор зиддиятли
        чиқишлари билан танилганди.
      </p>

      <p>
        Эмине-Лемара Мирзааҳмедова Ўзбекистоннинг турли соҳа ва ҳокимият органларидаги коррупция,
        ҳокимлар ва куч тизимларининг қонунбузарлигини танқид қилиб келган.
      </p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/ffcVT77RcH8?si=nqsPs43K3e8V4KFP"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        47 яшар блогер 2023 йилнинг 3 мартида ҳибсга олинган, Ўзбекистон Республикаси ЖКнинг
        139-модда (туҳмат), 140-модда (ҳақорат) ва 165-модда (товламачилик), 228-моддаси (ҳужжатлар,
        штамплар, муҳрлар, бланкалар тайёрлаш, уларни қалбакилаштириш, сотиш ёки улардан
        фойдаланиш)да айбланди.
      </p>
      <p>
        Жиноят иши материалларига кўра, блогер устидан Тошкент вилояти Янгийўл тумани собиқ ҳокими
        Улуғбек Ялғошев ҳамда Янгийўл тумани ободонлаштириш бўлими раҳбари Турғуной Якубовалар ариза
        киритган.
      </p>
      <p>
        Даъвогарларга кўра, блогер уларнинг сирини ошкор қиламан, деб қўрқитиб, пул талаб қилган.
        Уларнинг бу даъвосига судда ҳокимият ходимлари гувоҳлик берган.
      </p>
      <p>
        Адвокатларга кўра, бу айбловни тасдиқловчи далилий ашё тақдим этилмаган. Суд эса ёпиқ ўтган.
      </p>
      <p>
        Блогернинг оиласи уни озод этиш эвазига ҳуқуқни муҳофаза қилиш органлари катта миқдорда пора
        талаб қилганини даъво қилган.
      </p>
      <p>
        Икки фарзанди бор Мирзааҳмедовани яқиндан билганлар ўша пайтда унинг ҳибсга олинишини
        блогерлик фаолияти билан боғлашган. Айни пайтда мазкур ишдан хабардор бир манба блогерга
        қўйилган айбловлар унинг тадбиркорлик фаолияти билан боғлиқлигини ҳам иддао қилган.
      </p>
    </div>
  ),

  4: (
    <div>
      <p>
        Мирзиёев танқидчиси сифатида танилган блогер Абдуқодир Мўминовга 2023 йилнинг 4 август куни
        жиноят ишлари бўйича Миробод туман суди ҳукми билан 3 йилгача журналистлик фаолиятни чеклаш
        ҳамда 7 йилу 3 ой муддатга озодликдан маҳрум этиш жазоси тайинланган.
      </p>

      <p>
        YouTube’даги “Кўзгу” канали муаллифи Абдуқодир Мўминов 2023 йилнинг 8 февралида
        “фирибгарлик” ва “товламачилик”да гумон қилиниб, ҳибсга олинган.
      </p>

      <img src="https://gdb.rferl.org/01000000-0a00-0242-dd84-08db8d1f1ef3_w1023_r1_s.jpg" />

      <p>
        Коррупцияга қарши чиқишлари билан танилган ва президент ҳамда оиласи мансубларининг бизнес
        алоқалари ҳақида гапириб келган Абдуқодир Мўминов 165-модда (товламачилик), 168-модда
        (фирибгарлик)дан ташқари, 141-1-модда (шахсий ҳаёт дахлсизлигини бузиш), 189-модда (савдо
        ёки хизмат кўрсатиш қоидаларини бузиш) ва 28, 211-модда (пора беришда иштирокчилик)да
        айбланди.
      </p>

      <p>
        Ҳукмга мувофиқ, судланувчидан жабрланувчилар фойдасига етказилган моддий ва маънавий зарарни
        ундириш ҳам кўзда тутилган. Мўминов иши бўйича бир неча тадбиркор дохил 14 киши жабрланувчи
        деб топилган, умумий зарар 903,4 миллион сўм деб баҳоланган.
      </p>

      <p>
        Абдуқодир Мўминов ўзига қўйилган айбларни тан олган-олмагани ҳанузгача номаълум. Судга қадар
        блогер 5 нафар адвокатнинг хизматидан воз кечган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/b6_I2u6eGSo?si=ShoPH-7fcy2NVP5a"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>2023 йилнинг 6 октябрь куни апелляция суди тайинланган жазони ўзгаришсиз қолдирди.</p>

      <p>
        Апелляция судида Абдуқодир Мўминов тергов жараёнида орган ходимлари унга нисбатан шафқатсиз
        муносабатда бўлгани, жумладан, электр токи ва резина таёқ билан зарба бергани, тепкилагани
        ва қовурғасини синдиргани ҳақида гапириб берган.
      </p>

      <p>
        9 октябрь куни Ўзбекистон Республикаси Ички ишлар вазирлиги ЖИЭДнинг 1-сонли тергов
        изоляторида сақланаётган Абдуқодир Мўминов "муассаса ички тартиб-қоидаларини бузиш" айби
        билан 10 кунлик карцерга ташлангани хабар қилинган.
      </p>

      <p>
        Онаси Сабоҳат Абдуллаеванинг сўзларига кўра, қамоқхона маъмурияти Абдуқодир Мўминов изолятор
        ички тартибини апелляция судидан анча олдин, 20 сентябрда бузгани учун энди жазога
        тортилаётганини иддао қилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/MaxUbcWo5-4?si=pauEpNSp8kmk99nA"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Абдуқодир Мўминовнинг карцерга ташлангани ҳақидаги хабар унинг апелляция судида ўзига
        нисбатан қийноқлар ҳақида гапириб, президент Шавкат Мирзиёевга мурожаат қилиши ортидан пайдо
        бўлган.
      </p>
      <p>
        Human Rights Watch халқаро инсон ҳуқуқлари ташкилоти Абдуқодир Мўминовга нисбатан шафқатсиз
        қийноқ қўллангани ҳақидаги иддаоларни текширишга чақирди.
      </p>

      <p>
        HRW’га кўра, президент Мирзиёев қийноқларга чек қўйишга ваъда берганига қарамай, жазо
        муассасаларида қийноқ ва шафқатсиз муносабат ҳамон кўп кузатилмоқда ва бу каби жиноятлар
        учун жазосизлик нормага айланиб улгурган.
      </p>

      <p>
        Ҳуқуқ фаоллари ва ижтимоий тармоқ фойдаланувчилари блогер президент Мирзиёевнинг куёвлари
        бизнеси ҳақида олиб бораётган суриштируви туфайли қўлга олинганига ишонишади.
      </p>

      <p>
        2022 йил декабрида Абдуқодир Мўминов номаълум шахслар унга ҳужум қилиб, машинасининг
        ойналарини синдиргани ва ўзини дўппослаганини айтган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/xh7b8xBcS60?si=cSp_KzkNlffs0aWC"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Тошкент шаҳар ИИББ ҳодиса юзасидан Ўзбекистон ЖКнинг 164-моддаси (“талончилик”) бўйича
        жиноят иши очгани ҳақида хабар берган, аммо унинг натижаси ҳақида жамоатчиликка ҳеч қандай
        хабар берилмаган.
      </p>
    </div>
  ),
  5: (
    <div>
      <p>
        2023 йилнинг декабрь ойида жиноят ишлари бўйича Андижон вилояти суди ҳукми билан блогер
        Отабек Аҳлиддинов 7,1 йилга озодликдан маҳрум қилинди.
      </p>

      <p>
        “Эзгулик” инсон ҳуқуқлари жамияти раиси Абдураҳмон Ташановга кўра, Отабек Аҳлиддинов
        Ўзбекистон ЖКнинг 167-моддаси 2-қисми (ўзлаштириш ёки растрата йўли билан талон-торож
        қилиш)да назарда тутилган жиноятни содир этганликда айбдор деб топилган.
      </p>

      <p>
        Отабек Аҳлиддинов Андижон вилояти Шаҳрихон туманидаги марказий поликлиникада бўлим раҳбари
        лавозимида ишлаган. Айблов хулосасига кўра, Аҳлиддинов 200 миллион сўмдан ортиқ пулни
        ўзлаштириб юборган.
      </p>

      <p>
        Блогер шу йилнинг сентябрида қамоққа олинган. Дастлаб у жиноят ишлари бўйича Хонобод тумани
        суди ҳукми билан 5,1 йилга қамалган эди. Сўнг прокуратуранинг протести асосида апелляция
        суди ишни қайта кўриб, муддатни 7,1 йилга узайтирган.
      </p>

      <p>
        Отабек Аҳлиддинов Ўзбекистон инсон ҳуқуқлари “Эзгулик” жамияти аъзоси бўлган. У ўз
        чиқишларида қатор ҳукумат тизимлари фаолиятини танқид қилган эди.
      </p>
    </div>
  ),
  6: (
    <div>
      <p>
        Human.uz сайти асосчиси, журналист ва блогер Хуршид Далиев 2023 йил январь ойида
        “Kompromatuzb иши” доирасида ҳибсга олинган. Жиноят ишлари бўйича Шайхонтоҳур туман судида
        2023 йил 26 сентябрь куни якунланган ёпиқ суд ҳукмига мувофиқ 7 йил муддатга озодликдан
        маҳрум этилган.
      </p>

      <p>
        Ҳукмга мувофиқ, суд Хуршид Далиев Ўзбекистон Жиноят-процессуал кодексининг 83-моддаси
        (реабилитация учун асослар) 1-бандига асосан жиноят ишининг айрим эпизодлари бўйича Жиноят
        кодексининг 139-моддаси (туҳмат) 2-қисми ва 165-моддаси (товламачилик) 3-қисми “а” бандида
        назарда тутилган жиноятларни содир этишда айбсиз деб топиб, оқлаган.
      </p>

      <p>
        Айни пайтда Human.uz асосчиси Ўзбекистон Жиноят кодексининг 139-моддаси 2-қисми, 165-моддаси
        3-қисми “а” банди, 184-моддаси (солиқлар ёки йиғимларни тўлашдан бўйин товлаш) 3-қисми ва
        243-моддаси (жиноий фаолиятдан олинган даромадларни легаллаштириш)да назарда тутилган
        жиноятларни содир этганликда айбдор топилган. Унга 3 йилга оммавий ахборот воситаларида
        ишлаш ҳамда журналистика ва блогерлик фаолияти билан шуғулланиш ҳуқуқидан маҳрум қилган
        ҳолда базавий ҳисоблаш миқдорининг 300 баравари (99 миллион сўм) миқдорида жарима ва 7 йил
        муддатга озодликдан маҳрум қилиш жазолари тайинланган. Хуршид Далиев қамоқ жазосини умумий
        тартибли колонияларда ўташи қайд этилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/BC0bpMui6ZA?si=RmvK2L7tPGKl1mtW"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>Давлат айбловчиси Хуршид Далиев учун 15 йиллик қамоқ жазоси сўраган.</p>
      <p>
        Озодлик манбасига кўра, суддаги сўнгги сўзида Human.uz раҳбари Хуршид Далиев “ҳатто
        терроризм ва конституциявий тузумга қарши жиноятлар содир этган шахсларга нисбатан ҳам
        бундай катта жазо сўралмаган”ини айтган.
      </p>

      <p>
        “Албатта, хатолар қилдик. Лекин бу давлат айбловчисининг бундай катта муддат сўраши
        адолатсизликдир. Масалан, мен таҳририятда йиллар давомида реклама ва бошқа турдаги
        даромадларимиз эвазига 30 та оилани боқиб келдим. Давлатга қарашли Аграр Университетнинг
        ўзимиз ижарада турган биноларини замонавий таъмирлатдик. Болаларим қиммат мактабларга
        бормади, уларга қиммат кийимлар олиб бермадим. Биронта банкнинг эшигини тақиллатиб, реклама
        сўраб борганим йўқ”, деган Хуршид Далиев.
      </p>

      <p>
        360 саҳифалик жиноят ишининг айблов хулосасига кўра, айбланувчилар гўё “Kompromatuzb”
        каналида танқидий материалларни чиқаришни тўхтатиш учун товламачилик билан шуғулланган.
      </p>

      <p>
        Улар товламачилик йўли билан вазирлик, агентлик ва бир қанча банкларни ўзининг
        раҳбарлигидаги “Human media”, “Bon profi media”, “Alm media web” ва “Komil unsur” МЧЖларга
        гўёки “PR” қилиш юзасидан жуда кўп сўм миқдордаги шартномаларни тузишга мажбур қилгани
        айтилади.
      </p>

      <p>
        ДХХ томонидан тергов қилинган ва “Kompromatuzb иши” номини олган жиноят иши доирасида 4
        нафар айбланувчи, 19 нафар жабрланувчи, ва шунингдек, 10 нафар фуқаровий даъвогар мавжуд.
        Жумладан, Бандлик вазирлиги собиқ матбуот котиби Мавжуда Мирзаевага 5 йил муддатга озодликни
        чеклаш жазоси тайинланган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/f2HevsG7nIE?si=G1B7H57gN_JzL3lu"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Жиноят оқибатида жабрланувчиларга нисбатан 5,1 миллиард сўмдан ортиқ моддий зарар
        етказилгани тахмин қилинган.
      </p>

      <p>
        “Kompromatuzb иши” доирасида журналист Хуршид Далиев раҳбарлик қилган Human.uz, Sof.uz,
        Terrabayt.uz сингари таҳририятлар мулклари, хусусан, битта “Malibu”, битта “Lacetti”, 2 та
        “Nexia 3” ва 1 та “Damas” жиноий фаолиятдан келган даромадлар ўлароқ хатланган.
      </p>

      <p>
        Шунингдек, мазкур таҳририятларнинг 10 дан ортиқ камералари ва компьютерлари, мобил
        қурилмалар тергов органи томонидан ҳибсга олинган.
      </p>

      <p>
        Human.uz сайтининг асосчиси Хуршид Далиев танқидий-таҳлилий чиқишлари билан эътиборга тушган
        журналист.
      </p>

      <p>Бир муддат "Ёшлар" телеканали ва "Kun.uz" сайтларида ишлаган.</p>

      <p>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/RSpYQSIk05g?si=id7SMrDuBcVigqFg"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </p>

      <p>
        2019 йилда Хуршид Далиев Андижон вилоятидаги мутасаддиларни танқид қилиб чиқиши ортидан
        исми-шарифи номаълум шахслар ўлим билан таҳдид қилгани ҳақда Human.uz сайтида баёнот
        билан&#xa0; чиққанди.
      </p>
    </div>
  ),
  7: (
    <div>
      <p>
        “Ўзбекнефтгаз” матбуот котиби вазифасида ишлаб келган Сиёвуш Ҳошимов 2023 йил январь ойида
        “Kompromatuzb иши” доирасида ҳибсга олинган. Жиноят ишлари бўйича Шайхонтоҳур туман судида
        2023 йил 26 сентябрь куни якунланган ёпиқ суд ҳукмига мувофиқ 7 йил муддатга озодликдан
        маҳрум этилган.
      </p>

      <p>
        Ҳукмга кўра, Сиёвуш Ҳошимов Ўзбекистон Жиноят-процессуал кодексининг 83-моддаси 1-бандига
        асосан жиноят ишининг айрим эпизодлари бўйича Жиноят кодексининг 139-моддаси 2-қисми ва
        165-моддаси 3-қисми “а” бандида назарда тутилган жиноятларни содир этишда айбсиз деб
        топилиб, реабилитация этилган.
      </p>

      <p>
        Шу билан бирга, “Ўзбекнефтгаз” ширкати матбуот котиби мамлакат Жиноят кодексининг
        139-моддаси 2-қисми, 165-моддаси 3-қисми “а” банди ва 243-моддасида назарда тутилган
        жиноятларни содир этганликда айбли топилиб, унга ҳам ОАВда ишлаш ҳамда журналистика ва
        блогерлик фаолияти билан шуғулланиш ҳуқуқидан маҳрум қилган ҳолда 7 йил муддатга озодликдан
        маҳрум қилиш жазоси тайинланган. Жазони умумий тартибли колонияларда ўташи айтилган.
      </p>

      <p>
        Давлат айбловчиси суддан Сиёвуш Ҳошимовга 15 йиллик қамоқ жазоси тайинлашни сўраган эди.
      </p>

      <p>
        &#xa0;“Ўзбекнефтгаз” ширкати собиқ матбуот котиби Сиёвуш Ҳошимов маҳкамадаги сўнгги сўзида
        “қонунларни бузмагани, жиноий йўл билан даромад орттирмагани, барчаси терговнинг уйдирмалари
        экани”ни айтган. У қарамоғида ногирон ота-онаси борлигини айтиб, прокурор сўраган жазо
        муддатининг ҳаддан ташқари адолатсиз эканини урғулаган.
      </p>

      <p>
        ДХХ томонидан тергов қилинган ва “Kompromatuzb иши” номини олган жиноят иши доирасида 4
        нафар айбланувчи, 19 нафар жабрланувчи, ва шунингдек, 10 нафар фуқаровий даъвогар мавжуд.
        Жумладан, Human.uz сайти асосчиси, журналист ва блогер Хуршид Далиев 7 йилга қамалган.
        Бандлик вазирлиги собиқ матбуот котиби Мавжуда Мирзаевага 5 йил муддатга озодликни чеклаш
        жазоси тайинланган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/f2HevsG7nIE?si=6w5C-ixr9g7GqQi4"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        360 саҳифалик жиноят ишининг айблов хулосасига кўра, айбланувчилар гўё “Kompromatuzb”
        каналида танқидий материалларни чиқаришни тўхтатиш учун товламачилик билан шуғулланган.
      </p>

      <p>
        Жиноят оқибатида жабрланувчиларга нисбатан 5,1 миллиард сўмдан ортиқ моддий зарар
        етказилгани тахмин қилинган.
      </p>
    </div>
  ),
  8: (
    <div>
      <p>
        27 ёшли Ҳаёт Самарқандий (Норбоев) Ўзбекистон Республикаси ЖКнинг 165-моддаси 2-қисми
        (товламачилик) билан айбланиб, жиноят ишлари бўйича Самарқанд вилояти Каттақўрғон тумани
        судининг 2022 йил 13 июлидаги ҳукми билан 7 йилга озодликдан маҳрум қилинган.
      </p>

      <p>
        Жиноят иши тафсилотларига кўра, блогер ўзи истиқомат қиладиган Самарқанд вилояти Нарпай
        тумани ҳокими Шерзод Раҳмоновга халқ депутатлари Нарпай тумани кенгашида шарманда қилиш
        билан таҳдид қилган.
      </p>

      <p>
        Нарпай тумани ҳокими Шерзод Раҳмоновнинг аризаси асосида тезкор ушлаш тадбири уюштирилиб,
        блогер махсус кукун билан ишлов берилган 15 миллион сўм миқдоридаги пулни олиш чоғида қўлга
        туширилган.
      </p>

      <p>
        Жиноят иши 2022 йил сентябрь ойида Самарқанд вилояти судида апелляция тартибида кўрилган ва
        ҳукм ўзгаришсиз қолдирилган.
      </p>

      <p>
        Ўзбекистон Республикаси Олий судининг кассация судлов ҳайъати 2022 йил 19 декабрь куни
        блогер Ҳаёт Самарқандийга нисбатан 7 йиллик қамоқ жазосини бекор қилиб, ишни қайта кўриш
        учун қуйи инстанция судига юборган. Суд тафсилотлари Озодликка маълум эмас.
      </p>

      <p>
        Блогер Самарқандий Жиззах Давлат университети педагогика-психология факультетининг 3-босқич
        талабаси эди.
      </p>
    </div>
  ),
  9: (
    <div>
      <p>
        Термизлик видеоблогер Отабек Саттторий воқеасини президент Мирзиёевнинг “Янги Ўзбекистон”ида
        блогерлар овозини ўчириш ва сўз эркинлиги бўғилишига яққол мисол тарзида келтириш мумкин.
      </p>

      <p>
        Танқидий чиқишлари сабаб қамалгани айтиладиган Сатторий 2024 йил февралида озод қилинди.
        Бироқ у қамоқдан чиқишидан аввал бундан кейин блогерлик билан шуғулланмаслиги ҳақида баёнот
        берган эди.
      </p>

      <p>Сатторий Мирзиёев даврида узоқ муддатга қамалган илк блогер ҳисобланади.</p>

      <p>
        Сатторий 2021 йилнинг 10 майида жиноят ишлари бўйича Сурхондарё вилояти Музработ тумани суди
        ҳукмига кўра, 6,5 йилга озодликдан маҳрум қилинган.
      </p>
      <p>
        Сатторий YouTube порталидаги “Халқ фикри” видеоблогида танқидий чиқишлари билан танилган. У
        маҳаллий амалдорларни коррупция ва нотўғри бошқарувда айблаб аёвсиз танқид қилган.
      </p>
      <p>
        Блогерга қарши кўрилган чоралар кўлами мисли кўрилмаган бўлди. Уни 30 январь куни ҳибсга
        олиш учун Ички ишлар вазирлиги ходимларидан иборат катта гуруҳ жалб қилинди, терговчилар
        унинг уйини туни билан тинтув қилди.
      </p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/Opctg405BPY?si=EFafDWqfFl3YP6I_"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        Сатторий Жиноят кодексининг 139-моддаси 3-қисми “а”, “г” бандлари (оғир ёки ўта оғир жиноят
        содир этишда айблаб, ғаразгўйлик ёки бошқа паст ниятларда туҳмат қилиш) ва 165-моддаси
        3-қисми “а” банди (жуда кўп миқдордаги товламачилик) да айбдор деб топилган. Давлат
        айбловчиси уни 11 йилга озодликдан маҳрум этишни сўраган эди.
      </p>
      <p>
        2021 йил 10 май куни апелляция суди Отабек Сатторийга чиқарилган ҳукмни ўз кучида қолдирди.
      </p>
      <p>
        2022 йилнинг апрелида Ўзбекистон Олий суди ҳам Сатторийга нисбатан дастлабки суд ҳукмини ўз
        кучида қолдирди.
      </p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/WIn7eI3FlyQ?si=WHlkyukK7ur8mfqv"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>Отабек Сатторий судда айбловни тан олган эмас.</p>
      <p>
        Сатторий Сурхондарёдаги очиқ маҳкама жараёнида судлов ҳайъати раиси ва прокурорларга хитобан
        бир неча марта “орқасида президент Мирзиёев тургани”ни айтган.
      </p>
      <p>
        АҚШдаги The Diplomat нашри Сатторий судини ёритаркан, президент Мирзиёевнинг ўзбек
        блогерларига берган ваъдасини эслатди.
      </p>
      <p>
        Eurasianet нашри Сатторийга чиқарилган ҳукм мамлакатда бошланган ислоҳотлар тарафдорларини
        даҳшатга солгани ҳақида ёзди.
      </p>
      <p>
        Халқаро ташкилотлар Сатторий блогерлик фаолияти ортидан “сохталаштирилган жиноят иши асосида
        қамалди”, деб ҳисоблади.
      </p>
      <p>
        Қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси (CPJ) Ўзбекистон
        ҳукуматини Сатторийни зудлик билан озод этишга чақириб, ҳукумат журналистларга эркин ва
        қасос олишлардан қўрқмасдан фаолият олиб боришга имкон бериши кераклигини урғулаган.
      </p>
      <p>
        “Чегара билмас мухбирлар” халқаро ташкилоти (RSF) эса Сатторийнинг қамалишини “ҳукуматнинг
        маҳаллий коррупция ортидан келиб чиқаётган жанжалларни бостириш ва танқидчиларни қўрқитишга
        интилиши” ўлароқ баҳолади.
      </p>
      <p>
        Human Rights Watch Сатторийга чиқарилган ҳукмни Ўзбекистонда сўз эркинлигига берилган зарба
        ва маҳкама хатоси, деб атаган. HRW ўз баёнотида блогерга нисбатан очилган жиноят иши, унга
        нисбатан қўйилган айбловлар шубҳали эканини урғулаган.
      </p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/-G1JLeW7oU8?si=2e2HYsH7jqp9w8o3"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        <a href="https://www.amnesty.org/en/location/europe-and-central-asia/uzbekistan/report-uzbekistan/">
          Amnesty International
        </a>{' '}
        ташкилоти ҳам 2021 йилги ҳисоботида Сатторий қамалишини қоралади.
      </p>
      <p>АҚШ Давлат департаменти ҳисоботида ҳам Сатторий тилга олинган.</p>

      <p>
        Жанубий Калифорния университетининг инсон ҳуқуқлари амалиёти бўйича адъюнкт-профессори Стив
        Свердлоу Сатторий қамалиши ортидан “Ўзбекистон танқидий журналистларни қамоққа ташлайдиган
        ва сўз эркинлигига ҳужум қиладиган мамлакатлар сафида кўзга кўринарли ўринни эгаллади», деб
        ёзди.
      </p>
      <p>
        2024 йилнинг 5 февраль куни Сатторий жиноят ишлари бўйича Қашқадарё вилояти Қарши туман суди
        ҳукми билан қамоқдан озод этилди.
      </p>
      <p>
        Вилоят судлари матбуот хизматининг
        <a href="https://t.me/qashqadaryoviloyatisudlari/8553">билдиришича,</a> унга белгиланган
        жазо ахлоқ тузатиш иши жазосига алмаштирилган. Бундан ташқари блогер иш ҳақининг 20 фоизи
        давлат даромади фойдасига ундирилиши суд ҳукмида қайд этилди.
      </p>
      <p>
        Сатторий Қаршидаги манзил колонияда пайти у билан учрашган инсон ҳуқуқлари "Эзгулик" жамияти
        раҳбари{' '}
        <a href="https://www.ozodlik.org/a/sattoriy-tajimuratov-qamoq/32788725.html">
          Абдураҳмон Ташанов
        </a>{' '}
        га кўра, халқаро матбуот ва ҳуқуқ ташкилотлари блогерлик фаолияти учун қамалган деб
        ишонадиган Сатторий озодликка чиққанидан сўнг "блогерлик фаолиятини давом эттирмоқчи эмас".
      </p>
      <p>
        Сатторий буни "тинчгина яшаш ва келажакда IT соҳасини эгаллаш" режаси билан тушунтирган.
      </p>
      <p>
        "Ҳужжатларимни ёқиб юборганман, энди блогерлик қилмайман, деди Отабек”, дея Сатторийнинг
        сўзларидан иқтибос келтирди Ташанов.
      </p>
    </div>
  ),
  10: (
    <div>
      <p>
        Ўзбекистон Мустақил босма оммавий ахборот воситалари ва ахборот агентликларини
        қўллаб-қувватлаш ва ривожлантириш жамоат жамғармаси директори лавозимида ишлаб келган
        Саид-Абдулазиз Юсупов 2019 йил 10 май куни фирибгарликда айбланиб қўлга олинган.
      </p>

      <p>
        У 2019 йилнинг сентябрида Жиноят кодексининг 167- ("ўзлаштириш ёки растрата йўли билан
        талон-торож қилиш"), 168- ("фирибгарлик") ҳамда 28- ("жиноят иштирокчиларининг турлари") ва
        211- ("пора олиш-беришда воситачилик қилиш") моддаларида назарда тутилган жиноятларни содир
        этганликда айбланиб, суд ҳукми билан 6 йилга озодликдан маҳрум этилган.
      </p>

      <p>
        Бош прокуратура расмий баëнотига кўра¸ Саид-Абдулазиз Юсупов “ўзини Давлат хавфсизлик
        хизмати масъул ходими деб таништириб, фирибгарлик йўли билан одамлардан жуда катта
        миқдорларда пул олган”ликда айбланган.
      </p>

      <p>
        Ҳибсга олинганидан сўнг Юсуповнинг онаси ва хотини унинг тергов давомида қийноққа солингани
        ва шошилинч тиббий ëрдамга муҳтожлигини билдирган. Хусусан, 2019 йилнинг 9 сентябрида
        ижтимоий тармоқларда Саид-Абдулазиз Юсуповга тааллуқли экани ишонилган, унинг оила
        аъзоларига ҳибсхонадан чиқарган мактуби тарқалган эди.
      </p>

      <p>
        "У ерда "Темур", "Ойбек", "Бердак"лар 6,5 сутка давомида менга нисбатан жисмоний, руҳий,
        психологик тазйиқ ўтказишди. Мени ҳатто зўрламоқчи бўлишди. Яъни дубинка билан номусимга
        тажовуз қилмоқчи бўлишди. Мени синдирган нарса – аяжоним ва аёлимни қамаш, хўрлаш, кейин эса
        бола чақам-у отамгача қандай қилиб ўлдириб юборишларини айтиб ишонтиришгани бўлди", деб
        ёзилган эди мактубда.
      </p>

      <p>Аммо прокуратура бу иддаоларни рад қилган.</p>

      <p>
        Фирибгарликда айбланиб қамалган журналист Саид-Абдулазиз Юсупов 2020 йил январь ойида
        маҳкумликдаги ҳаëтига оид мақола ëзган.
      </p>
      <p>
        Ўзбекистон Ички ишлар вазирлиги Жазони ижро этиш бош бошқармаси муассислигидаги «Вақт-Время»
        газетасида чоп этилган мақола-мактубда матбуот тизимининг собиқ амалдори¸ жазо муддатини
        ўташ учун колонияга келганидан ўзининг “яхши маънодаги шок”ка тушганини ëзган.
      </p>

      <p>
        Саид-Абдулазиз Юсуповнинг ëзишича¸ уни “жазони ижро этиш муассасаси ходимларининг “сиз"лаб
        мурожаат этишгани, қўполлик қилмай, нафсониятга тегмай муомала қилишлари ўзини
        ҳайратлантирган”.
      </p>

      <p>
        Бир йилу 2 ой давомида ҳибсда ушланган Саид-Абдулазиз Юсупов 2020 йил 8 июль куни қамоқдан
        озод этилган.
      </p>

      <p>
        Қамоқдан чиққанидан сўнг Саид-Абдулазиз Юсупов президент Мирзиёев оиласини олқишлайдиган
        қатор чиқишлар қилган.&#xa0;
      </p>

      <p>
        Жумладан, президентнинг кенжа куёви Отабек Умаровни “чодирининг қозиғигача тиллодан бўлган
        бой йигит”, ўзбек ëшлари учун бутун бошли ИИВ қила олмаган ишларни қилган "қаҳрамон"
        сифатида тасвирлайди.
      </p>
    </div>
  ),
  11: (
    <div>
      <p>
        Бандлик вазирлиги собиқ матбуот котиби, журналист Мавжуда Мирзаева 2023 йил 29 январь куни
        Kompromаtuzb иши бўйича ҳибсга олинган.
      </p>

      <p>
        Жиноят ишлари бўйича Шайхонтоҳур туман судида 2023 йил 26 сентябрь куни якунланган ёпиқ суд
        ҳукмига мувофиқ, у Жиноят кодексининг 113-моддаси 4-қисми ва 165-моддаси 2-қисми “а”, “в”
        бандларида назарда тутилган жиноятларни содир этганликда айбдор топилган. Мавжуда Мирзаевага
        нисбатан 3 йилга ОАВда ишлаш ҳамда журналистика ва блогерлик фаолияти билан шуғулланиш
        ҳуқуқидан маҳрум қилган ҳолда 5 йил муддатга озодликни чеклаш жазоси тайинланган.
      </p>

      <p>
        Маҳкама жараёнида прокурор Мирзаевани 6 йилга озодликдан маҳрум қилиш билан жазолашни
        сўраган.
      </p>

      <p>
        Мавжуда Мирзаева ўзининг айбдорлигини қисман тан олиб, судда қамоқ билан боғлиқ бўлмаган
        жазо беришларини сўраган.
      </p>

      <p>
        ДХХ томонидан тергов қилинган ва “Kompromatuzb иши” номини олган жиноят иши доирасида 4
        нафар айбланувчи, 19 нафар жабрланувчи, ва шунингдек, 10 нафар фуқаровий даъвогар мавжуд.
        Жумладан, Human.uz сайти асосчиси, журналист ва блогер Хуршид Далиев 7 йилга қамалган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/f2HevsG7nIE?si=YlCnJon9eShXxr_U"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Жиноят оқибатида жабрланувчиларга нисбатан 5,1 миллиард сўмдан ортиқ моддий зарар
        етказилгани тахмин қилинган.
      </p>

      <p>
        Айблов хулосасига кўра, “Kompromatuzb иши” доирасида судланганлар "товламачилик йўли билан
        молия муассасаларини реклама ва бошқа ижтимоий роликлар кўринишида Human.uz ва бошқа
        сайтларда чиқишлар қилишга мажбурлаган".
      </p>

      <p>
        Айбланувчилар мазкур молия муассасалари ва бошқа идораларнинг ходимлари билан алоқа ўрнатиб,
        уларнинг касбий фаолияти ва шахсий сирларига оид маълумотларни қўлга киритиб, улардан
        товламачилик воситасида фойдаланишгани иддао қилинади.
      </p>

      <p>
        Ҳозирга қадар судланувчилар ёки адвокатларининг ушбу айбловлар юзасидан берган кўрсатмалари
        жамоатчиликка маълум эмас. Жиноят ишининг ДХХ томонидан қўзғатилгани, тергов ва маҳкама
        атрофидаги махфийлик маҳаллий журналистлар ва жамоатчиликда хавотирларни пайдо қилган.
        KompromatUzb Телеграм канали коррупция ва непотизмга оид алоҳида ҳолатларни фош қилгани
        айтилади.
      </p>

      <p>
        Журналист Мавжуда Мирзаева 2018 йил ноябрь ойида ўзи ишлаб келган "Ўзбекистон 24"
        телеканалидаги ички вазият бўйича очиқ чиқиш қилиши ортидан омма назарига тушган эди. Ўшанда
        у телеканалда цензура мавжудлиги ҳақида гапирган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/oCIhkBl4v2I?si=DcPMD49O9YXiaQUy"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2020 йил декабрь ойида Тошкентда ўтказилган халқаро анжумада Мавжуда Мирзаева журналистларга
        босимлар бўлаётгани, хусусан, ўзининг ишдан бўшатилганини айтган эди.
      </p>
    </div>
  ),
  12: (
    <div>
      <p>
        2024 йил бошида 24 ёшли Ситора Бозорова ижтимоий тармоқларда Президент Шавкат Мирзиёев
        “сулоласи”ни “ёқиб юбориш”га чақирган постлари учун беш йилу икки ойга озодликдан маҳрум
        этилган.
      </p>

      <p>
        Жиноят ишлари бўйича Термиз шаҳар суди Ситора Бозоровани Ўзбекистон Жиноят кодексининг
        158-моддаси, 3-қисми - "Ўзбекистон президентини омма олдида ҳақоратлаш ёки унга туҳмат
        қилиш"да айбдор деб топган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/NvGFpJ_D2mA?si=fBDUhUZtTlChtGTR"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Озодликда нусхаси мавжуд суд ажримидан маълум бўлишича, Ситора Бозорова&#xa0; Facebook
        тармоғида “Ситора Ибрагимовна”, “Тўмарис Барчиной”, “Қиролича Қиролича”. “Наргиза
        Олимова”&#xa0; профиллари остида постлар тарқатиб келган. Бу постлардан баъзилари суд
        ҳужжатларида келтирилади.
      </p>

      <p>
        Жумладан, 2022 йил 3 май куни Ўзбекистон президенти Шавкат Мирзиёевнинг сурати устига
        “Даюс”, “батраклар сулоласи”, “сулоланг ёнсин” деган мазмунда ҳамда президентнинг қизи Саида
        Мирзиёеванинг сурати устига “фоҳиша” деб ёзилган суратларни тарқатган.&#xa0;
      </p>

      <p>Суд ҳукмидан аён бўлишича, Бозорова 2023 йилнинг сентябрь ойида ҳибсга олинган.</p>
    </div>
  ),

  13: (
    <div>
      <p>
        2024 йил мартида Наманганда ижтимоий тармоқларда Ўзбекистон президенти Шавкат Мирзиёевга
        қарши ҳақоратли изоҳлар ёзган 28 ёшли йигит судланди.
      </p>

      <p>
        Uznews нашри <a href="https://uznews.uz/posts/73258">хабар</a>ига кўра, Д.Турсунов исмли
        наманганлик шахс Facebook тармоғида очилган профилига 2023 йил 8 май куни “Ўзбекистон
        Президенти Москвада Ғалабанинг 78 йиллигига бағишланган тадбирларда иштирок этади” номли
        мақоладан кўчириб олинган экран тасвирини жойлаштириб, ушбу постда Ўзбекистон президентини
        ҳақоратлаган ва унга туҳмат қилган.
      </p>

      <p>
        “Бундан ташқари, у Facebook орқали турли постларга давлатга қарши изоҳлар қолдирган”, деб
        ёзган Uznews маълумот олинган манбани келтирган эмас.
      </p>

      <p>
        Нашрга кўра, судланувчи 2016 йил 26 сентябрь куни Ўзбекистондан Озарбайжонга бориб, 2016 йил
        30 сентябрь куни у ердан фуқаролик паспортига дунёнинг барча мамлакатларига чиқиш учун
        махсус рухсат стикери расмийлаштирилмаган бўлса-да, белгиланган тартибни бузиб, Эронга
        кириб, қонунга хилоф равишда чет элга чиққан.
      </p>

      <p>
        Суд ҳукми билан судланувчи Ўзбекистон Жиноят кодексининг 158-моддаси 3-қисми (Ўзбекистон
        Республикаси Президентини омма олдида ҳақоратлаш ёки унга туҳмат қилиш, шунингдек, матбуот
        ёки бошқа оммавий ахборот воситаларидан, телекоммуникация тармоқларидан ёки Интернет
        бутунжаҳон ахборот тармоғидан фойдаланган ҳолда уни ҳақоратлаш ёки унга туҳмат қилиш) ва
        223-моддаси (Қонунга хилоф равишда чет элга чиқиш ёки Ўзбекистон Республикасига кириш)
        1-қисмида назарда тутилган жиноятларни содир қилганликда айбдор деб топилган ва унга
        нисбатан 5 йилга озодликдан маҳрум қилиш жазоси тайинланган.
      </p>
    </div>
  ),
  14: (
    <div>
      <p>
        Қашқадарё вилояти Нишон тумани судида 2024 йил 29 январь куни наманганлик блогер Абдуҳаким
        Абжалилов иши бўйича ҳукм ўқилди.
      </p>
      <p>
        "Қашқадарё вилояти судлари" телеграм канали маълумотига кўра, Ўзбекистон Жиноят кодексининг
        165-моддаси (товламачилик) 2-қисми “а”, “в” бандларида назарда тутилган жиноятни содир
        этганликда айбдор деб топилган Абжалилов 5 йил муддатга озодликдан маҳрум этилган.
      </p>

      <p>
        &#xa0;“Achchiq haqiqat” МЧЖ раҳбари бўлган Абжалилов, суд ҳукмига мувофиқ, ўзига нисбатан
        тайинланган жазони умумий тартибли колонияларда ўтайди.
      </p>

      <p>
        Хабарномада 49 ёшли наманганлик блогер нима учун Қашқадарё вилоятида судланганига аниқлик
        киритилган эмас.
      </p>

      <p>
        Youtube тармоғида 600 мингдан зиёд обуначига эга Sirojiddin Media канали эгаси Сирожиддин
        Адилов Абдуҳаким Абжалилов судида иштирок этгани, судланувчининг адвокати блогернинг ноҳақ
        қамалгани, ҳукм юзасидан апелляция тартибида шикоят аризаси кирилишини билдирганини маълум
        қилган.
      </p>
    </div>
  ),
  15: (
    <div>
      <p>
        Рустам Карим&#xa0; - Ўзбекистон президенти ҳақидаги танқидий чиқишлари билан танилган
        блогер.
      </p>

      <p>
        2019 йил 18 октябрь куни Жиноят ишлари бўйича Тошкент шаҳар суди ҳукмига кўра, Рустам Карим
        (Рустамбек Каримов — 1975 й. т.)&#xa0;&#xa0;&#xa0; Ўзбекистон Жиноят кодекси 244−1-моддаси
        (жамоат хавфсизлиги ва жамоат тартибига таҳдид соладиган материалларни тайёрлаш, сақлаш,
        тарқатиш ёки намойиш этиш) 1-қисмида назарда тутилган жиноятни содир этганликда айбдор деб
        топилган ва 3 йил 1 ой муддатга озодликдан маҳрум қилиш жазоси тайинланган.&#xa0;
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/EVqntkyKDGs?si=yYyF073zoQsAgDnu"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Рустам Карим ва унинг шериги Тўлқин Астанов 2019 йилнинг 8 апрелида Ўзбекистон Мусулмонлар
        идорасида безорилик қилганликда гумонланиб қўлга олинган эди. Тошкент ИИББ бу икки шахснинг
        Facebook ижтимоий тармоғида диний идора раиси «шаънига путур етказувчи постлар қолдирган"ини
        ҳам маълум қилган.
      </p>

      <p>
        Рустам Карим ва Тўлқин Астановлар Facebook ижтимоий тармоғида Диний идора раҳбарияти ва
        мамлакат ичидаги айрим уламоларга нисбатан кескин танқиди, ҳажвий постлари билан танилган.
      </p>

      <p>
        Қамоқдан чиқиши билан Ўзбекистонни тарк этишга қарор қилган Рустам Каримга кўра, у Россия
        паспорти билан Мексика орқали АҚШга келиб, сиёсий бошпана сўраган.
      </p>
    </div>
  ),
  16: (
    <div>
      <p>
        Тўлқин Астанов Facebook ижтимоий тармоғида Диний идора раҳбарияти ва мамлакат ичидаги айрим
        уламоларга нисбатан кескин танқиди, ҳажвий постлари билан танилган фаол.
      </p>

      <p>
        2019 йил 18 октябрь куни Жиноят ишлари бўйича Тошкент шаҳар судида Тўлқин Астановга (1971
        й.т.) ва Рустам Карим (Рустамбек Каримов — 1975 й. т.)га нисбатан жиноят ишини кўриб чиқиш
        бўйича суд жараёни ниҳоясига етди ва суд ҳукми эълон қилинди.
      </p>

      <p>
        Ҳукмга кўра, Тўлқин Астанов Жиноят кодекси 244−1-моддаси (жамоат хавфсизлиги ва жамоат
        тартибига таҳдид соладиган материалларни тайёрлаш, сақлаш, тарқатиш ёки намойиш этиш)
        3-қисми «г» бандида назарда тутилган жиноятни содир этганликда айбдор деб топилди. Унга
        Жиноят кодексининг 244−1-моддаси 3-қисми «г» банди билан 5 йил муддатга озодликдан маҳрум
        қилиш жазоси тайинланиб, Жиноят кодексининг 72-моддаси (шартли ҳукм қилиш) тартибида,
        тайинланган 5 йил муддатга озодликдан маҳрум қилиш жазоси шартли деб ҳисобланиб, 2 йил синов
        муддати белгиланди. Синов муддати ҳукм чиқарилган кундан бошлаб ҳисобланиши кўрсатилди.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/EVqntkyKDGs?si=boVL4yQULaXVnnln"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Рустам Карим ва Тўлқин Астанов 2019 йилнинг 8 апрелида Ўзбекистон Мусулмонлар идорасида
        безорилик қилганликда гумонланиб қўлга олинган эди. Тошкент ИИББ бу икки шахснинг Facebook
        ижтимоий тармоғида диний идора раиси «шаънига путур етказувчи постлар қолдирган"ини ҳам
        маълум қилган.
      </p>

      <p>
        Рустам Карим&#xa0; - Ўзбекистон президенти ҳақидаги танқидий чиқишлари билан танилган. У
        2019 йилда диний айбловлар билан 3 йилу 1 ойга қамалган. Қамоқдан чиқиши билан Ўзбекистонни
        тарк этишга қарор қилган Рустам Каримга кўра, у Россия паспорти билан Мексика орқали АҚШга
        келиб, сиёсий бошпана сўраган.
      </p>
    </div>
  ),
  17: (
    <div>
      <p>
        Жиноят ишлари бўйича Қашқадарё вилоят судининг 2021 йил&#xa0; 3 ноябрдаги ҳукми билан
        Effect.uz сайтининг собиқ мухбири, Taftish.uz сайти мухбири бўлган Элёрбек Тожибаев 3 йилга
        қамалган. Журналист ва унинг бир неча ҳамкасби туҳмат, ҳақорат қилиш, ҳокимият вакили ёки
        фуқаровий бурчини бажараётган шахсга қаршилик кўрсатиш ҳамда тергов қилишга ёки суд ишларини
        ҳал этишга аралашишда айбланиб, судланишган.
      </p>

      <p>
        2021 йилнинг январь ойида Effect.uz нашри жиноят ишлари бўйича Термиз туман суди биносидан
        Э. Тожибаев, А. Нуримбетов ва Ҳ. Аҳмедов иштирокидаги иккита видеони эълон қилган эди.
        Журналистлар суд раиси Одил Бегимқулов билан зиддиятга киришган. Судда катта миқдордаги
        фирибгарликда айбланган Икром Худояровга нисбатан ҳукм чиқарилиши кутилаётганди.
      </p>

      <p>
        Судья журналистларни ўзининг рухсатисиз кабинетга киришга ҳақлари йўқлиги ҳақида
        огоҳлантирган.
      </p>

      <p>
        Э. Тожибоев иддаосича, Effect.uz журналистлари "Термиз туман суди раиси қабулига киришга
        урингани учунгина" жиноят иши фигурантларига айланишган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/VaJHuLHsDck?si=nFSkJO3Lo0CH9bzH"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        2021 йил 2 июнь куни YouTube порталига жойлаштирилган видеомурожаатида у Ўзбекистондаги
        журналист ва блогерларни касбий фаолиятларига таҳдидлардан огоҳлантирган.
      </p>

      <p>
        "Ҳаммангизни огоҳликка чақириб қоламан. Шунақанги ҳолатлар сизнинг ҳам бошингизга тушмасин.
        Сўз эркинлиги Ўзбекистонда ўлди. Ўлди. Ҳурматли танқидчи ва мустақил журналист, блогерлар",
        деган эди фарғоналик журналист ўз видеомурожаатида.
      </p>
    </div>
  ),
  18: (
    <div>
      <p>
        2022 йил 3 февраль куни жиноят ишлари бўйича Хоразм вилояти Ҳазорасп тумани суди томонидан
        блогер Собиржон Бобониёзов 3 йилга озодликдан маҳрум қилинди.
      </p>

      <p>
        Блогер марҳум президент Ислом Каримов ҳамда амалдаги президент Шавкат Мирзиёевни ҳақорат
        қилишда айбдор деб топилган.
      </p>

      <p>
        Жиноят иши материалларига кўра, "31 яшар блогер Telegram ижтимоий тармоғидаги “Блогерлар
        бирлашмаси” номли гуруҳга аъзо бўлиб, мазкур гуруҳда Ўзбекистон Республикасининг собиқ
        президенти Ислом Каримов ҳамда амалдаги президент Шавкат Мирзиёевни ҳақоратловчи ва
        фаолиятини обрўсизлантирувчи мазмунда тўғридан-тўғри видеоматериаллар эълон қилган".
      </p>

      <p>
        Айблов хулосасида блогер мазкур жиноятларни "оғирлаштирувчи, яъни маст ҳолатда такроран
        содир этгани" қайд этилади.
      </p>

      <p>
        2021 йил мартида қабул қилинган “Ўзбекистон Республикасининг айрим қонун ҳужжатларига
        ўзгартиш ва қўшимчалар киритиш тўғрисида”ги қонунга мувофиқ президентини телекоммуникация
        тармоқлари ёки Интернетда ҳақоратлаш ёки унга туҳмат қилиш 3 йилгача ахлоқ тузатиш ишлари
        ёки 2 йилдан 5 йилгача озодликни чеклаш ёхуд 5 йилгача озодликдан маҳрум қилиш билан
        жазоланади.
      </p>

      <p>
        Халқаро матбуот ташкилотлари Ўзбекистон жиноят кодексига киритилган ўзгартиришлар сўз ва
        матбуот эркинлигини чеклашини айтишган.
      </p>
    </div>
  ),
  19: (
    <div>
      <p>
        Жиноят ишлари бўйича Қашқадарё вилоят суди 2021 йил 3 ноябрь куни Effect.uz сайти мухбири
        Акбар Нуримбетовга нисбатан 3 йил озодликни чеклаш жазосини тайинлади.
      </p>

      <p>
        Журналист бир неча ҳамкасби билан туҳмат, ҳақорат қилиш, ҳокимият вакили ёки фуқаровий
        бурчини бажараётган шахсга қаршилик кўрсатиш ҳамда тергов қилишга ёки суд ишларини ҳал
        этишга аралашишда айбланиб, судланишган.
      </p>

      <p>
        2021 йилнинг январь ойида Effect.uz нашри жиноят ишлари бўйича Термиз туман суди биносидан
        журналистлар Э. Тожибаев, А. Нуримбетов ва Ҳ. Аҳмедов иштирокидаги иккита видеони эълон
        қилган. Журналистлар суд раиси Одил Бегимқулов билан зиддиятга киришган. Судда катта
        миқдордаги фирибгарликда айбланган Икром Худояровга нисбатан ҳукм чиқарилиши кутилаётганди.
      </p>

      <p>
        Судья журналистларни ўзининг рухсатисиз кабинетга киришга ҳақлари йўқлиги ҳақида
        огоҳлантирган.
      </p>

      <p>
        Ҳодиса ортидан Судьялар кенгаши баёнот чиқариб, Effeсt.uz мухбирларини “журналист одобига
        зид хатти-ҳаракат қилиш, суд мустақиллиги ва судья дахлсизлигига очиқдан-очиқ тажовуз ва
        ҳурматсизлик”да айблаганди.
      </p>

      <p>
        Effect.uz журналистлари "Термиз туман суди раиси қабулига киришга урингани учунгина" жиноят
        иши фигурантларига айлангани хабар қилинган.
      </p>
    </div>
  ),
  20: (
    <div>
      <p>
        Блогер Миразиз Бозоров ижтимоий тармоқларда Ўзбекистон ҳукуматини коррупцияда айблаб, кескин
        танқид қилган ва ЛГБТ ҳуқуқларини ҳимоя қилиш, хусусан, Жиноят кодексидан “Бесоқолбозлик”
        моддасини чиқариб ташлашга чақиргани билан танилган.
      </p>

      <p>
        Жиноят ишлари бўйича Миробод тумани суди 2022 йил январь ойида блогер Миразиз Бозоровга 3
        йил озодликни чеклаш жазоси тайинлади. Суд ҳукмига кўра, Бозоров Жиноят кодексининг
        139-моддаси 3-қисми г-банди билан "ғаразгўйлик ёки бошқа паст ниятларда туҳмат" қилишда
        айбдор, деб топилди.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/8lr56-UzzOA?si=64kxrEZMKtC-FtHL"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Бозоров маҳкамадаги сўнгги сўзида ўзига қарши айбловлар ортида Давлат хавфсизлик хизмати
        (ДХХ) турганини иддао қилган.
      </p>

      <p>
        Адвокати Сергей Майоров блогер Бозоров устидан кечган маҳкамани адолатсиз деб атаб, ҳукмни
        бекор қилишга чақирган.
      </p>

      <p>
        Блогер устидан суд 2022 йил 20-21 январь кунлари бўлиб ўтди. Ҳар икки мажлис очиқ, деб эълон
        қилинганига қарамай, унга журналистлар қўйилмади.
      </p>

      <p>
        Фаоллар Миразиз Бозоровга жиноят иши очилишининг асл сабаби унинг ҳукуматни танқид қилувчи
        чиқишлари эканини айтишади.
      </p>

      <p>Миразиз Бозоров устидан тергов қарийб 10 ой давом этди.</p>

      <p>
        Жиноят иши 2021 йил 28 апрелда очилган. Блогернинг ўзи 29 апрелда уй қамоғига ташланган,
        судга ҳам уй қамоғидан олиб келинган.
      </p>

      <p>
        Тергов жараёнида блогер аввал жабрланувчи бўлди, кейин гумонланувчига айланди ва жиноятчи
        ўлароқ судга келтирилди.
      </p>

      <p>
        2021 йилнинг 28 март оқшомида бир гуруҳ номаълум шахс блогерни ўз уйи олдида калтаклаб
        кетганди. Қора ниқобли одамлар томонидан дўппосланган блогер Миразиз Бозоров оғир тан
        жароҳати билан касалхонага ётқизилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/I9QCnV6hGVc?si=vKU90z9VdYAvxg8M"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        У ўзининг “Канал Базарова” Телеграм-каналида, президент Мирзиёев бошқаруви остида коррупция
        кучайгани, янги бошланган сиёсий-иқтисодий ислоҳотларни халқ учун “катта йўқотиш” деб
        билиши, пандемия пайтида ҳукумат “халқ пулини ўғирлади” деган хулосалари акс этган
        видеопостларни бот-бот эълон қилган.
      </p>

      <p>2021 йил 24 октябрда бўлган президентлик сайловини “бойкот қилишга” ҳам чақирган.</p>

      <p>
        The Diplomat нашри бош муҳаррири Кэтрин Путц маҳкама ортидан чоп этган мақоласида&#xa0;
        Ўзбекистон ҳукумати прогрессив блогерларга ҳам, консерватив блогерларга ҳам тоқат қилмаслиги
        ҳақида ёзган. Мақола муаллифига кўра, блогерлар Миразиз Бозоров ва Фозилхўжа Орифхўжаев иши
        Ўзбекистонда сўз эркинлиги чеклангани ҳамда сўз ва ифода эркинлиги устидан давлат назорати
        сақланиб қолаётганини кўрсатади.
      </p>
    </div>
  ),
  21: (
    <div>
      <p>
        Жиноят ишлари бўйича Қашқадарё вилоят суди 2021 йил 3 ноябрь куни Effect.uz сайти мухбири
        Ҳамиджон Аҳмедовга 2 йилу 6 ой озодликни чеклаш жазосини тайинлаган.
      </p>

      <p>
        Журналист бир неча ҳамкасби билан туҳмат, ҳақорат қилиш, ҳокимият вакили ёки фуқаровий
        бурчини бажараётган шахсга қаршилик кўрсатиш ҳамда тергов қилишга ёки суд ишларини ҳал
        этишга аралашишда айбланиб, судланишган.
      </p>

      <p>
        2021 йилнинг январь ойида Effect.uz нашри жиноят ишлари бўйича Термиз туман суди биносидан
        журналистлар Э. Тожибаев, А. Нуримбетов ва Ҳ. Аҳмедов иштирокидаги иккита видеони эълон
        қилган эди. Журналистлар суд раиси Одил Бегимқулов билан зиддиятга киришган. Судда катта
        миқдордаги фирибгарликда айбланган Икром Худояровга нисбатан ҳукм чиқарилиши кутилаётганди.
      </p>

      <p>
        Судья журналистларни ўзининг рухсатисиз кабинетга киришга ҳақлари йўқлиги ҳақида
        огоҳлантирган.
      </p>

      <p>
        Ҳодиса ортидан Судьялар кенгаши баёнот чиқариб, Effeсt.uz мухбирларини “журналист одобига
        зид хатти-ҳаракат қилиш, суд мустақиллиги ва судья дахлсизлигига очиқдан-очиқ тажовуз ва
        ҳурматсизлик”да айблаганди.
      </p>

      <p>
        Effect.uz журналистлари "Термиз туман суди раиси қабулига киришга урингани учунгина" жиноят
        иши фигурантларига айланганини маълум қилинган.
      </p>
    </div>
  ),
  22: (
    <div>
      <p>
        Блогер Ҳумоюн Умрзоқов ижтимоий тармоқларда Чироқчи тумани ички ишлар органи ходимлари ва
        ҳокимиятни танқид қилувчи чиқишлари билан танилган.
      </p>

      <p>
        2021 йил сентябрь ойида Қашқадарё вилоятининг Чироқчи туманида яшовчи блогер Ҳумоюн Умрзоқов
        ички ишлар органларига ёлғон хабар беришда айбланиб қамоққа олинган.
      </p>

      <p>
        ИИБга кўра, блогер 2021 йил 1 сентябрга ўтар кечаси таниши Х.Б. билан ўзаро тил бириктирган
        ҳолда, ўзи фойдаланиб келган “ВАЗ-2106” русумли автомашинаси Дам қишлоғидан ўғирлангани
        тўғрисида маълум қилган.
      </p>

      <p>
        “Аслида эса ўзи машинани шу қишлоқда яшовчи танишининг уйи орқа томонига олиб бориб, очиқ
        ҳолда қолдирган”, дейилади расмий хабарда.
      </p>

      <p>
        Терговга қадар текширувда блогернинг бу ҳаракати ошкор бўлган ва унга нисбатан Жиноят
        кодексининг 237-моддаси 2-қисми “а”,”б” бандлари (айбловнинг сунъий далилларини вужудга
        келтирган ҳолда, ғаразгўйлик ниятида ёлғон ахборот бериш) асосида жиноят иши қўзғатилди.
        Блогер ва унинг шериги ушланиб, эҳтиёт чораси сифатида қамоққа олинган.
      </p>

      <p>
        Маҳкама томонидан бир йиллик қамоқ жазосига ҳукм этилган Ҳумоюн Умрзоқов 2022 йил 17 апрель
        куни муддатидан олдин озодликка чиқарилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/p3seqVHp9w8?si=RsHGDP2KC_KgSDq7"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>Ҳумоюн Умрзоқов ўзига белгиланган бир йиллик қамоқ жазосини “оғир жазо” деб атаган.</p>

      <p>
        <i>
          ”Ичкарида бўлган вақтда мен кўп кузатдим. Оғирроқ жиноят қилганлар уй қамоғи ва шартли
          озодликка чиқиб кетганликларини кўрдим. Манзил колониясига олинганликларини кўрдим. Менга
          оғирроқ жазо беришди, қилган ишим учун”, д
        </i>
        еган у Озодлик билан суҳбатда.
      </p>
    </div>
  ),
  23: (
    <div>
      <p>
        Валижон Калонов Мирзиёев ҳокимиятга келганидан сўнг "президентни ҳақоратлагани" учун
        қамалган биринчи блогер бўлган.
      </p>

      <p>
        Жиззахлик фаол Валижон Калонов Жиззах шаҳар судининг 2021 йил 23 декабрдаги қарори билан
        президентни ҳақоратлаш ва "бошқа ижтимоий хавфли жиноятларни содир этганлик"да айбдор деб
        топилиб, қамоқ жазосига ҳукм қилинган. Озодликка Калоновга берилган қамоқ муддати маълум
        эмас.
      </p>

      <p>
        Жиззах вилоят прокуратураси 2021 йил 19 апрелда эълон қилган баёнотида 1969 йили Бахмал
        туманида туғилган фуқаро В.К. ижтимоий тармоқларда Ўзбекистон Президентини ҳақоратлайдиган,
        унинг обрўсига путур етказадиган ва камситадиган маълумотларни тарқатиб, туҳмат қилиб
        келаётганлиги ҳолати аниқланганини хабар қилди.
      </p>

      <p>
        Валижон Калонов жазо муддатини ўташ даврида Ўзбекистон Республикаси ЖПКнинг 93-моддасига
        асосан, жазони ўташ психиатрия шифохонасида мажбурий даволанишга ўзгартирилган.
      </p>

      <p>
        Жиззах вилояти Шароф Рашидов туман суди 2023 йил 7 ноябрь куни Валижон Калоновни руҳий
        касалликлар шифохонасида мажбурий даволаш муддатини яна уч ойга узайтирган.
      </p>

      <p>
        Озодликда нусхаси мавжуд ажримда айтилишича, "текширувлар даврида бемор Калоновнинг руҳий
        ҳолати яхшиланмагани, ўзининг кейинги тақдири борасида режалари мавжуд эмаслиги, ўзини
        тутиши тартибланмагани, ўзининг қилмишларига нисбатан пушаймон эмаслиги аниқланган".
      </p>

      <p>
        Валижон Калоновнинг исми сир қолиш шарти билан Озодликка гапирган қариндошлари унинг мутлақо
        соғломлиги, ҳафтада камида бир марта кўришиб туришгани, у ўзига "асабни бўшаштирувчи
        препаратларни мажбуран беришга уринишаётгани"ни айтган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/TCczxK-G7gc?si=21uaSrT9Jw-VY7M5"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Мирзиёевнинг Хитой сиёсатини танқид қилувчи баёнотлари билан танилган Валижон Калонов
        қамалишидан аввал Озодлик билан суҳбатда Президентга ҳақорат ва туҳмат айблари унинг
        2019-2020-йилларда YouTube даги чиқишлари билан боғлиқ бўлиши мумкинлигини айтган эди.
      </p>

      <p>
        &#xa0;“2019 йили Ўзбекистон президенти Хитойга бориб келиб, Хитой бизнинг сиёсатимизга
        аралашмайди, биз ҳам Хитойнинг сиёсатига аралашмаймиз, деганидан кейин мен бу гапга қарши
        турдим. Чунки ўзбек халқи уйғурнинг эгизагидир”, деган жиззахлик фаол.
      </p>

      <p>
        Калонов 2020 йил кузида президент Мирзиёевга YouTube орқали мурожаат қилиб, "президентга
        қилаётган ишларингизни кўрдик. Ўзингизга 10 миллион доллар олиб, бола-чақаларингизга,
        атрофдагиларингизга 1 миллион доллардан бериб, халқдан кечирим сўраб, ҳаммаларинг
        кетингизлар Ўзбекистондан", деган эди.
      </p>

      <p>
        Жиноят кодексининг Валижон Калонов айбланаётган 158-моддаси, 3- қисми 2021 йилнинг 30
        мартида кучга кирган. Унга биноан Ўзбекистон Республикаси Президентини омма олдида
        ҳақоратлаш ёки унга туҳмат қилиш, шунингдек, матбуот ёки бошқа оммавий ахборот
        воситаларидан, телекоммуникация тармоқларидан ёки Интернет бутунжаҳон ахборот тармоғидан
        фойдаланган ҳолда уни ҳақоратлаш ёки унга туҳмат қилиш уч йилгача ахлоқ тузатиш ишлари ёки
        икки йилдан беш йилгача озодликни чеклаш ёхуд беш йилгача озодликдан маҳрум қилиш билан
        жазоланади.
      </p>

      <p>
        Мустақил журналист ва медиаэксперт, Чегарасиз мухбирлар халқаро ташкилотининг собиқ вакили
        Йоханн Бир Озодлик билан суҳбатда Европа давлатларининг кўпчилиги президентни ҳақорат қилиш
        учун жавобгарликни қонунчиликдан чиқариб ташлаётганини айтади:
      </p>

      <p>
        “Европанинг кўплаб давлатларида президентни ҳақорат қилганлик учун жавобгарликни бекор
        қилишди. Чунки инсон ҳуқуқлари бўйича Европа суди давлат раҳбарига оддий одамдан кўра кўпроқ
        ҳимоя зарур эмаслигини бир неча бор эътироф қилди ва аксинча, президент жамоат вакили
        сифатида оддий одамлардан кўра кўпроқ танқидларга бардош бериши лозимлиги таъкидланди”.
      </p>
    </div>
  ),
  24: (
    <div>
      <p>
        Президент Шавкат Мирзиёев ҳамда унинг оиласини непотизм ҳамда коррупцияда айблаган
        тошкентлик 60 яшар блогер Шоҳида Саломова 2022 йилнинг 18 декабрь куни аввалига ғойиб
        бўлган, сўнгра ҳибсга олинган.
      </p>
      <p>
        “Шахиня Королева” тахаллуси остида фаолият олиб борган блогер{' '}
        <a href="https://www.youtube.com/watch?v=JmcfEpzci9o">YouTube</a>, Фейсбук ва Телеграмдаги
        саҳифаларидаги чиқишларида Ўзбекистон Адлия вазирлиги, прокуратура, суд, вилоят ва айниқса
        Тошкент шаҳар ҳокимлиги мулозимларини ҳам танқид қилиб келган.
      </p>
      <p>
        Саломованинг танқиди нишонига айланганлар орасида Шавкат Мирзиёевнинг кенжа куёви Отабек
        Умаров ҳам бор. Шоҳида Саломова Отабек Умаровни "пойтахтнинг Мирзо Улуғбек туманидаги
        ҳовлиси яқинида 20 тача ер участкаларини сотиб олиб, катта ҳовли қураётганлик"да{' '}
        <a href="https://www.youtube.com/watch?v=6l7n8TmN__Q&amp;t=8s">айблаган.</a>
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/6l7n8TmN__Q?si=iEGgHh9iJEUHXy41"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Шоҳида Саломова Телеграмдаги “Патанатомия страни Уз” канали маъмури сифатида ҳам фаолият
        юритган. Блогер ҳибсга олингач, дастлаб ушбу канал ўчириб ташланган. 21 декабр куни эса бу
        канал қайта ишга туширилиб, унда Шоҳида Саломованинг ўзига қарши камситувчи ва бошқа
        материаллар жойлаштирилган. Ҳозирда ушбу канал ишламаяпти.
      </p>
      <p>
        Саломованинг ишини кузатган жамоатчилик ва ҳуқуқ фаоллари унинг ҳибсга олинишини “биринчи
        оила” ҳақидаги танқидий постлари билан боғлашган.
      </p>

      <p>
        Жумладан, Франциядаги Марказий Осиёда инсон ҳуқуқлари ташкилоти раҳбари Надежда Атаева ҳам
        Саломованинг ҳибсга олинишини касбий фалияти билан боғлаган.
      </p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/j-35LJq1DrA?si=skDTYueUukknHEUD"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        Ўзбекистон ИИББ Тергов бошқармаси Саломова иши юзасидан{' '}
        <a href="https://iibb.uz/uz/news/tumat-ilish">расмий изоҳ берган.</a> Унга кўра, "1970 йилда
        туғилган А. Г. ариза билан мурожаат қилиб, ижтимоий тармоқларда унга туҳмат қилиб, ҳақорат
        қилган ижтимоий тармоқ фаоли фуқаро 1962 йилда туғилган Шоҳида Саломовага нисбатан қонуний
        чора кўришни сўраган."
      </p>

      <p>
        Айни пайтда, Шоҳида Саломова шу йилнинг баҳорида бошқа бир таниқли блогер ва жамоатчилик
        фаоли Алексей Гаршинга қарши кўрсатма берган эди.
      </p>

      <p>
        Тошкент вилоятида жойлашган “Шоввозсой” тоғлари ҳудудидаги президент Мирзиёевнинг ҳашаматли
        қароргоҳини фош қилган Гаршин шу йилнинг 21 октябрида Ўзбекистон Жиноят Кодексининг
        140-моддаси 2-қисми асосида Юнусобод туман суди қарори билан Шоҳида Саломовани “ҳақорат
        қилганлик”да айбдор деб топилиб, катта миқдорда - 108 млн сўмлик жаримага маҳкум этилган.
        Бироқ, Алексей Гаршин суд қарорини 2022 йилнинг 19 декабрида қўлига олганини айтган.
      </p>

      <p>
        “Саломовага “менинг аризам юзасидан жиноят иши очилгани”ни билдиришди. Мен Шоҳида Саломовани
        ҳақорат қилмаганман ва у менга мутлақо қизиқ эмас. Уни қаматиш ёки жаримага тортиш ҳам керак
        эмас. Терговчи мени ҳибсга олиш билан қўрқитди, қанақадир ҳужжатларни имзолашимни буюрди.
        Мен рад жавобини бердим. Тушунишимча, улар менинг қўлим билан ўзларининг қинғир ишларини
        амалга оширмоқчи”, деган ўша пайтда Гаршин.
      </p>

      <p>
        Кейинчалик жиноят иши доирасида Шоҳида Саломованинг руҳий ҳолатини текшириш важи билан унга
        нисбатан суд-психиатрик экспертиза тайинланган. Суд ажримига асосан Шоҳида Саломова тиббий
        муассасага жойлаштирилган.
      </p>
    </div>
  ),
  25: (
    <div>
      <p>
        Асли инглиз тили ўқитувчиси бўлган Нафосат (Шабнам) Оллошукурова 2018 йилда блогерлар сафига
        қўшилган. Асосан, Фейсбук тармоғи орқали жонли чиқишлар қилиб, асосий эътиборни
        ҳуқуқ-тартибот идораларидан азият чеккан шахсларга қаратган. Яна у Тошкентда расмий идоралар
        олдида бўладиган норозилик пикетларини тармоқлар орқали жонли ёритадиган блогер сифатида
        танилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/La6iXO3_ZyA?si=2Td-XesFs2jR2zRI"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Н.Оллошукурова 2019 йили шоир ва журналист Маҳмуд Ражабнинг “Тошкентга юриши”ни ëритгани
        ортидан 10 кунлик қамоққа ҳукм қилинган. Блогер Маъмурий жавобгарлик кодексининг учта
        моддаси бўйича айбдор деб топилган (183-модда, "майда безорилик"; 192-модда, "маиший
        шовқинга қарши кураш талабларини бузиш"; 202-модда, "рухсат этилмаган йиғилишлар¸ митинглар¸
        кўча юришлари ва намойишлар ўтказиш учун шароитлар яратиш").
      </p>

      <p>
        Нафосат Оллошукурова қамоққа ташланганидан 3 кун ўтиб, Урганч туманида жойлашган Хоразм
        вилоят асаб-руҳий касалликлар диспансерига ëтқизилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/ttlBZoqoYTk?si=8VD49AniMC2Jm0R_"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Нафосат Оллошукурова 10 кунлик қамоқ жазосини ўтаётган пайти суд қарорига норозилик сифатида
        очлик эълон қилган.
      </p>

      <p>
        БМТ Олий комиссари, Европа Иттифоқи, ЕХҲТ, Amnesty international, Human rights watch,
        Журналистларни ҳимоя қилиш қўмитаси каби халқаро ташкилотлар Нафосат Оллошукуровани озод
        қилишни Ўзбекистон ҳукуматидан талаб қилган.
      </p>

      <p>
        Халқаро ташкилотлар ва жамоатчилик босими остида руҳий шифохонада уч ой ушлаб турилган
        блогер Оллошукурова 2019 йил 28 декабрь куни касалхонадан чиқарилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/5Fka52IeRig?si=1DCmFuqAQGJSax9X"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Блогер 2020 йил 18 январь куни Ўзбекистондан чиқиб кетган. Озодлик билан суҳбатлашган
        Оллошукурова тергов пайти уни калтаклашгани, руҳий касалхонага қайта ташлашларидан қўрқиб
        ватанни тарк этганини айтган эди.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/AHGJE17hWdg?si=ZqBoATOc9cvtEh2a"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>Бир муддат хорижда яшаган Оллошукурова кейинчалик Ўзбекистонга қайтган.</p>
    </div>
  ),
  26: (
    <div>
      <p>
        Ўзининг қамалишини блогерлик фаолияти билан боғлаган самарқандлик Ўткирбек Чоршанбиев 2022
        йил 10 мартида ҳибсга олинган.
      </p>

      <p>
        Суд Чоршанбиевни Жиноят кодексининг 168-моддаси (фирибгарлик) бўйича айбдор деб топиб, унга
        5 йиллик қамоқ жазоси тайинлаган.
      </p>
      <p>
        Чоршанбиев тергов ҳибсхонасида 7 ой, қамоқхонада 11 ой ўтиргач, манзил колонияга чиқарилган.
        Уч ойдан сўнг эса - 2023 йил 15 ноябрида озодликка чиқарилган.
      </p>

      <p>
        Ҳибсга олинишидан роппа роса бир йил аввал Озодлик билан суҳбатда&#xa0; блогер Ўткир
        Чоршанбиев журналист ва блогерларга муносабат ёмонлашаётгани ҳақида гапирган эди:
      </p>

      <p>
        “Шахсан мен аҳолидан тушган шикоятларни ўрганиш жараёнида, Самарқанд ва Қашқадарё
        ҳокимликларида шундай қўпол, ноқонуний муносабатга учрадим. Президентимиз, яқинда ҳам
        журналист ва блогерлар билан учрашувда айтдилар: “Қўрқмай ёзинглар, орқангизда мен борман”,
        деб. Лекин, жойларда раҳбарлар бунинг тескарисини қиляпти. Шу боис, мен президентимиздан бу
        вазият бўйича назоратни ўз қўлларига олишини сўраган бўлардим”.
      </p>
    </div>
  ),
  27: (
    <div>
      <p>
        Қорақалпоғистонда “Робин Гуд” номи билан танилган Даулетмурат Тажимуратов адвокат ҳамда «Эл
        хызметинде» газетаси муҳаррири cифатида фаолият юритган.
      </p>

      <p>
        1979 йилда туғилган Тажимуратов 2022 йил 1−2 июль кунлари Нукус шаҳрида юз берган воқеалар
        ортидан асосий айбланувчи сифатида қамоққа олинган. Тергов идораси уни “уюшган гуруҳ ташкил
        килиб, Қорақалпоғистон Республикасининг амалдаги ҳукуматини ағдариб, ўзини Жўқорғи Кенгес
        раиси лавозимига тайинлаш мақсадида 1−2 июль кунлари оммавий тартибсизликларни
        ташкиллаштириш”да айблаган.
      </p>

      <p>
        Тажимуратовга нисбатан ҳукм Нукус воқеалари бўйича Бухорода 2023 йилнинг 31 январида
        якунланган судда ўқилган эди. У 16 йилга озодликдан маҳрум қилинган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/aFdDoCn_OI4?si=88SwTHXFmkKKQUI0"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2023 йил июнь ойида Тажимуратовнинг суд ҳукми юзасидан шикоятини апелляция тартибида кўриб
        чиққан Олий суд 16 йиллик қамоқ жазосини ўзгаришсиз қолдирган.
      </p>

      <p>
        Тажимуратовнинг адвокати Сергей Майоров ўз ҳимояси остидаги шахс юзасидан Олий суд чиқарган
        қарорни “Газета.uz”га изоҳлар экан: “Мен [Олий суднинг ушбу қарорини] нафақат адолатсиз,
        балки биринчи навбатда ноқонуний деб ҳисоблайман”, деб айтган.
      </p>

      <p>
        2023 йил сентябрь ойида Human Rights Watch Тошкентдан Нукус воқеалари бўйича асосий
        айбланувчи сифатида 16 йилга қамалган Даулетмурат Тажимуратовнинг хавфсизлигини таъминлашни
        сўраган.
      </p>
      <p>
        “Эзгулик” жамияти раҳбари Абдураҳмон Ташанов 2024 йилнинг 13 январь куни Навоийдаги 5-сонли
        колонияда жазо ўтаётган Тажимуратов билан учрашган. Ташановнинг сўзларига кўра, Тажимуратов
        тергов жараёнида ўзига нисбатан жисмоний қийноқлар қўллангани ҳақида гапирган.&#xa0;
      </p>

      <p>
        2024 йил апрель ойида АҚШ Давлат департаментининг йиллик ҳисоботида Даулетмурат Тажимуратов
        номи сиёсий маҳбуслар қаторида тилга олинган.
      </p>

      <img src="https://gdb.rferl.org/01000000-0aff-0242-332d-08db66389dc8_w1023_r1_s.jpg" />

      <p>
        “Нукус воқеалари” деб ном олган норозилик чиқишлари 2022 йилнинг июль ойи бошида Ўзбекистон
        конституциясининг янги таҳририда Қорақалпоғистон республикаси суверен мақомининг бекор
        қилинишига қарши бошланиб кетган эди. 1 ва 2 июль кунлари кузатилган норозиликлар чоғида,
        расмийларга кўра, 21 киши ҳалок бўлган, ҳуқуқ-тартибот идоралари ходимлари дохил 243 киши
        яраланган.
      </p>

      <p>
        Намойишлар куч билан бостирилган, бироқ ўзбек расмийлари ҳарбийларнинг намойишчиларга қарата
        ўқ узганини рад этган, Миллий гвардия, ИИВ ҳамда Мудофаа вазирлиги намойишларни бостириш
        чоғида қўлланган махсус воситаларни намойиш қилган.
      </p>

      <p>
        АҚШ, Европа Иттифоқи, БМТ ва халқаро инсон ҳуқуқлари ташкилотлари ҳам ўзбек расмийларини
        Қорақалпоғистондаги воқеалар юзасидан очиқ, ҳар томонлама ва шаффоф тергов ўтказишга, тинч
        намойишчиларга қарши ҳаддан зиёд куч қўлланилганига оид иддаоларни текширишга чақирган.
      </p>

      <p>
        2023 йил 18 май куни қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси
        (CPJ) Ўзбекистон расмийларини Нукус воқеалари бўйича судланган қорақалпоғистонлик
        журналистларга нисбатан чиқарилган айблов ҳукмларини бекор қилишга чақирган.
      </p>

      <p>
        CPJ ўзбек расмийларига матбуот ходимларини касбий фаолияти учун судламаслик, маҳкама
        жараёнларида журналистлар ва уларнинг оила аъзоларини қўрқитиш ҳаракатларидан тийилишга
        чақирган.
      </p>

      <p>Тажимуратов қорақалпоқ қадриятларининг ашаддий ҳимоячиси сифатида шуҳрат қозонган.</p>

      <p>
        2021 йилда у қорақалпоқларни “ўзбек либосида яшайдиган халқ” деб атагани учун таниқли ўзбек
        хонандаси Юлдуз Усмонова устидан судга шикоят қилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/ihdyPm62mLI?si=rDcV04kuEPNcF9jE"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Тажимуратов, шунингдек, газ ва сув таъминоти муаммосидан қийналаётган
        қорақалпоғистонликларга ўзининг юридик хизматларини бепул ёки рамзий тўлов эвазига таклиф
        қилгани билан танилган. Баъзилар уни “Робин Гуд” деб атаган.
      </p>
    </div>
  ),
  28: (
    <div>
      <p>
        Лолагул Қаллиханова (1989 йилда туғилган) – қорақалпоғистонлик журналист, “Makan.uz” сайти
        таъсисчиси.
      </p>

      <p>
        Қаллиханова 2022 йил 1−2 июль кунлари Нукус шаҳрида юз берган норозиликлар ортидан ҳибсга
        олинган.
      </p>

      <p>
        Тергов идораси уни “уюшган гуруҳга бирлашиб, ижтимоий тармоқлар орқали сепаратизм ғоялари
        билан йўғрилган, аҳолини оммавий тартибсизликка даъват қилувчи материаллар тарқатиш”да
        айблаган.
      </p>

      <p>
        2023 йил 31 январь куни, Бухоро вилояти суди биносида Нукус воқеаларида айбланган 22 нафар
        судланувчи, жумладан, Қаллихановага оид жиноят ишини кўриб чиқиш бўйича суд жараёни тугаб,
        суд ҳукми эълон қилинган.
      </p>

      <p>
        Қаллиханова ЖКнинг 159-моддаси 4-қисми, 244-моддаси 3-қисми ва 244−1-моддаси 3-қисми «а»,
        «б», «г» бандларида назарда тутилган жиноятларни содир этганликда айбдор деб топилган.
        Пировардида унга 3 йил синов муддати белгиланиб, суд залида қамоқдан озод қилинган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/aFdDoCn_OI4?si=5dTKrevWW4XRqLjI"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Ўзбекистонда 2022 йил 26 июнь куни жамоатчилик муҳокамасига қўйилган “Ўзбекистон
        Республикаси Конституциясига ўзгартиш ва қўшимчалар киритиш тўғрисида”ги қонун лойиҳаси
        қорақалпоғистонликлар орасида норозилик уйғотган эди.
      </p>

      <p>
        Ижтимоий тармоқлардаги норозилик чиқишларига асосий қонуннинг янги таҳририда Қорақалпоғистон
        республикасининг “суверенитети” ибораси ҳамда республика халқининг “умумий референдум
        асосида ажралиб чиқиш ҳуқуқи” жумласи олиб ташлангани сабаб бўлган.
      </p>

      <p>
        Қорақалпоғистонлик журналист Лолагул Қаллиханова ўша кунлари ижтимоий тармоқларда тарқалган
        видеода Конституциянинг янги таҳририда таклиф этилаётган айни ўзгаришларга қарши эканлигини
        билдирган.
      </p>

      <p>
        “Суверен Қорақалпоғистон Республикаси” сўзлари олиб ташланди, яъни Қорақалпоғистон
        Республикаси фуқароларининг розилигисиз республика суверенитети қонун билан олиб қўйилади”,
        деб ёзган эди Қаллиханова “Makan.uz” сайтида 26 июнь куни эълон қилинган мақоласида.
      </p>

      <p>
        Қаллиханова Ўзбекистон Республикаси Конституциясининг Қорақалпоғистон Республикасига тегишли
        бобига ўзгартиришлар киритишни тўхтатиб, шу бобнинг 70-дан 75-моддаларигача бўлган қисмини
        ўзгаришсиз қолдиришни талаб қилиши ҳақида ёзган.
      </p>

      <p>
        2023 йил 18 май куни қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси
        (CPJ) Ўзбекистон расмийларини Нукус воқеалари бўйича судланган қорақалпоғистонлик
        журналистларга нисбатан чиқарилган айблов ҳукмларини бекор қилишга чақирган.
      </p>

      <p>
        CPJ ўзбек расмийларига матбуот ходимларини касбий фаолияти учун судламаслик, маҳкама
        жараёнларида журналистлар ва уларнинг оила аъзоларини қўрқитиш ҳаракатларидан тийилишга
        чақирган.
      </p>

      <p>
        АҚШ, Европа Иттифоқи, БМТ ва халқаро инсон ҳуқуқлари ташкилотлари ҳам ўзбек расмийларини
        Қорақалпоғистондаги воқеалар юзасидан очиқ, ҳар томонлама ва шаффоф тергов ўтказишга, тинч
        намойишчиларга қарши ҳаддан зиёд куч қўлланилганига оид иддаоларни текширишга чақирган.
      </p>
    </div>
  ),
  29: (
    <div>
      <p>
        "Ayama" веб-сайти маъмури Бахтияр Кадирбергенов – 2022 йил 1−2 июль кунлари Нукус шаҳрида юз
        берган воқеалар ортидан ҳибсга олинган ОАВ ходимларидан бири. У судда асосий айбланувчи
        сифатида кўрилган Даулетмурат Тажимуратов билан YouTube ва Telegram-каналда ҳамкорлик
        қилганликда айбланган.
      </p>

      <p>
        2023 йил 31 январь куни, Бухоро вилояти суди биносида Нукус воқеаларида айбланаётган 22
        нафар судланувчи, жумладан, Бахтияр Кадирбергеновга оид жиноят ишини кўриб чиқиш бўйича суд
        жараёни тугаб, суд ҳукми эълон қилинган. Маҳкама&#xa0; Б.Кадирбергеновни ЖКнинг 244-моддаси
        3-қисми ва 277-моддаси (безорилик) 1-қисмида назарда тутилган жиноятни содир этганликда
        айбдор деб топилиб 7 йилга озодликдан маҳрум этган. Айблов томони Б.Кадирбергеновга 8 йил
        қамоқ жазоси сўраган эди.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/aFdDoCn_OI4?si=Gu_R9q37d-wKzyTN"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Қорақалпоғистонда 2022 йил 1-2 июль кунлари рўй берган воқеалар бўйича биринчи бўлиб очилган
        ишда айбланувчилар 22 нафарни ташкил этди. Улар ЖКнинг 10 га яқин моддаси, жумладан, оммавий
        тартибсизликлар ва конституциявий тузумга тажовузда айбланган.
      </p>

      <p>
        2023 йил 18 май куни қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси
        (CPJ) Ўзбекистон расмийларини Нукус воқеалари бўйича судланган қорақалпоғистонлик
        журналистларга нисбатан чиқарилган айблов ҳукмларини бекор қилишга чақирган.
      </p>

      <p>
        CPJ ўзбек расмийларига матбуот ходимларини касбий фаолияти учун судламаслик, маҳкама
        жараёнларида журналистлар ва уларнинг оила аъзоларини қўрқитиш ҳаракатларидан тийилишга
        чақирган.
      </p>

      <p>
        АҚШ, Европа Иттифоқи, БМТ ва халқаро инсон ҳуқуқлари ташкилотлари ҳам ўзбек расмийларини
        Қорақалпоғистондаги воқеалар юзасидан очиқ, ҳар томонлама ва шаффоф тергов ўтказишга, тинч
        намойишчиларга қарши ҳаддан зиёд куч қўлланилганига оид иддаоларни текширишга чақирган.
      </p>
    </div>
  ),
  30: (
    <div>
      <p>
        Қорақалпоғистоннинг «Ел хызметинде» нашри бош муҳаррири Абдималик Хожаназаров 2022 йил 1−2
        июль кунлари Нукус шаҳрида юз берган воқеалар ортидан ҳибсга олинган ОАВ ходимларидан бири.
      </p>

      <p>
        2023 йил 17 март куни, Бухоро вилоят суди биносида Нукус воқеаларида айбланаётган 39 нафар
        судланувчига оид жиноят ишини кўриб чиқиш бўйича суд жараёни тугаб, суд ҳукми эълон қилинди.
      </p>

      <p>
        Абдумалик Хўжаназаров Жиноят кодексининг 244-моддаси 3-қисми ва 244-1-моддаси 3-қисми “а”,
        “б”, “г” бандларида назарда тутилган жиноятларни содир этганликда айбли деб топилиб, унга 5
        йилдан озодликни чеклаш жазоси тайинланган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/aFdDoCn_OI4?si=WevpbDETitNMev5d"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2023 йил 18 май куни қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси
        (CPJ) Ўзбекистон расмийларини Нукус воқеалари бўйича судланган қорақалпоғистонлик
        журналистларга нисбатан чиқарилган айблов ҳукмларини бекор қилишга чақирган.
      </p>

      <p>
        CPJ ўзбек расмийларига матбуот ходимларини касбий фаолияти учун судламаслик, маҳкама
        жараёнларида журналистлар ва уларнинг оила аъзоларини қўрқитиш ҳаракатларидан тийилишга
        чақирган.
      </p>

      <p>
        АҚШ, Европа Иттифоқи, БМТ ва халқаро инсон ҳуқуқлари ташкилотлари ҳам ўзбек расмийларини
        Қорақалпоғистондаги воқеалар юзасидан очиқ, ҳар томонлама ва шаффоф тергов ўтказишга, тинч
        намойишчиларга қарши ҳаддан зиёд куч қўлланилганига оид иддаоларни текширишга чақирган.
      </p>
    </div>
  ),
  31: (
    <div>
      <p>
        “Ишонч” газетаси мухбири ва Ўзбекистон миллий ахборот агентлигининг собиқ журналист Есимкан
        Канаатов 2022 йил 1−2 июль кунлари Нукус воқеаларида қатнашишда айбланиб маҳкамага
        тортилган.
      </p>

      <p>
        2023 йил 17 март куни, Бухоро вилоят суди биносида 39 нафар судланувчига оид жиноят ишини
        кўриб чиқиш бўйича суд жараёни якунланиб, суд ҳукми эълон қилинди. Жумладан, Есимқан
        Қанаатов Жиноят кодексининг 244-моддаси 3-қисми ва 244−1-моддаси 3-қисми «а», «б», «г»
        бандларида назарда тутилган жиноятларни содир этганликда айбли деб топилиб, уларнинг ҳар
        бирига Жиноят кодексининг 57-моддаси қўлланилиб, 59-моддаси тартибида 5 йилга озодликни
        чеклаш жазоси тайинланди.
      </p>

      <p>
        1974 йилда туғилган журналист айирмачилик ғояларига асосланган мақолалар чоп этиш ва оммавий
        тартибсизликлар уюштиришда айбланган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/aFdDoCn_OI4?si=WevpbDETitNMev5d"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2023 йил 18 май куни қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси
        (CPJ) Ўзбекистон расмийларини Нукус воқеалари бўйича судланган қорақалпоғистонлик
        журналистларга нисбатан чиқарилган айблов ҳукмларини бекор қилишга чақирган.
      </p>

      <p>
        CPJ ўзбек расмийларига матбуот ходимларини касбий фаолияти учун судламаслик, маҳкама
        жараёнларида журналистлар ва уларнинг оила аъзоларини қўрқитиш ҳаракатларидан тийилишга
        чақирган.
      </p>

      <p>
        АҚШ, Европа Иттифоқи, БМТ ва халқаро инсон ҳуқуқлари ташкилотлари ҳам ўзбек расмийларини
        Қорақалпоғистондаги воқеалар юзасидан очиқ, ҳар томонлама ва шаффоф тергов ўтказишга, тинч
        намойишчиларга қарши ҳаддан зиёд куч қўлланилганига оид иддаоларни текширишга чақирган.
      </p>
    </div>
  ),
  32: (
    <div>
      <p>
        Азамат Нуратдинов – 1989 йилда туғилган, Мўйноқ туманидаги 9-мактаб ўқитувчиси, блогер. 2022
        йил 1−2 июль кунлари Нукус воқеаларида қатнашишда айбланиб маҳкамага тортилган.
      </p>

      <p>
        Тергов идораси уни 244-моддаси 3-қисми ва 244−1-моддаси 3-қисми «а» бандида назарда тутилган
        жиноятларни содир этиш, жумладан, Қонликўл туманида одамларни оммавий тартибсизликларга
        даъват қилувчи материалларни тарқатиб, оммавий тартибсизликларда етакчилик қилишда айблаган.
        Давлат айбловчиси унга нисбатан 7 йилга озодликдан маҳрум қилиш жазосини қўллашни сўраган.
      </p>

      <p>
        Бухоро вилоят судида 2023 йил 31 январь куни якунланган суд жараёнида 22 нафар судланувчидан
        бири Азамат Нуратдиновга нисбатан озодликни чеклаш тарзидаги шартли жазо қўлланилган ва у
        суд залидан озод қилинган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/aFdDoCn_OI4?si=WevpbDETitNMev5d"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2023 йил 18 май куни қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси
        (CPJ) Ўзбекистон расмийларини Нукус воқеалари бўйича судланган қорақалпоғистонлик
        журналистларга нисбатан чиқарилган айблов ҳукмларини бекор қилишга чақирган.
      </p>

      <p>
        CPJ ўзбек расмийларига матбуот ходимларини касбий фаолияти учун судламаслик, маҳкама
        жараёнларида журналистлар ва уларнинг оила аъзоларини қўрқитиш ҳаракатларидан тийилишга
        чақирган.
      </p>

      <p>
        АҚШ, Европа Иттифоқи, БМТ ва халқаро инсон ҳуқуқлари ташкилотлари ҳам ўзбек расмийларини
        Қорақалпоғистондаги воқеалар юзасидан очиқ, ҳар томонлама ва шаффоф тергов ўтказишга, тинч
        намойишчиларга қарши ҳаддан зиёд куч қўлланилганига оид иддаоларни текширишга чақирган.
      </p>
    </div>
  ),
  33: (
    <div>
      <p>
        27 ёшли Ўткирбек Собиров 2023 йилнинг январида Фарғонада газ тақчиллигидан норози бўлиб
        Телеграмда овозли шарҳ қолдиргани учун уч йилга қамалган.
      </p>
      <p>
        Озодликда нусхаси мавжуд суд ҳукмидан маълум бўлишича, Ўткирбек Собиров 2022 йил январь
        ойида Фарғонада газ тақчиллигидан норози бўлиб Телеграмдаги “Қўқон метан газ” номли гуруҳда
        овозли шарҳ қолдиргани учун қамалган.
      </p>

      <img src="https://gdb.rferl.org/01000000-0a00-0242-1494-08dbe129e24e_w650_r1_s.jpg" />

      <p>
        Экспертиза Собировнинг овозли матнида “президентни ҳақоратлаш аломатлари” борлигини
        аниқлаган.
      </p>
      <p>
        “Собиров 2022 йил 27 январь куни табиий газ ва электр тармоғидаги узилишлар сабабли
        давлатимизда юритилаётган сиёсатдан норози бўлиб Ўзбекистон президентини ҳокимиятдан
        четлатиш лозимлигини айтиб, қонуний равишда сайланган ҳокимият вакилини ҳокимиятдан
        четлатишга очиқдан-очиқ даъват қилиб шу мазмундаги фикрларини овозли ва матнли шаклда
        гуруҳга жойлаштириб, “Қўқон метан газ” номли гуруҳга тарқатган. Бундан ташқари гуруҳ
        аъзоларини Қўқон шаҳридаги Ўрда мажмуаси олдида йиғилиб митинг ўтказишга чақирган”, дейилади
        суд ҳукмида.
      </p>
    </div>
  ),
  34: (
    <div>
      <p>
        Хоразмдаги оғриқли мавзуларни ёритиб келган журналист Давлат Назар (Давлатназар Рўзметов)
        2019 йид 6 ноябрь оқшомида машина уриб кетиши оқибатида ҳалок бўлган эди. Ўлимига қадар
        танқидий қарашлари сабаб бир неча бор ҳибсга олинган журналистнинг ЙТҲ оқибатида вафот
        этгани шубҳа-гумонларни кучайтирган.
      </p>

      <p>
        Ўзбекистон Бош прокуратураси журналист Давлат Назар "автоҳалокат қурбони бўлгани" ҳақида
        зудлик билан расмий маълумот эълон қилди:
      </p>

      <p>
        <em>
          "2019 йил 06 ноябрь куни соат 23:55 ларда фуқаро С.У. ўзи ишлаб келаётган корхонасига
          тегишли бўлган “Газель” русумли автомашинани “Урганч-Хива” йўлининг 4-километрида бошқариб
          бораётганида, йўлни кесиб ўтаётган “Жамият” газетаси мухбири Давлатназар Рўзметовни уриб
          юборган. Натижада Д.Рўзметов бош қисмидан жароҳат олиб, воқеа жойида вафот этган".
        </em>
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/kA7arkxLn-Y?si=TP5N0Yx8oyMTiqQL"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2019 йил 12 ноябрь куни Ўзбекистон Ички ишлар вазирлиги машина уриб кетиши оқибатида ҳалок
        бўлган хоразмлик журналист Давлат Назар (Давлатназар Рўзметов) ўлими бўйича вазиятга доир
        матбуот анжумани ўтказиб, журналист ўлимига сиёсий тус бермаслик, бу “бахтсиз ҳодиса”
        эканини таъкидлаган эди.
      </p>

      <p>
        Давлат Назарнинг Фейсбукдаги саҳифасига ўлимидан сўнг (тег қилиб) ёзилган постларнинг
        аксарида журналист ўлими шубҳа остига олинган.
      </p>

      <p>
        <i>
          "Журналист ўлими ҳеч қачон оддий ўлим бўлмайди. Давлат Назардек қалами ўткир журналистнинг
          ўлими – инчинун. Ушбу ҳодиса юзасидан шаффоф текширув ва батафсил ахборот кутиб қоламиз
        </i>
        ", дея ёзган эди, жумладан, блогер Шаҳноза Соатова.
      </p>

      <p>
        Ўлимига қадар Озодлик билан яқин ҳамкорлик қилиб келган Давлат Назар кейинги пайтда мунтазам
        кузатувда эканини гапирган.
      </p>

      <p>
        Ўлимидан олдин у блогер Шабнам Оллошукурованинг руҳий диспансерга жойлаштирилгани ҳақидаги
        маълумотларни тарқатгани ортидан тазйиққа учрагани ҳақида Озодликка айтган:
      </p>

      <p>
        <i>
          "Ҳозиргина АҚШ элчихонаси сиёсий масалалар бўйича биринчи котиби Рейчел Вульф хоним билан
          учрашдик. Учрашув жараёнида дипломат хоним билан Ўзбекистонда сўз эркинлиги, демократик
          жараённинг ривожланиши, инсон ҳуқуқлари ҳамда журналист ва блогерларга айрим орган ва
          ташкилотлар томонидан бўлаётган босимлар, таъқиблар хусусида, жумладан, ўзимга бўлаётган
          таъқиблар ҳамда мажбурий тарзда руҳий касалликлар шифохонасида сақланаётган Нафосат
          Оллошукурова хусусида суҳбатлашдик",{' '}
        </i>
        дея хабар йўллаганди Давлат Назар ўлимидан бир неча кун аввал.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/UIb21NV-o4I?si=8X4oHYuLGLhXc65m"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Давлат Назар тахаллуси билан ижод қилган қўшкўпирлик Давлатназар Рўзметов “Ёшлар овози”,
        “Хоразм ёшлари”, "Жамият" каби газеталарда фаолият юритган.
      </p>

      <p>
        У ўзининг Фейсбукдаги саҳифасида Ўзбекистонда бўлаётган воқеаларга фаол фикр билдириши билан
        ҳам машҳур эди.
      </p>

      <p>
        Давлат Назар Ўзбекистон ҳаëтида мухим бўлган воқеа, яъни Урганч шаҳар Ашхобод кўчасидаги уйи
        бузилганлар намойиши ҳақида Озодликка маълумотларни етказгани ортидан муаммоларга дуч
        келгани маълум.
      </p>

      <p>
        Давлат Назар танқидий мақолалари ва мухолиф қарашлари сабаб бир неча бор қамоққа ташланган
        эди.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/fdMEwX43-mE?si=5lWKD3eEaSpQoXdl"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2020 йил 19 февралда жиноят ишлари бўйича Урганч шаҳар суди Давлат Назарни машинасида уриб
        ўлдирган ҳайдовчи Умидбек Сапаровга 3 йил муддатга озодликни чеклаш жазоси тайинлади.
        Шунингдек, суд Сапаровни 1,5 йил давомида машина ҳайдаш ҳуқуқидан ҳам маҳрум қилди. Адвокат
        Шерзод Қурбоновга кўра, судья судланувчи Сапаровга нисбатан енгил жазо тайинлар экан, унинг
        Давлат Назар оиласига моддий ёрдам берганини инобатга олган.
      </p>
    </div>
  ),
  35: (
    <div>
      <p>
        Бобомурод Абдуллаев – кейинги йилларда шов-шувли жиноят ишларига алоқадорликда гумон қилиниб
        бир неча бор ҳибсга олинган мустақил журналист.
      </p>

      <p>
        Абдуллаев 2017 йилнинг 27 сентябрида МХХ томонидан ҳибсга олинган. Шундан сўнг у 2011 йилдан
        бошлаб "Усмон Ҳақназаров" имзоси остида "амалдаги тузумни ўзгартиришга чақирувчи" мақолалар
        чоп этиш ва Ўзбекистонда "инқилоб қилиш"га уринишда гумон қилиниб, судланган.
      </p>

      <p>
        Маҳкама давомида Бобомурод Абдуллаев ўзининг Усмон Ҳақназаров тахаллуси остидаги
        мақолаларнинг аксарияти муаллифи эканини тан олган, бироқ ўзи ёзган мақолаларда давлат
        тўнтаришига чақириқ бўлганини рад этган.
      </p>

      <p>
        Шу билан бирга, судда журналистга нисбатан тергов давомида қийноқ қўлланилгани қайд этилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/2dT87l6pG60?si=TC_zIqsh9FVZuT_M"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Прокурор Б.Абдуллаевга 5 йиллик қамоқ жазоси сўраган. Бироқ 2018 йил 7 май куни жиноят
        ишлари бўйича Тошкент шаҳар судида бўлиб ўтган маҳкамада журналист Ўзбекистон Жиноят
        кодексининг 159 - моддаси, 1 - қисми, “б” бандида назарда тутилган жиноятни содир этганликда
        айбдор топилиб, унга иш ҳақининг 20 фоизини давлатга ўтказиш ва 3 йилга ахлоқ тузатиш
        ишларига жалб этиш жазоси тайинланган ҳамда суд залидан озод қилинган.
      </p>

      <p>
        Абдуллаевнинг суд залидан озод қилинишини қатор нуфузли халқаро ташкилотлар, жумладан,
        ЕХҲТнинг Матбуот эркинлиги бўйича вакили, Amnesty International , CPJ ва бошқа инсон
        ҳуқуқлари ташкилотлари олқишлаган.
      </p>

      <p>Абдуллаев 2020 йилда иккинчи бор қамоққа олинган.</p>

      <p>
        Қирғизистон Миллий хавфсизлик давлат қўмитаси Абдуллаевни 2020 йил 8 августида Ўзбекистон
        томонининг расмий сўровига биноан Бишкекда қўлга олган ва 22 август куни Ўзбекистонга
        топширган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/1r3sYIEm4lE?si=rTtY0jKpsH8njqzR"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        22 август куни Тошкентда ДХХ ходимлари тарафидан саккиз соат сўроқ қилиниши ортидан Б.
        Абдуллаев қўйиб юборилган, бироқ унга қарши очилган жиноят иши ҳали ёпилмаган эди.
        Ўзбекистон куч ишлатар тузилмалари журналистнинг нимада айбланаётганига расман ойдинлик
        киритган эмас.
      </p>

      <p>
        Журналистнинг ўзи Бишкекда қўлга олинган пайтда уни "Қора Мерган" тахаллуси остида ҳукуматга
        қарши танқидий мақолалар ёзганликда айблаётганларини таъкидлаган ва бу айбловни кескин рад
        этган.
      </p>

      <p>
        Бобомурод Абдуллаевнинг қўлга олиниши ортидан “Чегарасиз мухбирлар” (RSF), Amnesty
        International, Association for Human Rights in Central Asia (AHRCA), Civil Rights Defenders,
        International Partnership for Human Rights (IPHR), Freedom House, Freedom Now, Norwegian
        Helsinki Committee (NHC), Human Rights Watch (HRW) ҳамда Журналистларни ҳимоя қилиш қўмитаси
        (Committee to Protect Journalists) каби нуфузли ташкилотлар расмий Бишкекни ўзбекистонлик
        журналистни зудлик билан озод қилишга чақирган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/Wy6rOApZniQ?si=SaEvpZCA9iMf3wlU"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        “Чегара билмас мухбирлар” (RSF) халқаро ташкилоти ўз стипендианти бўлган журналист Абдуллаев
        Қирғизистонда қўлга олиниб, Ўзбекистонга топширилганидан ташвиш билдирган.
      </p>

      <p>
        2020 йил октябрида Абдуллаевга нисбатан жиноят иши ёпилган ва у озодликка чиқарилган. Шундан
        сўнг журналист президент Шавкат Мирзиёев унга Тошкентдан{' '}
        <a href="https://www.ozodlik.org/a/30900457.html">
          уч хонали хонадон совға қилганини айтган
        </a>{' '}
        ва бунинг "сиёсий пора" экани ҳақидаги танқидларни{' '}
        <a href="https://www.ozodlik.org/a/30902930.html">рад этган </a>эди.
      </p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/flhGCQNDDoE?si=YEwmn6IK_X8H1N9U"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  ),
  36: (
    <div>
      <p>Шоир ва блогер Маҳмуд Ражаб “Тошкентга юриш” қилгани ортидан маҳкамага тортилган.</p>

      <p>
        2019 йил 18 октябрь куни жиноят ишлари бўйича Хоразм вилоят судида Маҳмуд Ражаб устидан суд
        ҳукми ўқилди. У Ўзбекистон Республикаси Жиноят кодексининг 244-модда (оммавий
        тартибсизликлар) ва 246-модда (контрабанда) да назарда тутилган жиноятларни содир этганликда
        айбдор деб топилган ва 2 йилу 3 ойга шартли озодликдан маҳрум қилинган ва суд залидан озод
        қилинган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/La6iXO3_ZyA?si=BNuCAA4VNLH1wOZP"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Маҳмуд Ражаб 2019 йилнинг март ойида Истанбулдан мухолифатчи шоир Муҳаммад Солиҳ асарларини
        олиб келаётганида Тошкент аэропортида ушланиб, қўлидаги китоблар тақиқланган адабиётлар
        сифатида олиб қўйилган. У контрабандада айбланиб, 5 ойдан бери терговга қатнаётган пайти
        Хоразмдан адолат топа олмаганини айтиб, Тошкентдан ҳақиқатни излаб пиёда йўлган чиққан эди.
      </p>

      <p>
        Маҳмуд Ражаб ва унинг яқинлари Тошкентга бориб, Ички ишлар вазири Пўлат Бобожонов билан
        шахсан учрашиш мақсадида 2019 йил 22 сентябрь куни юриш бошлаган ва 50 километр йўлни пиёда
        босиб ўтган.
      </p>

      <p>
        “Юриш” қатнашчилари орасида Маҳмуд Ражабнининг қариндошларидан ташқари, уни қўлловчи шахслар
        ҳам бор эди.
      </p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/2tzQ7CzR0yw?si=8da8vKA4YJEq658e"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        “Тошкентга юриш” қилгани учун дастлаб 10 суткага қамалган шоир Маҳмуд Ражаб жазо муддатини
        ўтаб, 3 октябрь озод қилинган.
      </p>
    </div>
  ),
  37: (
    <div>
      <p>
        Жамшид Мирзаев (Маҳдий Мирзаев) – ижтимоий тармоқларнинг ўзбек сегментида диний мазмундаги
        постлари билан танилган блогер.
      </p>

      <p>
        У танишлари билан бирга 2023 йилнинг 20-21 май кунлари майда безорилик айби билан 15
        суткалик қамоққа олинган.
      </p>

      <p>
        Кейинроқ 8 кишига нисбатан "террорчилик ҳаракати ҳақида хабар бермаслик" ва "террорни
        молиялаштириш", "диний-экстремистик ташкилот тузиш ва унда иштирок этиш" айблари билан
        тергов ҳаракатлари бошланган.
      </p>

      <p>
        Гумондорларнинг Озодлик билан гаплашган айрим қариндошлари тергов органи гумондорларнинг
        хайрия учун йиққан маблағларини терроризмни молиялаш деб талқин қилаётган бўлиши
        мумкинлигини айтган.
      </p>

      <p>
        М.Мирзаевнинг онаси Озодлик билан суҳбатда ўғли унга:
        <i>“Менинг бўйнимга катта нарсаларни қўйишмоқда, ҳаммага хабар беринг!”</i>
        деганини айтди. Маҳдий Мирзаевнинг яқинлари уни террорчиликда айблашга асос йўқлигини
        гапирган.
      </p>

      <p>
        Мирзаевнинг онаси Зулфия Мирзаевага кўра, ўғли дастлаб қамоққа олинган 21 май куни у ва
        турмуш ўртоғини ҳам Юнусобод тумани ИИБга олиб бориб сўроқ қилишган. У сўроқ жараёнида
        ўзларига “босим ўтказилгани”ни иддао қилган.
      </p>

      <p>
        Мирзаев Жиноят кодексининг 155-моддаси (терроризм) бўйича айблангани маълум, бироқ судга оид
        бошқа тафсилотлар Озодликка номаълум.
      </p>
    </div>
  ),
  38: (
    <div>
      <p>
        2023 йилнинг 26 октябрь куни Инстаграмда президент Шавкат Мирзиёев ҳақида танқидий пост
        ёзган 19 ёшли Дилшод Искандаров икки ярим йилга қамалди.
      </p>

      <p>
        Самарқанд вилояти Каттақўрғон тумани суди Дилшод Искандаровни Ўзбекистон Жиноят кодексининг
        158-моддаси, 3-қисми ("Ўзбекистон президентини омма олдида ҳақоратлаш ёки унга туҳмат
        қилиш”)да айбдор деб топган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/INGkIv78dH8?si=KHCPmvcANN5QI-PO"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Озодликда нусхаси мавжуд суд ҳукмидан маълум бўлишича, Искандаров шу йил ўрталарида Россияда
        бўлган пайтда Инстаграм ижтимоий тармоғида “President family” номли видеолавҳа остида
        “avlodinggiga …Sh.M.Mirziyoyev” (имло ўзгаришсиз берилмоқда - таҳр.) деган изоҳ қолдирган.
      </p>

      <p>
        “Шу йил ёз ойлари бошида Дилшод Искандаров ўзининг “Xiaomi 11N” телефони ёрдамида
        Инстаграмдаги “President family” номли видеолавҳа остига avlodinggiga … Sh.M.Mirziyoyev” деб
        изоҳ қолдирган. Кейинчалик, унинг профилини кузатиб борувчи танишлари “...ака профилингизга
        нима учун бундай ҳақоратли сўзларни ёздингиз?, ўчириб ташланг яхши бўлмайди” деб
        огоҳлантирганидан сўнг изоҳини ўчириб ташлаган”, дейилади суд ҳукмида.
      </p>

      <img src="https://gdb.rferl.org/01000000-0a00-0242-d669-08dbe12934db.jpg" />

      <p>
        Ўзбекистон Адлия вазирлиги ҳузуридаги суд экспертиза маркази мазкур постда “президентни
        ҳақоратлаш, обрўсизлантириш билан боғлиқ ҳаракатлар мавжуд”, дея хулоса берган.
      </p>

      <p>
        Суд ҳукмида айтилишича, Дилшод Искандаров 2022 йил ноябрь ойида Россиянинг Владивосток
        шаҳрига ишлаш мақсадида борган, интернетдаги пости учун ўзига нисбатан Ўзбекистонда жиноят
        иши очилганидан гўёки хабар топган ва 2023 йил август ойида Ўзбекистонга қайтган.
      </p>

      <p>
        Судда ўзига қўйилган айбга иқрор бўлган, бундай пост ёзишга уни ҳеч ким мажбурламагани,
        қилмишидан пушаймонлигини айтган ва суддан енгиллик сўраган.
      </p>
    </div>
  ),
  39: (
    <div>
      <p>
        2024 йилнинг февраль куни фарғоналик блогер Гули (Гулноз) Мирзаева Қашқадарё вилояти Муборак
        тумани ИИБ томонидан ҳибсга олинган.
      </p>
      <p>
        Мирзаеванинг яқинлари у президент Мирзиёев ва оиласини танқид қилгани сабаб қўлга олиниб,
        унга нисбатан 158-модда илгари сурилганини айтишган.
      </p>

      <p>Шунингдек, Мирзаева товламачиликда ҳам гумон қилинмоқда.</p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/KxFtC1B5Lco?si=t_IUj8sLzjiZCGIs"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Озодлик суҳбатлашган Муборак тумани ҳокимлигининг исми сир қолишини сўраган мулозими
        иддаосига кўра, Мирзаева "Муборак газни қайта ишлаш заводи раҳбарларини танқид қилмаслик
        эвазига пул талаб қилган".
      </p>

      <p>
        Аммо “Озодлик”да мазкур инцидентни тасдиқловчи маълумотлар мавжуд эмас. Айни пайтда мазкур
        ҳодиса юзасидан расмий изоҳ берилмади, жиноят иши тафсилотлари маълум эмас.
      </p>

      <p>
        Гули Мирзаева ўзининг тармоқлардаги чиқишларида президент Шавкат Мирзиёев ва унинг оила
        аъзолари, хусусан, тўнғич қизи Саида Мирзиёевани танқид қилиб келган.
      </p>

      <p>
        У ўз чиқишларидан бирида блогерлар Абдуқодир Мўминов ҳамда Дилдора Боймуродоваларнинг
        қамалишини уларнинг президент ва унинг оиласига қаратилган танқидий чиқишлари билан
        боғлаган.
      </p>

      <p>
        Блогер "Президент оиласини ҳашаматли уйлар қуриб, коррупция ва непотизмга берилганлик"да
        айблаган.
      </p>

      <p>
        "Тараққиёт стратегиясини ўқиб чиқдим. Ундан ҳозирча юртимиздаги ягона инсон - тўнғич
        қизингиз Саида Мирзиёеванинг президент ёрдамчиси лавозимига ишга кўтарилгани ва тараққиёт
        сари қадам босганига гувоҳи бўлдим. Бошқа ҳеч қандай тараққиётни мен кўрмадим, сезмадим
        жаноб президент", дейди у 2023 йил 9 октябрида YouTube даги "Ҳақиқат истаб" каналига
        жойланган видеосида.
      </p>

      <p>
        Ўзининг сўнгги видеоларидан бирида Мирзаева президент ёрдамчиси Саида Мирзиёевага мурожаат
        қилиб, Муборак газни қайта ишлаш заводидаги, ўз таъбирича, "коррупцион ҳолатлар" ҳақида
        гапирган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/nGsdJGzAYdE?si=MLRWwdljQs32dDFU"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Блогерга кўра, Муборак газни қайта ишлаш заводида "жуда кўп шахслар ишга келмасдан ойлик
        маошлари олишади". Мирзаева завод раҳбарияти уюшган жиноий гуруҳ тузганини иддао қилиб Саида
        Мирзиёевадан чора кўришни талаб қилади.
      </p>

      <p>
        У шунингдек, ўзининг транспортга пули йўқлигини айтиб, Қашқадарё вилояти ҳокимлигига пиёда
        бораётганини таъкидлайди.
      </p>

      <p>
        Мирзаева бундан олдинги чиқишларида мухолифатдаги "Ҳақиқат, Тараққиёт ва Бирдамлик"
        демократик партиясини расмий рўйхатдан ўтказишни талаб қилиб, партия тарафдорларини имзо
        тўплашда фаол бўлишга чақирган.
      </p>

      <p>
        Норасмий "Ҳақиқат, Тараққиёт ва Бирдамлик" демократик партияси раҳбари, профессор Хидирназар
        Аллақулов Озодлик билан суҳбатда Гули Мирзаеванинг партия фаолиятини қўллаб-қувватлагани,
        аммо унинг на партия бошқаруви ва на унинг фаолиятига алоқадор эмаслигини таъкидлади.
      </p>

      <p>
        Блогерни яқиндан таниган фаолларнинг айтишича, унинг қамалишига Муборак газни қайта ишлаш
        заводи фаолиятидаги коррупциявий ҳолатларни фош этишга урингани ҳам сабаб бўлган.
      </p>

      <p>
        Мирзаевани яқиндан таниган блогерлардан бирининг айтишича, у 2023 йил ёзида Ўзбекистонда
        судланган ва йирик миқдорда жаримага тортилган.
      </p>

      <p>
        Ўша пайтда Россия Федерациясида яшаган Мирзаева Ўзбекистонга миграция хизмати томонидан
        мажбурий равишда депортация қилингани айтилади.
      </p>
    </div>
  ),
  40: (
    <div>
      <p>Комил Аҳмедов – фарғоналик блогер.</p>

      <p>
        2022 йил 22 июль куни Қўқон шаҳар суди қарори билан блогер Комил Аҳмедовга нисбатан
        Ўзбекистон Республикаси Маъмурий жавобгарлик тўғрисидаги кодексининг 184 прим 3-моддаси яъни
        (миллий, ирқий, этник ёки диний адоватни тарғиб қилувчи материалларни тайёрлаш, сақлаш ёки
        тарқатиш) билан 15 сутка маъмурий қамоқ жазоси тайинланган.
      </p>

      <p>
        Суд шунингдек, бошқа бир блогер Олимжон Ҳайдаровга ҳам 15 суткалик қамоқ жазоси тайинлаган.
      </p>

      <img src="https://gdb.rferl.org/08a40000-0a00-0242-986e-08da6c8f8477_w1023_r1_s.jpg" />

      <p>
        Фарғона вилояти ИИБ хабарига кўра, 2022 йилнинг 28 июнь куни телеграмдаги «Олимжон Ҳайдаров»
        ҳамда «QO’QONJONIM» каналларида қолдирилган «Қўқон шаҳрида ноқонуний Черков фаолият олиб
        бормоқда» сарлавҳали хабар юзасидан «Возрождение» номли «Евангел» христианлари черкови
        пастори А.Айрапетовнинг аризасига асосан Қўқон шаҳар ИИБ ходимлари томонидан олиб борилган
        терговга қадар текширув ҳаракатлари давомида Қўқон шаҳар, Чуст кўчаси 51-уйда жойлашган
        «Возрождение» номли «Евангел» христианлари черкови 2019 йилдан бошлаб расмий фаолият юритиб
        келаётгани аниқланган.
      </p>

      <p>
        Бундан олдинроқ ўзининг Фейсбук саҳифасида Олимжон Ҳайдаров Комил Аҳмедов билан бирга ҳеч
        қандай огоҳлантиришларсиз судга чақиртирилгани, бир кун аввалги сана билан ҳамма ҳужжатлар
        тайёрлаб қўйилгани ҳақида хабар берганди.
      </p>

      <p>
        Тармоқ фойдаланувчилари Қўқон судининг мақола учун чиқарган 15 суткалик жазосини номутаносиб
        эканини айтган.
      </p>
    </div>
  ),
  41: (
    <div>
      <p>
        Танқидий чиқишлари билан танилган қашқадарёлик блогер, “Эзгулик” инсон ҳуқуқлари жамияти
        фаоли Элмурод Одил бир неча бор қамоққа олинган.
      </p>

      <p>
        2021 йил Яккабоғ тумани ҳокими аризасига асосан Элмурод Одил устидан терговолди суриштирув
        ҳаракати бошланган.
      </p>

      <p>
        Блогер Телеграмдаги саҳифасида Ўзбекистон имижига салбий таъсир кўрсатадиган маълумотлар
        тарқатиш, ҳокимликнинг ички ишларига аралашиш, ҳоким ўринбосарлари орасидаги муносабатда
        носоғлом вазият келтириб чиқаришда ва ҳокимлик матбуот котибини урганликда айбланган.
      </p>

      <p>
        Элмурод Одил бу айбловларни инкор қилар экан, туман иқтисодий ва ижтимоий ҳаётидаги
        камчиликлар ҳақида танқидий чиқишлари учун унинг овозини ўчиришга ҳаракат бошланганини
        айтган.
      </p>

      <p>
        &#xa0;2021 йил 24 июнь куни Элмурод Одил Яккабоғ тумани ҳокими қабулига келган
        шикоятчилардан интервью олиб турган пайтда ҳокимлик ахборот хизмати раҳбари Шерзод Ҳасанов
        унинг мобил телефонини куч билан тортиб олган ва бир соатдан сўнг телефон хотирасидаги
        видеоларни ўчириб, қайтариб берган.
      </p>

      <p>2023 йилда Элмурод Одил бир эмас, икки марта 15 суткалик қамоқ жазоси олган.</p>

      <p>
        Дастлаб, 2023 йил 31 январь куни Элмурод Одил газ ва свет мавзусини фаол ёритиб, сенат раиси
        истеъфосини талаб қилгани ортидан туҳмат ва ҳақоратда айбдор деб топилиб, 15 сутка қамоққа
        маҳкум этилган эди.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/SJlOtpnvK9k?si=tcL9C77g8gLHuA6G"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2023 йил 27 май куни блогер Элмурод Одил яна маҳкамага тортилди. Бу сафар у Маъмурий
        жавобгарлик кодексининг 183-моддаси (майда безорилик) ва 198-моддаси (ҳокимият вакилининг
        қонуний талабларини бажармаслик ёки хизмат вазифаларини бажаришига тўсқинлик қилиш) 1-қисми
        билан 15 суткага қамалган.
      </p>

      <p>
        “Daryo” нашри эса 27 майда Одилов пилла пунктида Ички ишлар ходимлари томонидан “аёвсиз
        калтаклангани” тўғрисида ёзган.
      </p>

      <p>
        Элмурод Одил бу ҳибсларни мутасаддилар томонидан унинг блогерлик фаолиятни тўхтатиш
        мақсадида уюштирилган, деб ҳисоблайди.
      </p>
    </div>
  ),
  42: (
    <div>
      <p>
        Facebook ижтимоий тармоғи орқали Отабек Нуритдинов тахаллуси остида ижтимоий-сиёсий
        воқеаларга муносабат билдириб келган блогер Абдуфатто Нуритдинов 2020 йил, 30 декабрь куни
        Андижон вилоят маъмурий суди томонидан 15 сутка қамоқ жазосига ҳукм қилинган.
      </p>

      <p>
        Расмий маълумотга кўра, Абдуфатто Нуритдинов туҳмат, ҳақорат ва майда безориликда айбдор,
        деб топилган. Бундан ташқари блогерга БҲМнинг 60 баробари миқдорида жарима ҳам солинган.
        Блогер ўзига қўйилган айбловларни тан олмаган.
      </p>

      <p>
        Ўзини ошкор қилишни истамаган{' '}
        <a href="https://www.ozodlik.org/a/30354043.html">манбанинг айтишича</a>: “Нуритдинов асосан
        Андижон вилояти ва Асака тумани хокимлик вакилларининг бюджет пулларини талон-торож
        қилишларини аёвсиз ёритиб келган”.
      </p>

      <p>Нуритдинов 2021 йил 14 январь оқшомида қамоқ муддатини ўтаб, озодликка чиққан.</p>

      <p>Озодликка чиққанидан бир ой ўтиб, Нуритдинов ўзининг калтакланганини иддао қилди.</p>

      <img src="https://gdb.rferl.org/F7711BE3-1BB4-457A-B094-DE0F4E996B8E.jpg" />

      <p>
        Нуритдиновга кўра, 18 февраль куни у Андижон вилоятининг Асака шаҳридаги масжид яқинида
        спиртли ичимликлар билан савдо қилувчи тадбиркор томонидан калтакланган.
      </p>

      <p>
        Блогернинг Фейсбукда ёзишича, жанжалга унинг масжидга яқин жойдаги ароқ дўкони ҳақида эълон
        қилган пости сабаб бўлган.
      </p>

      <p>2020 йил кузида Нуриддинов яна бир жиноят иши фигурантига айланди.</p>
      <p>
        Расмий маълумотга кўра, Нуритдинов Facebook тармоғидаги ўз саҳифасида Андижон шаҳридаги
        25-мактаб директор ўринбосари Гулчеҳра Мирзаевани ҳақоратлагани учун унга қарши Жиноят
        кодексининг 140-моддаси (ҳақорат қилиш) билан жиноят иши қўзғатилган.
      </p>
      <p>
        Блогер ўзига нисбатан асоссиз жиноят иши қўзғатилганлиги ҳақида Facebook’да{' '}
        <a href="https://www.facebook.com/story.php?story_fbid=3502609673154627&amp;id=100002168858300">
          пост
        </a>{' '}
        қолдирган.
      </p>

      <p>
        Кейинчалик Бош прокуратураси жамоатчилик билан алоқалар ва ҳуқуқий ахборот бўлими бошлиғи
        Ҳаёт Шамсутдинов блогер Нуритдиновга қарши очилган жиноят иши бекор қилинганини хабар
        қилган.
      </p>

      <p>
        Ҳ. Шамсутдиновга кўра, ҳолатни ўрганиш чоғида жиноят иши қўзғатиш ҳақидаги қарорни қабул
        қилишда жиноят-процессуал қонунчилиги талабларига тўлиқ риоя қилинмаганлиги аниқланган. Шу
        важдан Жиноят-процессуал кодексининг 23-моддаси (айбсизлик презумпцияси) 3-қисмига мувофиқ,
        Абдуфатто Нуритдиновга нисбатан қўзғатилган жиноят иши бекор қилинган.
      </p>
    </div>
  ),
  43: (
    <div>
      <p>
        Аctivist лойиҳаси блогери Ҳожиакбар Носиров 2023 йил, 8 апрель куни жиноят ишлари бўйича
        Шайхонтоҳур туман суди қарори билан 15 суткага қамалган.
      </p>

      <p>
        Тошкент шаҳар судлари
        <a href="https://t.me/toshkentshaharsudlari/6066">&#xa0;расмий телеграм каналида</a> маълум
        қилинишича,
        <br />
        1997 йилда Тошкентда туғилган Носиров ички ишлар органлари томонидан диний муҳитни
        соғломлаштириш амалиёти доирасида ўтказилаётган мониторинг натижасида қўлга олинган.
      </p>

      <p>
        Расман билдирилишича, Ҳожиакбар Носиров 5 апрель куни кармин E120 моддаси борлиги учун
        йогуртлар ҳаром экани тўғрисидаги видеони эълон қилган.
      </p>

      <p>
        Дин ишлари бўйича қўмита 7 апрелдаги 18-660-сонли хулосасида Ҳожиакбар Носиров “ихтилоф ва
        тушунмовчиликлар келтириб чиқариши мумкин бўлган ғояларни тарқатганлигини аниқлаган”.
      </p>

      <p>
        Судда блогер кўрсатма беришдан бош тортган. Суд қарори билан у Маъмурий жавобгарлик
        тўғрисидаги кодекснинг 184-3-моддаси (миллий, ирқий, этник ёки диний адоватни тарғиб қилувчи
        материалларни тайёрлаш, сақлаш ёки тарқатиш) ва 194-моддаси (ички ишлар органлари ходимининг
        қонуний талабларини бажармаслик) 1-қисми бўйича тутилган ҳуқуқбузарликни содир этганликда
        айбли деб топилиб, унга 15 сутка маъмурий қамоқ жазоси тайинланган
      </p>

      <p>
        Блогер қамалиши ортидан{' '}
        <a href="https://www.ozodlik.org/a/fanvo-yogurt-harom-emas/32356757.html">
          Ўзбекистон мусулмонлари диний идораси Фатво маркази
        </a>{' '}
        кармин E120 моддаси ҳаром эмаслигини ва бу модда қўшилган маҳсулотларни истеъмол қилиш жоиз
        экани ҳақида билдирган.
      </p>
    </div>
  ),
  44: (
    <div>
      <p>
        <a href="https://taftish.uz/">Taftish.uz</a> нашри журналисти Бобур Ганиев 2021 йил 1
        октябрь куни 15 суткалик маъмурий қамоқ жазосига ҳукм қилинган.
      </p>

      <p>
        Ўша куни суд Бобур Ганиев ва унинг ҳамкасби Аброр Козубаевни ички ишлар ходимларини ҳақорат
        қилганлик, улар талабларини бажармаслик ҳамда уларнинг хизмат бурчларини бажаришига қаршилик
        кўрсатишда айбдор деб топган.
      </p>

      <p>
        Бобур Ганиев 5 400 000 сўмлик, Аброр Козубаев эса 270 минг сўмлик жаримага ҳам тортилган.
      </p>

      <p>
        Икки журналист ва уларнинг дўсти 2021 йил&#xa0; 30 сентябрь кунги ИИБ рейди пайти содир
        бўлган воқеада айбланган.
      </p>

      <p>
        Аброр Козубаев ўзига тегишли “Эпика” русумли машинада ҳамкасби Бобур Ганиев ва таниши Обид
        Салимов билан кетаётган пайтда уни ИИБ ходимлари тўхтатган.
      </p>

      <p>
        Озодликка тақдим қилинган суд қарори нусхасида Бобур Ганиев ва Обид Салимов ўз телефонларига
        ИИБ ходимларини видеога олгани ҳамда Ганиев “ИИБ ходимларини камситувчи сўзлар билан
        ҳақоратлаб, оммага ўзларини кўрсатиб, ИИБ ходимларини хизмат вазифаларини бажаришга қаршилик
        кўрсатган”и айтилган.
      </p>

      <img src="https://gdb.rferl.org/305cb4a2-0971-493d-9233-1622bf570bcb_cx8_cy49_cw88_w250_r1_s.jpg" />

      <p>Козубаев ва Салимов ҳам ИИБ ходимларига қаршилик қилинганини инкор қилишган.</p>

      <p>
        Бироқ судья Дилшод Камилов уларнинг учаласини ҳам айбдор деб топган ва ҳар бирига 15
        суткалик қамоқ жазоси тайинлаган.
      </p>

      <p>
        Суд қарорида ёзилишича, “судланувчиларни қонунларга риоя этиш ва ҳурмат қилиш руҳида
        тарбиялаш мақсадида” уларга маъмурий қамоқ жазоси берилган.
      </p>

      <p>
        Суд қарорида Бобур Ганиев Маъмурий-жавобгарлик тўғрисидаги Кодекснинг 41-моддаси (ҳақорат
        қилиш), 194-моддаси (ички ишлар органлари ходимининг қонуний талабларини бажармаслик),
        195-моддаси (ички ишлар органлари ходимларининг ўз хизмат бурчларини бажаришларига қаршилик
        кўрсатиш)да айбдор деб топилгани қайд қилинган.
      </p>

      <p>
        Аброр Козубаев 194-модда ва 195-модда, Обид Салимов эса 195-модда бўйича айбдор деб
        топилган.
      </p>

      <p>
        1 октябрь куни ижтимоий тармоқларда 34 яшар Бобур Ганиевнинг ИИБ хонасида тергов
        қилинаётгани акс этган фото ва видеолар тарқалди. Видеолардан бирида Ганиевнинг тергов пайти
        ИИБ ходими олдида тиз чўкиб ўтиргани акс этган.
      </p>

      <p>
        Видеолардан яна бирида эса гўёки Бобур Ганиевники экани айтилган мобил телефондан
        порнографик тасвирлар ҳам топилгани иддао қилинган.
      </p>
      <p>
        Бобур Ганиевнинг ҳамкасблари иддаосича, танқидий чиқишлари сабаб унга нисбатан сохта
        айбловлар илгари сурилган ва уни жамоатчилик орасида обрўсизлантириш учун ИИБ хонасида
        видеога олиб тарқатилган.
      </p>

      <p>
        1 октябрь куни Тошкент шаҳар Ички ишлар бош бошқармаси Ахборот хизмати раҳбари Нилуфар
        Исахонова Qalampir.uz сайтига берган интервьюсида Бобур Ганиевнинг ИИБ хонасидаги фото ва
        видеоларини ким тармоқларга тарқатиб юборгани юзасидан хизмат текшируви бошланганини маълум
        қилган.
      </p>

      <p>
        Бироқ ушбу баёнотлардан сўнг ўтказилгани айтилган маҳкамада Ганиевнинг ИИБ ходими олдида тиз
        чўкиб ўтиргани ҳам, гўёки унинг телефонидан топилган порнографик видеолар билан боғлиқ
        ҳолатлар ҳам тилга олинмаган.
      </p>

      <p>
        Онлайн видеоконференция тарзида ўтгани айтилган суд мажлисида Ганиев ИИБ ходимларини видеога
        олганини ва улар билан келишмовчилик бўлганини тан олган, бироқ ўзига қўйилган бошқа
        айбловларни инкор қилган. У “ички ишлар ходимларини қонуний талабларини бажаришга қаршилик
        кўрсатмагани ва уларни ҳақорат қилмаган”ини айтган.
      </p>

      <img src="https://gdb.rferl.org/ffd2289f-ebfd-402c-b492-0cb0ac05d710_w650_r0_s.jpg" />

      <p>
        Ижтимоий тармоқларда ушбу икки журналистнинг қамалиши, айниқса, Бобур Ганиевнинг ИИБ ходими
        олдида тиз чўкиб ўтиргани видеоси кенг муҳокамага сабаб бўлди.
      </p>

      <p>
        Олий Мажлис депутати Расул Кушербаев ҳам журналистлар қамалганини қоралаб, ИИБ хонасидаги
        Бобур Ганиев видеолари атайин тарқатилгани ҳақида ёзди.
      </p>
    </div>
  ),
  45: (
    <div>
      <p>
        <a href="https://taftish.uz/">Taftish.uz</a> нашри журналисти Аброр Козубаев 2021 йил 1
        октябрь куни 15 суткалик маъмурий қамоқ жазосига ҳукм қилинган.
      </p>

      <p>
        Ўша куни суд Козубаев ва унинг ҳамкасби Бобур Ганиевни ички ишлар ходимларини ҳақорат
        қилганлик, улар талабларини бажармаслик ҳамда уларнинг хизмат бурчларини бажаришига қаршилик
        кўрсатишда айбдор деб топган.
      </p>

      <p>
        Аброр Козубаев 270 минг сўмлик, Бобур Ганиев эса 5 400 000 сўмлик жаримага ҳам тортилган.
      </p>

      <p>
        Икки журналист ва уларнинг дўсти 30 сентябрь кунги ИИБ рейди пайти содир бўлган воқеада
        айбланган.
      </p>

      <p>
        Аброр Козубаев ўзига тегишли “Эпика” русумли машинада ҳамкасби Бобур Ганиев ва таниши Обид
        Салимов билан кетаётган пайтда уни ИИБ ходимлари тўхтатган.
      </p>

      <p>
        Озодликка тақдим қилинган суд қарори нусхасида Бобур Ганиев ва Обид Салимов ўз телефонларига
        ИИБ ходимларини видеога олгани ҳамда Ганиев “ИИБ ходимларини камситувчи сўзлар билан
        ҳақоратлаб, оммага ўзларини кўрсатиб, ИИБ ходимларини хизмат вазифаларини бажаришга қаршилик
        кўрсатган”и айтилган.
      </p>

      <img src="https://gdb.rferl.org/305cb4a2-0971-493d-9233-1622bf570bcb_cx8_cy49_cw88_w250_r1_s.jpg" />

      <p>Козубаев ва Салимов ҳам ИИБ ходимларига қаршилик қилинганини инкор қилишган.</p>

      <p>
        Бироқ судья Дилшод Камилов уларнинг учаласини ҳам айбдор деб топган ва ҳар бирига 15
        суткалик қамоқ жазоси тайинлаган.
      </p>

      <p>
        Суд қарорида ёзилишича, “судланувчиларни қонунларга риоя этиш ва ҳурмат қилиш руҳида
        тарбиялаш мақсадида” уларга маъмурий қамоқ жазоси берилган.
      </p>

      <p>
        Суд қарорида Аброр Козубаев 194-модда (ички ишлар органлари ходимининг қонуний талабларини
        бажармаслик), 195-модда (ички ишлар органлари ходимларининг ўз хизмат бурчларини
        бажаришларига қаршилик кўрсатиш)да айбдор деб топилган.
      </p>

      <p>
        Бобур Ганиев 41-модда, 194-модда, 195-модда, Обид Салимов эса 195-модда бўйича айбдор деб
        топилган.
      </p>
    </div>
  ),
  46: (
    <div>
      <p>
        Самарқандлик 39 яшар Бунёджон Бозоров 2023 йилнинг октябрида Facebook тармоғидаги шарҳи учун
        5 йилу 1 ойлик қамоқ жазосига ҳукм қилинди.
      </p>

      <p>
        Human Rights Watch инсон ҳуқуқлари ташкилоти 30 май кунги{' '}
        <a href="https://www.hrw.org/news/2024/05/30/uzbekistan-imprisoned-insulting-president-online">
          баёнот
        </a>{' '}
        ида айтилишича, Бунёджон Бозоров президент Мирзиёевни интернет орқали ҳақорат қилганликда
        айбланган.
      </p>

      <p>
        Самарқанд судининг тил экспертлари хулосаси билан Бозоров президентни ҳақоратлаш ва
        конституцион тузумни ағдаришга уринишда айбдор топилган.
      </p>
    </div>
  ),
  47: (
    <div>
      <p>
        Самарқанд вилоятида туғилган, Олмалиқ шаҳрида яшовчи 28 яшар Собир Нормаматов 2024 йилнинг
        апрелида президент Мирзиёевни интернетда ҳақоратлагани учун ахлоқ тузатиш ишларига ҳукм
        қилинган.
      </p>

      <p>
        Human Rights Watch инсон ҳуқуқлари ташкилоти 30 май кунги{' '}
        <a href="https://www.hrw.org/news/2024/05/30/uzbekistan-imprisoned-insulting-president-online">
          баёнот
        </a>{' '}
        ида айтилишича, Собир Нормаматов Инстаграмда Президент Мирзиёевнинг учта видеоси ва Саида
        Мирзиёеванинг бир видеоси остида сўкингани учун 2 йилу 6 ойлик мажбурий меҳнат жазосига ҳукм
        этилган. У Президент Мирзиёевга нисбатан "масхарабоз" ва "иккиюзламачи" сўзларини қўллаган.
      </p>

      <p>
        8 апрель куни жиноят ишлари бўйича Иштихон тумани суди Нормаматовни Жиноят кодексининг
        158-моддаси 3-қисми (Ўзбекистон президентини омма олдида ҳақоратлаш ёки унга туҳмат қилиш,
        шунингдек, матбуот ёки бошқа оммавий ахборот воситаларидан, телекоммуникация тармоқларидан
        ёки Интернет бутунжаҳон ахборот тармоғидан фойдаланган ҳолда уни ҳақоратлаш ёки унга туҳмат
        қилиш) билан айбдор деб топган.
      </p>

      <p>Gazeta.uz судланувчи судда айбига иқрор бўлгани ҳақида ёзди.</p>
      <p>
        Суд Нормаматовга нисбатан иш ҳақининг 20 фоиз миқдорини давлат даромади ҳисобига ушлаб
        қолган ҳолда 2 йилу 6 ой ахлоқ тузатиш ишлари жазоси тайинланди. Суд Рақамли технологиялар
        вазирлигига Нормаматовнинг Instagram аккаунтига киришни чеклашни, шунингдек, Samsung Galaxy
        A53 телефонини давлат ҳисобига мусодара қилишни топширган.
      </p>
    </div>
  ),
  48: (
    <div>
      <p>
        2022 йил февралида 40 ёшли қашқадарёлик (исм-шарифи номаълум) шахс Ўзбекистон Республикаси
        Жиноят кодексининг 158-моддаси 3-қисми (Ўзбекистон Республикаси Президентини омма олдида
        ҳақоратлаш ёки унга туҳмат қилиш, шунингдек, матбуот ёки бошқа оммавий ахборот
        воситаларидан, телекоммуникация тармоқларидан ёки Интернет бутунжаҳон ахборот тармоғидан
        фойдаланган ҳолда уни ҳақоратлаш ёки унга туҳмат қилиш) билан айбдор деб топилиб 4 йилу 6
        ойга қамоққа ҳукм қилинган.
      </p>

      <p>
        Бу ҳақда Human Rights Watch инсон ҳуқуқлари ташкилотининг 30 май куни эълон қилган{' '}
        <a href="https://www.hrw.org/news/2024/05/30/uzbekistan-imprisoned-insulting-president-online">
          баёнот
        </a>{' '}
        да қайд қилинган.
      </p>

      <p>
        Ушбу баёнотда Human Rights Watch Ўзбекистон ҳукуматини "интернетда президентни
        ҳақоратлаганлик" учун жиноий жазони назарда тутувчи айбловни бекор қилиш ва ушбу айблов
        бўйича маҳкум этилган барча шахсларни зудлик билан озод этиш юзасидан амалий қадамлар
        қўйишга чақирди.
      </p>
    </div>
  ),
  49: (
    <div>
      <p>
        2021 йил 15 июль куни Тошкентдаги Президент Администрацияси биноси олдидан ушлаб кетилган
        мустақил блогер Озодбек Қурбонов майда безориликда айбланиб 15 суткага қамалган.
      </p>

      <p>
        “Ҳақиқат ва тараққиёт” партияси фаолларига кўра, судда блогер "ҳокимият вакилига қаршилик
        кўрсатгани" ва ходимларни "ҳақорат қилгани" айтилган.
      </p>

      <p>
        Ўзбекистон ҳуқуқ-тартибот идоралари 15 июль куни Президент Администрацияси олдида юз берган
        ҳодиса ва 23 яшар блогернинг тақдири ҳақида расмий маълумот бергани йўқ.
      </p>

      <p>
        YouTube даги "Куч бирдамликда" канали бош муҳаррири бўлган Озодбек Қурбонов ҳукуматга
        қаратилган танқидий ва “Ҳақиқат ва тараққиёт” партияси етакчиси Хидирназар Аллақулов
        фаолиятини қўллаб-қувватловчи чиқишлари билан танилган.
      </p>

      <p>
        Гувоҳларнинг айтишича, 15 июль куни блогер “Ҳақиқат ва тараққиёт” партиясининг Конституцион
        судга жамоавий аризаси топшириш жараёнини ёритаётган бўлган.
      </p>

      <p>
        Ўша куни тармоқларга жойлаштирилган видеомурожаатида “Ҳақиқат ва тараққиёт” партияси
        етакчиси, профессор Хидирназар Аллақулов Президент Администрацияси биносида жойлашган
        Конституциявий судга шикоят қилгани борганида 40-50 нафар шахслар ҳужумига учраганини даъво
        қилган.
      </p>

      <p>
        Унинг сўзларига кўра, шикоят аризаси топшириш жараёнини ёритиш учун борган блогер Озодбек
        Қурбонов номаълум шахслар томонидан машинага босиб олиб кетилган.
      </p>

      <p>
        Партия фаоллари Ўзбекистон Конституциявий суди биноси олдида ўзларига қарши уюштирилганини
        иддао қилаётган ҳужумда, уларнинг сўзларига кўра, "аксари аёллар" ва ички ишлар ходимлари
        қатнашган.
      </p>
      <p>
        "Озод Қурбоновни уриб, қўлларини қайириб, машинага тиқишиб, ўғирлаб олиб кетишди", деб
        айтган профессор Аллақулов 15 июль куни қилган видеочиқишида.
      </p>

      <p>У 23 яшар блогерга қилинган ҳужумни унинг сиёсий фаолияти билан боғлаган.</p>

      <p>
        Озодбек Қурбонов дастлаб Россияда Аллақулов тарафдорларининг имзосини тўплаган, у Тошкентга
        келганидан сўнг ҳам партия фаолиятини ёритишда давом этган. Профессор Аллақуловнинг
        сўзларига кўра, у партиянинг интернет администратори сифатида фаолият олиб борган.
      </p>
    </div>
  ),
  50: (
    <div>
      <p>
        Ўзбекистонда зиддиятли чиқишлари билан танилган диний блогер Аброр Мухтор Алий (Аброр
        Абдуазимов) ва унинг шериги экани айтилган яна бир шахс 2024 йилнинг 6 февраль куни жиноят
        ишлари бўйича Тошкент шаҳар Шайхонтоҳур тумани суди қарори билан 15 суткага қамоққа олинди.
      </p>

      <p>
        Блогер ва унинг шериклари Ўзбекистон Республикаси Маъмурий жавобгарлик тўғрисидаги
        кодексининг 194-моддаси (ички ишлар органлари ходимининг қонуний талабларини бажармаслик) ва
        195-моддасида (ички ишлар органлари ходимларининг ўз хизмат бурчларини бажаришларига
        қаршилик кўрсатиш) ифода қилинган ҳуқуқбузарликни содир этишда айбдор деб топилган.
      </p>

      <p>
        Маъмурий ҳуқуқбузарликка оид иш мазмунидан хабардор Озодлик манбасига кўра, Аброр Абдуазимов
        ва унинг шериклари шу йилнинг 5 февраль куни Тошкент шаҳар Шайхонтоҳур тумани ҳокимлиги
        яқинидаги майдончада тадбиркор Х. Н. тарафдорлари билан низони ўзаро ҳал қилиш чоғида ички
        ишлар органлари ходимларига бўйсунмаганликда айбланган.
      </p>

      <p>
        Озодлик манбасининг маълум қилишича, Аброр Абдуазимов ва шерикларига нисбатан иш судья
        Абдулла Абдулхаев томонидан 6 февраль куни соат 20.30 да кўриб чиқилган. Суд қарори билан
        Абдуазимовдан ташқари унинг шериги Хусрав Насруллаев ҳам маьмурий жавобгарликка тортилган.
      </p>

      <p>
        Ислом цивилизацияси маркази собиқ ходими, блогер Аброр Абдуазимов 2023 йил февралида блогер
        Никита Макаренкога туҳмат қилганликда айбланиб, суд қарори билан 500 долларга яқин жаримага
        тортилган эди.
      </p>

      <p>
        Аввалроқ 7,5 йилга озодликдан маҳрум қилинган ва ўтган йил охирида озодликка чиққан блогер
        Фозилхўжа Орифхўжаев Аброр Мухтор Алий билан тортишувдан сўнг ҳибсга олингани хабар қилинган
        эди.
      </p>

      <p>
        Аброр Абдуазимовнинг 2022 йил январида 3 йилга озодлиги чекланган бошқа блогер – Миразиз
        Бозоровнинг ишига ҳам алоқаси борлиги айтилади.
      </p>

      <p>
        Ўзбекистонда танқидий чиқишлари учун кўплаб блогер ва журналистлар қамалаётгани ва жаримага
        тортилаётганига қарамай, YouTube тармоғида 700 мингдан зиёд обуначига эга ва тез-тез
        провокацион постлар жойлайдиган Аброр Абдуазимов 2023 йил февралига қадар бирор марта
        судланган эмас.
      </p>

      <p>
        Аброр Мухтор Алий озодликка чиқарилгани тўғрисида Kun.uz ўз манбасига таянган ҳолда 2024 йил
        21 февралида
        <a href="https://kun.uz/kr/news/2024/02/21/bloger-abror-abduazimov-ozodlikka-chiqdi">
          &#xa0;хабар берди.
        </a>
      </p>
    </div>
  ),
  51: (
    <div>
      <p>
        “Бургут бола” тахаллуси билан блогерлик қилган Сундар Қорабоев айни пайтда Маданият
        объектларини муҳофаза қилиш департаменти бошлиғи вазифасида фаолият юритган.
      </p>

      <p>
        У 2021 йил 16 март куни Тошкент шаҳар, Юнусобод туман Маъмурий суди қарори билан Маъмурий
        жавобгарлик тўғрисидаги кодекснинг 183-моддасида (майда безорилик) назарда тутилган қилмишни
        содир этганликда айбдор деб топилиб, 10 кунлик қамоққа ҳукм қилинган.
      </p>

      <p>
        Суд вакилига кўра, Сундар Қорабоев 2021 йил 15 март куни Тошкент шаҳридаги “Уголок” кафесида
        хўранда аëлнинг тинчини бузиб жанжал фигуранти бўлганлиги маҳкама жараëнида аниқланган.
      </p>

      <p>
        Унинг укаси Ахримаз Қорабоев акаси “шантаж қурбони” бўлгани, акасини қамаган судда
        процессуал қоидалар бузилганини айтган.
      </p>

      <p>
        Қорабоевни яқиндан таниган Ўзбекистон Маданият вазирлигидаги мулозимнинг Озодликка иддао
        қилишича, ”Сундарнинг Бургут бола тахаллуси билан Зомин туманидаги муаммоларни ҳажв қилгани”
        туман ҳокимлигига ëқмаган.
      </p>

      <p>
        Блогер Қорабоевнинг видеолавҳаларидан бирида улкан газ баллонини елкасида кўтарган кампир
        билан суҳбати акс этган. Суҳбатда тумандаги газ муаммоси ҳажв қилинади.
      </p>

      <p>
        Сундар Қорабоев Зомин экологияси ва қадимий обидаларини ҳимоя қилиб мунтазам чиқишлар
        қилган. Қорабоев нафақат Жиззах, балки бутун республикадаги қадимий обидалар ҳимояси бўйича
        Озодликка суҳбатлар берган. Қорабоев қадимий обидаларнинг “Вақф” фондига ўтказилгани ортидан
        талон-торож бўлгани ҳақида матбуотда жиддий танқидий чиқишлар қилган.
      </p>

      <p>
        Ижтимоий тармоқ фаоллари Сундар Қорабоевнинг қамоққа олинишини уюштирилган, деб ҳисоблайди.
      </p>
    </div>
  ),
  52: (
    <div>
      <p>
        Ҳайдаржон Бобоҳайдаров –&#xa0; Youtube тармоғида 800 мингдан ортиқ обуначиси бўлган сўхлик
        видеоблогер. У “Дадахон Ҳайдаров” тахаллуси билан танилган.
      </p>

      <p>
        Дадахон Ҳайдаров 2020 йил 31 май куни Фарғона вилояти Сўх туманида рўй берган
        тартибсизликлар ортидан ҳибсга олинган. Унга нисбатан Жиноят кодексининг 219-моддаси
        (ҳокимият вакилига ёки фуқаровий бурчини бажараётган шахсга қаршилик кўрсатиш) ва
        214-моддаси (оммавий тартибсизликлар) бўйича жиноят иши очилган.
      </p>

      <p>
        2020 йилнинг 31 май куни Ўзбекистоннинг Сўх тумани Чашма қишлоғининг ҳудудидаги
        Қирғизистоннинг Боткен вилояти Кадамжай тумани Чечме айили билан чегарада жойлашган Чашма
        булоғи бўйида икки давлат фуқаролари ўртасида оммавий жанжал содир бўлган.
      </p>

      <p>
        Ҳайдаржон Бобоҳайдаров чегарада содир бўлган низодан сўнг туманга борган Бош вазир А. Арипов
        билан учрашувда Фарғона ҳокими Шуҳрат Ғаниевни алмаштиришни сўраган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/LeurTcv1djU?si=jkBuuXPwI7GsEbvg"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>Блогернинг ҳибсга олиниши тармоқларда эътирозларга сабаб бўлган.</p>

      <p>
        2020 йил 2 сентябрь куни Бош прокуратура Ҳайдаржон Бобоҳайдаровни "ушлаб туриш учун етарли
        асос бўлмагани учун" у қамоқдан озод қилинганини маълум қилган.
      </p>
    </div>
  ),
  53: (
    <div>
      <p>
        “Sardor gangster” тахаллуси билан TikTok ва YouTube платформаларида танилган блогер Сардор
        Сафарбоев 2024 йил 21 февраль куни 10 суткага қамалган.
      </p>

      <p>
        Қашқадарё вилояти судлари матбуот хизмати{' '}
        <a href="https://t.me/qashqadaryoviloyatisudlari/8597">маълум қилишича,</a> Сардор Сафарбоев
        жиноят ишлари бўйича Нишон туман судининг 2024 йил 21 февралдаги қарори билан Маъмурий
        жавобгарлик тўғрисидаги кодекснинг 183-моддаси (майда безорилик) ва 184−3-моддаси (миллий,
        ирқий, этник ёки диний адоватни тарғиб қилувчи материалларни тайёрлаш, сақлаш ёки тарқатиш)
        асосида айбдор деб топилган.
      </p>

      <p>
        Билдирувда қайд этилишича, 26 ёшли Сардор Сафарбоев вақтинча ишсиз бўлган. Унга юқоридаги
        айбловлар асосида 10 сутка маъмурий қамоқ жазоси тайинланган.
      </p>

      <p>
        2024 йил 23 февралида Қашқадарё вилоят судининг жиноят ишлари бўйича судлов ҳайъати
        Сафарбоевнинг шикоятини апелляция тартибида кўриб чиқди ва биринчи инстанция судининг
        қарорини ўзгартиришсиз қолдирди.
      </p>
    </div>
  ),
  54: (
    <div>
      <p>Умид Каримов – қашқадарёлик журналист, Nasaf News сайти раҳбари.</p>

      <p>
        2023 йил 30 май куни Қашқадарё вилоят жиноят ишлари бўйича Шаҳрисабз шаҳар суди Умид Каримов
        ва қашқадарёлик икки блогерни майда безориликда айбдор деб топиб, ҳар бирини 5 суткага
        қамаган.
      </p>

      <p>
        ИИБ журналист ва блогерлар “ИИБ ходимларига нисбатан қўполлик қилиб, уларга ҳурматсизлик ва
        беписандлик қилган”и, Шаҳрисабз шаҳар ИИБ бошлиғининг ўринбосари Ж. Рауповни “фуқаролар
        олдида обрўсизлантирган”ини иддао қилган.
      </p>

      <p>
        Ушбу ҳибс ортидан Умид Каримов Nasafnews.uz нашри билан биргаликда ўзи муаллифлик қилаётган
        “Капитан Каримов” блоги бундан буён ишламаслигини очиқлаган ва Газета.uz нашрига берган
        интервьюсида бунга суд пайтида кузатилган адолатсизликлар сабаб бўлганини айтган.
      </p>

      <p>
        “Бекорга 5 сутка бериб, чиқариб юборди. Фаолиятимни шунинг учун тугатмоқчиман”, деган У.
        Каримов.
      </p>
    </div>
  ),
  55: (
    <div>
      <p>Мақсуд Музаффаров – қашқадарёлик блогер, AvtoblogUz канали муаллифи.</p>

      <p>
        2023 йил 30 май куни Қашқадарё вилоят жиноят ишлари бўйича Шаҳрисабз шаҳар суди Мақсуд
        Музаффаров ва қашқадарёлик бир блогер ҳамда журналистни майда безориликда айбдор деб топиб,
        ҳар бирини 5 суткага қамаган.
      </p>

      <p>
        ИИБ журналист ва блогерлар “ИИБ ходимларига нисбатан қўполлик қилиб, уларга ҳурматсизлик ва
        беписандлик қилган”и, Шаҳрисабз шаҳар ИИБ бошлиғининг ўринбосари Ж. Рауповни “фуқаролар
        олдида обрўсизлантирган”ини иддао қилган.
      </p>

      <p>
        Ушбу ҳибс ортидан Умид Каримов Nasafnews.uz нашри билан биргаликда ўзи муаллифлик қилаётган
        “Капитан Каримов” блоги бундан буён ишламаслигини очиқлаган ва Газета.uz нашрига берган
        интервьюсида бунга суд пайтида кузатилган адолатсизликлар сабаб бўлганини айтган.
      </p>
      <p>
        “Бекорга 5 сутка бериб, чиқариб юборди. Фаолиятимни шунинг учун тугатмоқчиман”, деган У.
        Каримов.
      </p>

      <p>Ушбу ҳибс ортидан Мақсуд Музаффаров блогерлик фаолиятини якунлашини билдирган.</p>

      <p>
        “Ҳақиқат йўқлигини кўзим билан кўрдим. Фаолиятни давом эттиришим учун ҳимоя йўқ эканини
        кўрдим. Шу ишлар кўзимни очди”, деган М. Музаффаров.
      </p>

      <p>
        Музаффаров билан бирга қамалган қашқадарёлик икки йигит ҳам ҳибсдан сўнг блогерликни
        тўхташини эълон қилишган.
      </p>
    </div>
  ),
  56: (
    <div>
      <p>
        Адҳам Олимов – “Мусанниф Адҳам” тахаллуси остида диний мавзуларда ёзувчи тошкентлик блогер.
      </p>

      <p>
        У 2018 йил 28 августдан 2 сентябргача бўлган оралиқда ҳибсга олинган ўнга яқин блогердан
        бири.
      </p>

      <p>
        Адҳам Олимов 2018 йил 28 август куни Тошкент туман Олмазор туман милициясига олиб кетилган.
        Кейинроқ уни Олмазор туман суди милиция ходимининг қонуний талабини бажармаганликда айбдор
        деб топиб, 15 суткага қамагани аниқланган. Бироқ бир неча кун давомида яқинлари унинг қаерда
        сақланаётганини аниқлай олишмаган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/cxp22rxli6E?si=Qk1rH-5f1rPrZU4F"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси (CPJ) 2018 йил 6
        сентябрида тарқатган баёнотида Ўзбекистон ҳукуматини ижтимоий ва диний мавзуларни ёритаётган
        блогерлар, жумладан, Адҳам Олимовни таъқиб қилишни тўхтатишга чақирган. Шунингдек, қўмита
        диний мавзуни ёритгани учун ҳибс қилинган блогерларни озод қилишни талаб этган.
      </p>

      <p>
        Мусанниф Адҳам 2018 йил 11 сентябрь куни жазо муддатини ўтаб бўлгани ортидан озодликка
        чиқарилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/gMwbjTt3_r4?si=i6WacOGEN0MKFTjr"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Ўша пайтда Ўзбекистондаги қатор блогерларнинг ҳибсга олиниши ижтимоий тармоқларнинг ўзбек
        контентида норозиликларга сабаб бўлган. Ҳибсдаги ўзбек блогерлари ҳимояси учун имзо йиғиш
        кампанияси ўтказилган.
      </p>
    </div>
  ),
  57: (
    <div>
      <p>
        2022 йил 11 ноябрь куни Тошкентнинг Миробод тумани суди “одоб-ахлоқ қоидаларига зид бўлган”
        видео ва расмларни ижтимоий тармоқларда тарқатган 21 ёшли блогер Севинч Саъдуллаевани
        Маъмурий жавобгарлик тўғрисидаги кодекснинг 183-моддасида (майда безорилик) назарда тутилган
        ҳуқуқбузарликни содир этган деб топди ва уни 5 суткага қамаган.
      </p>

      <p>
        Суд ҳукмига кўра, блогер ижтимоий тармоқларда ўзи иштирокидаги видео ва расмларни
        <i>
          “жамиятда юриш туриш қоидаларини қасддан менсимасдан жойлаштириб, жамоат тартибини бузиб,
          фуқароларнинг ўринли эътирозларига сабабчи бўлган”.
        </i>
      </p>

      <p>
        2022 йил 15 ноябрь куни Тошкент шаҳар судининг жиноят ишлари бўйича судлов ҳайъати апелляция
        инстанциясида блогернинг апелляция шикояти кўриб чиқилган ва 5 сутка маъмурий қамоқ жазосини
        4 суткалик қамоқ жазосига ўзгартириш ҳақида ажрим чиқарган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/uB0ksh86JsA?si=y9m5537kYuAXSs-7"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Газета.uz нашри хабарига кўра, блогер устидан суд Тошкент шаҳар Оила ва хотин-қизлар
        бошқармаси бошлиғи Нодира Умарова аризаси асосида ўтказилган.
      </p>

      <p>
        Бу каби хабарлар ОАВда чиқиши ортидан ижтимоий тармоқларда блогернинг қамалиши қизғин
        баҳс-мунозараларга сабаб бўлган, кўплаб фойдаланувчилар Севинч Саъдуллаевага нисбатан кескин
        жазо чораси қўлланилгани юзасидан эътироз билдиришган, ҳуқуқшунослик соҳасидан хабардор
        айрим блогерлар эса Ўзбекистонда “жамиятда юриш-туриш қоидаларини тартибга солувчи
        нормативлар”нинг ўзи йўқлигига эътибор қаратишган.
      </p>
    </div>
  ),
  58: (
    <div>
      <p>
        2020 йил 27 май куни Фарғона вилоят телевидениеси мухбири ва блогер Усмонжон Қодировга
        МЖтКнинг 54-моддаси 1-қисми, 183-моддаси ва 194-моддаси 1-қисми билан 15 сутка муддатга
        маъмурий қамоқ жазоси тайинланган.
      </p>

      <p>
        У Фарғона вилоят ҳокимлиги биноси олдида ниқоб тақмаганлик ва ИИБ ходимига қаршилик
        кўрсатганликда айбланган эди.
      </p>

      <p>
        2020 йил 29 май куни Усмонжон Қодировга нисбатан Фарғона шаҳар маъмурий судининг дастлабки
        қарорини ўзгартирган ва 15 кунлик маъмурий қамоқ муддати 2 кунга алмаштирилган.
      </p>

      <p>
        Газета. uz хабарига мувофиқ, кассация инстанцияси биринчи инстанция суди Усмонжон Қодировга
        нисбатан жазо тайинлашда айбига иқрорлигини, чин кўнгилдан пушаймонлигини, оилада ягона
        боқувчи эканлигини инобатга олмай, бир мунча оғир жазо тайинлаганини эътироф этган.
      </p>

      <p>
        Маҳаллий сайтларда журналист Усмонжон Қодиров ижтимоий тармоқда “исталмаган мавзу”да фикр
        билдиргани сабаб қамалгани ҳақида муҳокамалар ўртага чиққан.&#xa0;
      </p>

      <p>
        Жумладан, ёш журналист ва блогер
        <i>
          "Фарғона вилоятида Президент ташрифига тайёргарлик юқори даражада. Лекин, карантин
          вақтида, иссиқ ҳавода завод ходимларининг «хашар» га чиққани ачинарли. Фарғона Нефтни
          қайта ишлаш заводининг йўлида ходимлар меҳнатда. Улар қайси завод ишчилари эканлигига
          ойдинлик кирита олмадик. Чунки у ерда заводлар кўп… Қачонгача бундай ишлар давом этади.
          Қонуний йўл билан, ҳеч кимни мажбур қилмасдан қилиш мумкинми бундай ишларни? Ёки биз
          рахбарлар айтмаса, ён атрофимизни тоза, покиза қилмаймизми? Албатта катта раҳбар келса,
          шунга тайёрланиш керакми?
        </i>
        " дея ёзгани учун жазога тортилгани ҳақида қарашлар илгари сурилган.
      </p>
    </div>
  ),
  59: (
    <div>
      <p>
        Оддий андижонликлар муаммоларини ижтимоий тармоқларга муҳокамага олиб чиққан блогер Жўрабек
        Қимизов 2020 йил 26 февралда Пахтаобод туман ички ишлар ходимлари томонидан ҳибсга олинган.
        Унга фирибгарлик айби қўйилган.
      </p>

      <p>
        Жўрабек Қимизовнинг Уйғур қишлоғидаги уйида туман Ички ишлар ходимлари томонидан 2020 йил 4
        март куни тинтув ҳам ўтказилган.
      </p>

      <p>
        Жўрабекнинг хотини Озодлик билан суҳбатда эрининг қамалишига унинг "маҳаллий ҳокимиятни
        танқид қилиб чиққани сабаб бўлди" деган.
      </p>

      <p>
        Жўрабек Қимизов ўз вақтида Ўзбекистон чегарасидаги божхона пунктидаги вазият тўғрисидаги
        танқидий фикрларини Озодликка билдирган, у шунингдек, Москвада Ўзбекистон ҳукуматидан 2020
        йил 1 январида жорий қилинган чегара божини олиб ташлашни сўраб чиққан бир гуруҳ
        ўзбекистонлик такси ҳайдовчилари орасида ҳам бор эди.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/29QUP-QF-t8?si=omaFSIAeTY57jfJB"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Жўрабек 2018 йилда "Adolat TV" номли канал очиб, видеоблогерлик бошлаган. Унинг видеолари,
        хусусан, маҳаллий муаммоларни ёритишга бағишланган.
      </p>
    </div>
  ),
  60: (
    <div>
      <p>Наргиза Келдиёрова - Қашқадарёдаги ижтимоий муаммоларни ёритиб келган блогер.</p>

      <p>
        2024 йил 28 февралда Қашқадарё вилояти Қарши шаҳар судининг ёпиқ суд мажлисида Наргиза
        Келдиёрова ва қашқадарёлик яна икки блогер Дилдора Ҳакимова ҳамда Шукрулла Парпиевни қамоққа
        олишга санкция берилган.
      </p>

      <p>
        Уч нафар блогерга нисбатан Қашқадарё вилояти ИИБ томонидан Ўзбекистон Республикаси Жиноят
        Кодексининг 165-моддаси 3-қисми (товламачилик) билан жиноят иши қўзғатилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/UzZQYYEdks8?si=Gjovvq7RMq2_TOQf"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Айбланувчиларнинг қариндошларига кўра, блогерларга нисбатан Қашқадарё вилояти ҳуқуқни
        муҳофаза қилиш органлари томонидан бир неча йилдан бери тузоқ қўйилган ва сохта
        жабрланувчилар ясалган.
      </p>

      <p>
        Блогерлар ишида жабрланувчи сифатида ўтаётган шахсларнинг аксарияти уларнинг хизматидан
        фойдаланган, уларнинг ҳимоясида бўлган.
      </p>
    </div>
  ),
  61: (
    <div>
      <p>
        2024 йил 28 февралда Қашқадарё вилояти Қарши шаҳар судининг ёпиқ суд мажлисида Шукрулла
        Парпиев ва қашқадарёлик яна икки блогер Дилдора Ҳакимова ҳамда Наргиза Келдиёровани қамоққа
        олишга санкция берилган.
      </p>

      <p>
        Уч нафар блогерга нисбатан Қашқадарё вилояти ИИБ томонидан Ўзбекистон Республикаси Жиноят
        Кодексининг 165-моддаси 3-қисми (товламачилик) билан жиноят иши қўзғатилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/UzZQYYEdks8?si=Gjovvq7RMq2_TOQf"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Айбланувчиларнинг қариндошларига кўра, блогерларга нисбатан Қашқадарё вилояти ҳуқуқни
        муҳофаза қилиш органлари томонидан бир неча йилдан бери тузоқ қўйилган ва сохта
        жабрланувчилар ясалган.
      </p>

      <p>
        Блогерлар ишида жабрланувчи сифатида ўтаётган шахсларнинг аксарияти уларнинг хизматидан
        фойдаланган, уларнинг ҳимоясида бўлган.
      </p>
    </div>
  ),
  62: (
    <div>
      <p>
        2024 йил 28 февралда Қашқадарё вилояти Қарши шаҳар судининг ёпиқ суд мажлисида Дилдора
        Ҳакимова ва қашқадарёлик яна икки блогер Шукрулла Парпиев ҳамда Наргиза Келдиёровани қамоққа
        олишга санкция берилган.
      </p>

      <p>
        Уч нафар блогерга нисбатан Қашқадарё вилояти ИИБ томонидан Ўзбекистон Республикаси Жиноят
        Кодексининг 165-моддаси 3-қисми (товламачилик) билан жиноят иши қўзғатилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/UzZQYYEdks8?si=Tnoqz3F5xL61kDQa"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Айбланувчиларнинг қариндошларига кўра, блогерларга нисбатан Қашқадарё вилояти ҳуқуқни
        муҳофаза қилиш органлари томонидан бир неча йилдан бери тузоқ қўйилган ва сохта
        жабрланувчилар ясалган.
      </p>

      <p>
        Блогерлар ишида жабрланувчи сифатида ўтаётган шахсларнинг аксарияти уларнинг хизматидан
        фойдаланган, уларнинг ҳимоясида бўлган.
      </p>
    </div>
  ),
  63: (
    <div>
      <p>
        Зиёдулла Кабиров ижтимоий тармоқларда “Зиёвуддин Раҳим” тахаллуси билан танилган диний
        блогер.
      </p>

      <p>
        У 2018 йил 28 августдан 2 сентябргача бўлган оралиқда ҳибсга олинган ўнга яқин блогердан
        бири.
      </p>

      <p>
        З.Кабиров "милиция ходимларининг қонуний талабларини бажармаслик ва уларга қаршилик
        кўрсатишда айбдор деб топилган" ва 10 сутка маъмурий қамоқ ва энг кам иш ҳақининг бир
        баравари, яъни 184.300 сўм миқдорида жаримага ҳукм қилинган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/cxp22rxli6E?si=XlFq9yas2MOEoDh9"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси (CPJ) 2018 йил 6
        сентябрида тарқатган баёнотида Ўзбекистон ҳукуматини ижтимоий ва диний мавзуларни ёритаётган
        блогерлар, жумладан, Зиёвуддин Раҳимни таъқиб қилишни тўхтатишга чақирган. Шунингдек, қўмита
        диний мавзуни ёритгани учун ҳибс қилинган блогерларни озод қилишни талаб этган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/gMwbjTt3_r4?si=8j0g-j8u-L3dIhWd"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Ўша пайтда Ўзбекистондаги қатор блогерларнинг ҳибсга олиниши ижтимоий тармоқларнинг ўзбек
        контентида норозиликларга сабаб бўлган. Ҳибсдаги ўзбек блогерлари ҳимояси учун имзо йиғиш
        кампанияси ўтказилган.
      </p>
    </div>
  ),
  64: (
    <div>
      <p>
        Андижонлик блогер Отабек Усмонов 2018 йил 28 августдан 2 сентябргача бўлган оралиқда ҳибсга
        олинган ўнга яқин блогердан бири.
      </p>

      <p>
        Отабек Усмонов бир қатор блогерлар каби "милиция ходимларининг қонуний талабларини
        бажармаслик ва уларга қаршилик кўрсатишда айбдор деб топилган" ва 15 суткага ҳибс этилган.
      </p>

      <p>
        О.Усмоновни яқиндан таниганлар унинг 2018 йил 30 август куни олиб кетилгани ва орадан
        бир&#xa0; ўтиб, унинг устидан ҳукм ўқилганини айтган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/cxp22rxli6E?si=OM_ZIs3RVznjGYxl"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси (CPJ) 2018 йил 6
        сентябрида тарқатган баёнотида Ўзбекистон ҳукуматини ижтимоий ва диний мавзуларни ёритаётган
        блогерлар, жумладан, Отабек Усмоновни таъқиб қилишни тўхтатишга чақирган. Шунингдек, қўмита
        диний мавзуни ёритгани учун ҳибс қилинган блогерларни озод қилишни талаб этган.
      </p>

      <p>
        “Таҳлил шуни кўрсатмоқдаки, Ўзбекистон сўз эркинлиги вазиятни яшилаш масаласида жиддий
        ҳаракатларни қилмаяпти. Ҳукумат қўлга олинган блогерларни озод қилиши ва журналистларга
        ўзбек жамияти учун муҳим бўлган мавзуларни шарҳлашга имконият яратиб бериши лозим”, деган
        ўша пайтда Журналистларни ҳимоя қилиш қўмитасининг Европа ва Марказий Осиё бўйича
        тадқиқотчиси Гулноза Саид.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/gMwbjTt3_r4?si=2PnfhE4KKtWPeh8Q"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Ўша пайтда Ўзбекистондаги қатор блогерларнинг ҳибсга олиниши ижтимоий тармоқларнинг ўзбек
        контентида норозиликларга сабаб бўлган. Ҳибсдаги ўзбек блогерлари ҳимояси учун имзо йиғиш
        кампанияси ўтказилган.
      </p>
    </div>
  ),
  65: (
    <div>
      <p>Хуршидбек Муҳаммадрозиқов – қўқонлик блогер, хусусий мактаб асосчиси.</p>

      <p>
        У 2018 йил 28 августдан 2 сентябргача бўлган оралиқда ҳибсга олинган ўнга яқин блогердан
        бири.
      </p>

      <p>
        Хуршидбекнинг онасининг Озодликка айтишича, ўғли 2018 йил 2 сентябрида "милиция ходимлари
        билан гап талашиб қолгани учун" уни "ичкарига олиб кириб қўйишган".
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/cxp22rxli6E?si=ezm0mZZuA0GbQxDX"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси (CPJ) Ўзбекистон
        ҳукуматини ижтимоий ва диний мавзуларни ёритаётган блогерларни таъқиб қилишни тўхтатишга
        чақирган. Шунингдек, қўмита диний мавзуни ёритгани учун ҳибс қилинган камида тўрт нафар
        блогерни озод қилишни талаб этган.
      </p>

      <p>
        CPJ баёнотида Адҳам Олимов, Зиёдулла Кабиров, Отабек Усмонов қаторида Хуршидбек
        Мухаммадрозиқовнинг ҳам исми келтирилган.
      </p>

      <p>
        Ўша пайтда Ўзбекистондаги қатор блогерларнинг ҳибсга олиниши ижтимоий тармоқларнинг ўзбек
        контентида норозиликларга сабаб бўлган. Ҳибсдаги ўзбек блогерлари ҳимояси учун имзо йиғиш
        кампанияси ўтказилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/gMwbjTt3_r4?si=QfG1OlTPctuu3buX"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2018 йил 6 сентябрь куни ўзбек расмий матбуотида “Интернет тармоғи веб-сайтидан ва (ёки)
        веб-сайт саҳифаларидан фойдаланишни чеклаш тартиби тўғрисидаги низом” эълон қилинган.
      </p>

      <p>
        Унга кўра¸ “Тақиқланган ахборот мавжуд бўлган бутунжаҳон Интернет тармоғидаги ахборот
        ресурслари реестри юритилади ва реестрга киритилган ахборот ресурсларидан фойдаланиш
        чекланади”.
      </p>

      <p>
        Бироқ ўзбекистонлик фаоллар бу баҳонада ҳукумат ўзгача фикрдаги ресурсларни ҳам таъқиб
        остига олишидан хавотир билдирган.
      </p>
    </div>
  ),
  66: (
    <div>
      <p>
        Миразиз Аҳмедов- 2018 йил 28 августдан 2 сентябргача бўлган оралиқда ҳибсга олинган ўнга
        яқин блогердан бири.
      </p>

      <p>Тошкентлик блогер Миразиз Аҳмедов асосан, диний мавзуларда ёзиб келган.</p>

      <p>
        Ўша вақтда Озодлик айрим диндор блогерлар ва уларнинг яқинлари билан қилган суҳбатлар
        асносида милиция ва хавфсизлик ходимлари уларни жиддий огоҳлантиргани ёки қўрқитганини
        аниқлаган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/cxp22rxli6E?si=3GKK-AtERuyUfqzb"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси (CPJ) 2018 йил 6
        сентябрида тарқатган баёнотида Ўзбекистон ҳукуматини ижтимоий ва диний мавзуларни ёритаётган
        блогерларни таъқиб қилишни тўхтатишга чақирган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/gMwbjTt3_r4?si=A6oO66kTp5u8JAJN"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Ўша пайтда Ўзбекистондаги қатор блогерларнинг ҳибсга олиниши ижтимоий тармоқларнинг ўзбек
        контентида норозиликларга сабаб бўлган. Ҳибсдаги ўзбек блогерлари ҳимояси учун имзо йиғиш
        кампанияси ўтказилган.
      </p>
    </div>
  ),
  67: (
    <div>
      <p>
        Наманганлик блогер Дилшод Халилов 2018 йил август ва сентябрь ойларида давом этган “блогер
        ови” доирасида қамалган ва маъмурий жазога ҳукм қилинган.
      </p>

      <p>
        Дилшод Халилов 2018 йил 11 сентябрь куни кечга яқин ҳибсдан қўйиб юборилгани хабар қилинган.
      </p>

      <p>
        Ўша пайтда Ўзбекистондаги қатор блогерларнинг ҳибсга олиниши ижтимоий тармоқларнинг ўзбек
        контентида норозиликларга сабаб бўлган. Ҳибсдаги блогерлар ҳимояси учун петиция эълон
        қилинган.
      </p>

      <p>
        Қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси (CPJ) 2018 йил 6
        сентябрда Ўзбекистон ҳукуматини ижтимоий ва диний мавзуларни ёритаётган блогерларни таъқиб
        қилишни тўхтатишга чақирган.
      </p>
    </div>
  ),
  68: (
    <div>
      <p>
        Наманганлик блогер Тўрабек Боймирзаев 2018 йил 27 август куни аввалига ғойиб бўлган,
        кейинчалик унинг 15 суткага қамалгани айтилган. Суд тафсилотлари Озодликка маълум эмас.
      </p>
    </div>
  ),
  69: (
    <div>
      <p>
        2018 йили Ўзбекистоннинг биринчи президенти қизлари ва мамлакат Бош вазири ҳақида Faсebook
        тармоғида “ножоиз” гап айтгани боис ижтимоий тармоқнинг ўзбек сегменти фаоли, наманганлик
        Аббос Насриддиновга қарши маъмурий иш очилган. Иш 2018 йил февраль ойида Наманган шаҳар
        маъмурий судида кўрилган.
      </p>

      <p>
        Наманган шаҳар маъмурий суди мулозимининг Озодлик мухбирига айтишича¸ Насриддинов Маъмурий
        жавобгарлик тўғрисидаги Кодекснинг 40- моддаси (туҳмат қилиш)¸ ва 41- моддаси (ҳақорат
        қилиш) бўйича гумонланиб иши судга оширилган.
      </p>

      <p>
        Мулозимга кўра¸ мазкур “иш” namnews.uz портали ижрочи директори ва Ëшлар Иттифоқи Наманган
        шаҳар кенгаши раҳбари Анвар Икромовнинг аризасига биноан очилган.
      </p>

      <p>
        Мулозимнинг яна айтишича, “Аббос Асад", деган ном остида ФБ юзери бўлган Аббос
        Насриддиновнинг тармоқда қолдирган ëзувлари беш кишилик экспертлар гуруҳи тарафидан
        текширилган ва “матнда ҳақорат ва туҳмат аломатлари бор” деган хулоса судга тақдим қилинган.
      </p>

      <p>
        Мулозимнинг таъкидича, “Насриддинов биринчи президентнинг қизлари шаънига ножоиз гапни ва
        “Бош вазир Арипов кетсин” деган чақириқни ўз саҳифасига жойлаштирган.
      </p>

      <p>
        Блогер Аббос Насриддинов 2018 йил 21 февраль куни Озодлик билан суҳбатда сўз эркинлиги
        доирасидан чиқмагани ва бу айбловларнинг асоссиз эканлигини айтган.
      </p>

      <p>
        <i>
          “Журналист Алишер Таксановнинг Фейсбукдаги “Мне не жалко Шерзода Кудратходжаева”, деган
          мақоласини ўзбек тилига таржима қилиб ўзимнинг ва унинг профилига қўйганман. Бундан
          ташқари, Халқаро Пресс Клубнинг онлайн кўрсатувлари тақиқланганида Арипов кетсин! деган
          пост қўйганман. Иннайкейин, менинг устимдан МХХга ариза ëзган Анвар Икромов Фейсбукда
          Каримовни мақтаб пост қўйганида, Каримов давлатга 8 трлн. сўм моддий зарар етказган
          қизларни тарбиялаб вояга етказган, деб шарҳ қўйганман”
        </i>{' '}
        деган <a href="https://www.ozodlik.org/a/ozbekiston-bloger-sud/29053881.html">ўша пайтда</a>{' '}
        кекса блогер.
      </p>

      <p>
        2006 йили “чегарани ноқонуний кесиб ўтганлиги” учун 6 ой қамоқ жазоси олган Аббос
        Насриддинов Озодлик билан суҳбатда “Аслида бу Fergana.ru нашрида чоп қилган мақолаларим учун
        ҳукуматнинг ўч олишидир”, деган эди.
      </p>
    </div>
  ),
  70: (
    <div>
      <p>
        Ўзбекистонлик таниқли блогер, журналист ва иқтисод фанидан дарс берган ўқитувчи Ҳаёт Хон
        Насриддинов (Ҳаётхон Ғайратович Насриддинов) 2017 йил тахминан 20 октябрь куни МХХ томонидан
        ҳибсга олинган. Тошкентлик мустақил журналист Алексей Волосевич блогер МХХнинг ҳибсхонасига
        жойлаштирилганини айтган.&#xa0;
      </p>

      <p>
        Ҳаёт Хон Насриддинов Фарғона.ру нашри учун ўз исми билан 15 га яқин жиддий таҳлилий
        мақолалар ёзган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/9T_lfhH8tEc?si=j4x5EBs7n9QGxAVN"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        "Уни журналист, деб ҳисоблайман", дея баҳо берган Фарғона.ру ахборот агентлиги бош муҳаррири
        Данил Кислов.
      </p>

      <p>
        2017 йил 13 февраль куни инсон ҳуқуқлари ҳимояси билан шуғулланувчи 12 та халқаро ташкилот
        Ўзбекистон ҳукуматини ҳибсдаги журналист ва блогерлар, жумладан, Ҳаёт Насриддиновни зудликда
        қамоқдан озод этишга чақирган.
      </p>

      <p>
        2017 йил 13 февраль куни эълон қилинган баёнотда Бобомурод Абдуллаевга нисбатан қийноқ
        қўллаганликда гумонланган ҳуқуқ-тартибот ходимларига нисбатан тергов олиб борилиши ҳам талаб
        қилинган.
      </p>

      <p>
        Баёнот Amnesty International, Марказий Осиё Инсон ҳуқуқлари ассоциацияси, Фуқаролик
        ҳуқуқлари ҳимоячилари, Журналистларни ҳимоя қилиш қўмитаси, Freedom House, Human Rights
        Watch, Инсон ҳуқулари бўйича халқаро ҳамкорлик, Норвегия Хельсинки қўмитаси, Чегарасиз
        мухбирлар, Бугун озод этилиш учун, 19-модда ва Инсон ҳуқуқлари бўйича Ўзбекистон-Германия
        форуми томонидан имзоланган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/eWajRlNEIfc?si=mnuZX6KTtv4oRjPE"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Насриддинов иқтисод фани бўйича олий таълим олган. Кейинчалик Япония ва Жанубий Кореяда
        малака оширган, иқтисод фанлари номзоди, банк иши бўйича 30 тадан ортиқ илмий мақола
        муаллифидир. Сўнгги йилларда Тошкентдаги 94-сонли мактабда дарс берган.
      </p>

      <p>
        Ҳаёт Хон Насриддинов Озодлик радиоси рус хизмати - Радио Свободага ҳам 30 дан ортиқ
        мақолалар ёзган. Унинг сўнгги мақоласи 2012 йилда чоп этилган. Ўз мақолаларида у
        Ўзбекистоннинг ижтимоий-сиёсий-иқтисодий ҳаёти, Россиядаги ўзбекистонлик муҳожирлар ҳаётига
        оид актуал мавзуларни кўтарган, таҳлил қилган.
      </p>
    </div>
  ),
  71: (
    <div>
      <p>
        Ютуб, Инстаграм ва Телеграмдаги Аччиқ ТВ канали асосчиси ва раҳбари 25 яшар блогер
        Камолиддин Ҳалимжонов 2024 йил 2 май куни Қозоғистоннинг Чимкент вилояти&#xa0; ички ишлар
        ходимлари томонидан қамоққа олинган.
      </p>

      <p>
        Бу ҳақда яқинларига хабар беришга улгурган Камолиддиннинг айтишича, у Ўзбекистон томони
        сўровига биноан ҳибсга олинган ва Чимкентдаги ички ишлар бошқармасида сақланган. Камолиддин
        Ҳалимжонов Ўзбекистонга бериб юборилиши ҳақида огоҳлантирилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/Lbf0L6N57d0?si=W5viWbSsQSWtENtC"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Ўзбекистонлик аксарият блогерлар бугун маиший мавзулардан четга чиқа олмаётган бир пайтда,
        Аччиқ ТВ инсон ҳуқуқларининг поймол этилаётгани, халқнинг иқтисодий аҳволи оғирлашаётгани,
        газ ва электр энергиясининг қимматлагани ва бошқа долзарб&#xa0; мавзуларни&#xa0; мунтазам
        ёритиб келган.
      </p>
    </div>
  ),
  72: (
    <div>
      <p>
        2024 йил 19 июнь куни Термиз шаҳар судида блогер Фазилат Салимовага нисбатан маъмурий иш
        кўриб чиқилган.
      </p>
      <p>
        Суд қарори билан Ўзбекистон Маъмурий жавобгарлик тўғрисидаги кодексининг 195-моддаси (Ички
        ишлар органлари ходимларининг ўз хизмат бурчларини бажаришларига қаршилик кўрсатиш) ва
        202.2-моддаси 1-қисми (ёлғон ахборот тарқатиш) бўйича айбли деб топилган блогерга 8 суткалик
        қамоқ жазоси ҳамда БҲМнинг ўн баробари миқдорида (3 миллион 400 минг сўм) жарима
        тайинланган.
      </p>
      <p>
        Гувоҳлар иддаосича, беш яшар фарзанднинг онаси бўлган 33 ёшли термизлик блогер устидан суд
        ёпиқ тарзда ўтказилган.
      </p>
      <p>
        Фазилат Салимованинг онасига кўра, қизи ИИБ ходимлари томонидан бир фуқаро
        калтакланаётганини кўриб, “урманглар, айби бўлса, қонуний жазосини беринглар” деб, ўша жойда
        жонли эфир қилгани учун маҳаллий расмийлар ғазабига учраган.
      </p>
      <p>
        <i>“Улар Фазилатга туҳмат қилишяпти”</i>,{' '}
        <a href="https://www.youtube.com/watch?v=4CPiyfdAHrY">деган</a> блогернинг онаси бу суд
        аёлдан қасд олиш учун уюштирилганини иддао қилмоқда.
      </p>
      <p>
        2022 йил 5 ноябрь куни ҳам ижтимоий тармоқларда Фазилат Салимовани Термиздаги сайёр қабул
        пайти ҳибсга олишгани ва руҳий касалликлар шифохонасига тушгани хабари тарқалган.
      </p>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/_f7gNCC9_Do?si=Fc4q6lKm0SRpr-Ht"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  ),
  73: (
    <div>
      <p>
        Самарқандлик журналист ва жамоат фаоли Анастасия Павленко Маданий мерос объектлари Миллий
        рўйхатидаги давлат ҳимоясида бўлган машҳур ўзбек совет рассоми Павел Беньков яшаган уй
        ҳудудидаги ноқонуний қурилишни тўхтатишга қаратилган ҳаракатлари учун 2022 йил январь ойида
        судга тортилиб, жаримага маҳкум этилган.
      </p>

      <p>
        Қурилиши ноқонуний деб топилиб, тўхтатилганлигидан норози бўлган рассом уйининг ҳозирги
        мулкдори журналист устидан судга шикоят аризаси киритган.
      </p>

      <p>
        2022 йил 18 январь куни Самарқанд шаҳар суди Анастасия Павленкони Маъмурий жавобгарлик
        тўғрисидаги кодекснинг 45-моддаси (фуқароларнинг турар жойи дахлсизлигини бузиш), 46-моддаси
        (фуқарога маънавий ёки моддий зарар етказиши мумкин бўлган маълумотларни ошкор этиш) ҳамда
        202-моддаси 1-қисми (ёлғон ахборот тарқатиш”) билан айбдор деб топиб, унга нисбатан БҲМнинг
        7 баравари миқдорида жарима жазоси тайинлаган.
      </p>

      <p>
        Анастасия Павленко рус тилида чоп этиладиган “Самаркандский вестник” газетаси бош муҳаррири
        ўринбосари ва “Самарқандни асраймиз” мустақил ташаббус гуруҳи аъзосидир.
      </p>

      <p>
        Журналист 2022 йил 18 январь куни ўзининг Фейсбук саҳифасида суд жараёни "нохолис" ўтгани ва
        процессуал нормалар қўпол равишда бузилгани ҳақида ёзган: “Суд жараёнида туҳмат ва ҳақоратга
        учрадим, менга ҳимояланишим учун ҳеч қандай имкон беришмади, мен томонимдан киритилган барча
        илтимосномалар ва хусусан, судья Рўзиевни четлаш, эксперт ва мутахассисларни сўроқ қилишга
        жалб қилиш сўрови ҳам рад этилди” .
      </p>

      <p>
        “Озодлик” билан суҳбатда Анастасия Павленко суд "олдиндан режалаштирилган сценарий асосида
        ўтгани"ни иддао қилган.
      </p>

      <p>
        "Агар ушбу жараённи суд деб аташ мумкин бўлса, ушбу судни мен 20 йиллик журналист сифатидаги
        ўз касбий фаолиятимга нисбатан таъқиб сифатида баҳолайман”, деб айтган самарқандлик
        журналист ва фаол.
      </p>

      <p>
        Мустақил журналист ва тармоқ фаоли Никита Макаренко Анастасия Павленко устидан суд жараёнини
        1937 -1938 йиллардаги зиёлилар қатағонига қиёслаган.
      </p>

      <p>
        “Вилоятларда сўз эркинлиги ўта оғир аҳволда. Танқидий мавзуларни кўтараётган журналист ва
        блогерлар “чойхонача адолат”га қарши чиқа олмаяптилар ва уларнинг тақдири “саҳна ортида” ҳал
        бўлмоқда”, деб ёзганди у 2022 йил 19 январь куни ўзининг "Эффект Макаренко"
        Телеграм-каналида.
      </p>
    </div>
  ),
  74: (
    <div>
      <p>
        2023 йил 23 май куни Тошкентнинг Шайхонтоҳур туман суди собиқ имом ва диний блогер Шавкат
        Ҳасанни “диний мазмундаги материалларни қонунга хилоф равишда тайёрлаш ва тарқатиш”
        (Маъмурий жавобгарлик тўғрисидаги кодекснинг 184-2 моддаси) билан айбдор, деб топиб 6,6
        миллион сўм жаримага тортган.
      </p>

      <p>
        Шавкат Ҳасаннинг Kun.uz нашрига билдиришича, Вазирлар Маҳкамаси ҳузуридаги Дин ишлари бўйича
        қўмита Шавкат Ҳасан контентларида терроризм ва диний адоватга чақирувчи ғоялар йўқ, деб
        топган. Шунга қарамай унинг материаллари “тегишли тартибда рухсат олмай тарқатилгани”
        айтилади.
      </p>

      <p>
        Тармоқлардаги видеомурожаатида Шавкат Ҳасан “шунча йиллик расмий диний фаолиятида бундай
        экспертиза олиниши кераклигини билмаганини ҳам” таъкидлаган.
      </p>

      <p>
        Диний блогернинг жаримага тортилишига сабаб бўлган видеоматериаллар оилавий тотувлик
        мавзусида экани хабар қилинган.
      </p>

      <p>
        Бу каби маҳкама жараёнлари тармоқларда Ўзбекистондаги диний эркинликлар доираси тораётиб
        бораётгани ҳақидаги хавотирларга сабаб бўлган.
      </p>
    </div>
  ),
  75: (
    <div>
      <p>
        Ижтимоий тармоқларда Саъдуллох Абдул-Карим номи билан диний тарғибот олиб борган асакалик 25
        яшар Сайдулло Абдуллажонов 2018 йил 6 сентябрида Андижон вилоят Ички ишлар бошқармасига
        профилактик суҳбатга чақирилган.
      </p>

      <p>
        Абдуллажонов билан бирга исломий курсда ўқиган йигитнинг ишонишича, у 2018 йил 31 августдан
        то 6 сентябрга қадар ҳибсда ушланган.
      </p>

      <p>
        Андижон вилоят Асака шаҳар ИИБнинг ўзини "профилактика бўлими инспектори", деб таништирган
        мулозимга кўра, “Абдуллажонов 2011 йил июнидан то 2018 йилгача Facebookдаги ўз саҳифасида
        диний адоват қўзғовчи матнларни мунтазам қўйиб борган”.
      </p>

      <p>
        “Facebook ижтимоий тармоғидаги шахсий саҳифамда кескин резонанс ҳосил қилганимдан
        афсусдаман. Мутасаддиларнинг умумий хулосасига биноан менга нисбатан жазо сифатида
        э.к.и.ҳ.нинг (энг кам иш ҳақи - таҳр.) бир ярим баробаридаги жарима ва 360 соатлик мажбурий
        меҳнат тайинланганидан хабардорман. Агар яна бир бор ижтимоий тармоқларда кенг кўламли
        резонанс уюштиришга уринсам менга нисбатан кескин чоралар кўрилиши ҳақида огоҳлантирилдим”,
        дейилади Саъдуллох Абдул-Каримнинг Facebookда эълон қилинган “тушунтириш хати”да.
      </p>

      <p>
        2018 йилнинг август, сентябрь ойларида Ўзбекистоннинг турли шаҳарларида ўнга яқин блогер
        ҳибсга олинган.
      </p>
    </div>
  ),
  76: (
    <div>
      <p>
        2019 йил февраль ойида халқ депутатлари Наманган вилоят кенгаши депутати Олимжон
        Тўхтаназаров пора олганлик айби билан 2 йилу 8 ойга озодликдан чеклаш жазосини олган.
      </p>

      <p>
        Ўзбекистон ҳуқуқни муҳофаза қилиш органидан Озодликка юборилган расмий ҳужжатга кўра¸ Халқ
        депутатлари Наманган вилоят кенгаши депутати Олимжон Тўхтаназаров 2018 йил 22 сентябрь куни
        маҳаллий вақт билан соат 15 лар атрофида Чуст туманида аризачи аëлдан 500 АҚШ доллари
        миқдорида пора олаëтган пайтда қўлга олинган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/pUzBl5GHisE?si=5cYoc3iFLfuQf0qy"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Наманганлик депутат билан Facebookдаги мунозаралар пайтида танишганини айтган Ўтюраклар
        клуби етакчиси Мўътабар Тожибоева¸ Тўхтаназаровнинг қўлга олинишини маҳаллий раҳбарларнинг
        фаол депутатни “йўқ қилиш уриниши” деб иддао қилган.
      </p>

      <p>
        ЎзА агентлигининг Бош прокуратурага таяниб ёзишича, Жиноят ишлари бўйича Наманган вилояти
        судининг 2019 йил 5 февралдаги ҳукми билан Тўхтаназаровнинг ҳаракати Жиноят кодексининг
        168-моддаси, 3-қисми "в" бандидан 168-моддаси 1-қисмига қайта малакаланган.
      </p>

      <p>Натижада, у 168-моддаси 1-қисми, 211-модданинг 1-қисми билан айбдор, деб топилган.</p>

      <p>
        Бош прокуратуранинг маълум қилишича, суд жараёнида 45, 57-моддалар қўлланиб, 3 йилга муайян
        ҳуқуқдан маҳрум қилиш, 2 йилу 8 ойга озодликдан чеклаш жазоси тайинланган. Бунда унинг
        оилавий шароити ва ягона боқувчилиги инобатга олинган.
      </p>

      <p>
        Суд залидан озод қилинган Олимжон Тўхтаназаровнинг депутатлик ваколати муддатидан аввал
        тўхтатилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/1O0gohd9HWA?si=oStVgPvJ1GQcaii9"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Ўзбекистон Либерал-демократик партияси аъзоси бўлган, ЎзМТРК таркибидаги каналлардан бирида
        режиссёр бўлиб ишлаган Тўхтаназаров 2018 йил май ойида президент Шавкат Мирзиëевга
        бирваракайига Ўзбекистон қаҳрамони, Нобель ва ҳатто Оскар мукофотларини бериш ташаббуси
        билан ўртага чиққан эди.
      </p>
    </div>
  ),
  77: (
    <div>
      <p>
        2024 йил 14 январь куни Nuz.uz мухбири Михаил Довлатов Тошкент шаҳри Учтепа тумани 11-даҳада
        яшовчи фуқаролардан келиб тушган сўров бўйича журналистик суриштирув олиб бормоқчи бўлганида
        Учтепа тумани ҳуқуқ-тартибот идоралари томонидан ушланган. У тумандаги 2-сонли ички ишлар
        идорасига олиб борилган ва у ерда журналистнинг телефони ҳамда ускуналари олиб қўйилган.
        Довлатов тахминан 5 соат қўйиб юборилмаган ва “жамоат жойида чекканлик учун” жаримага
        тортилган.
      </p>

      <p>
        АОКА 2024 йил 16 январда билдирган расмий муносабатида бу ҳолатга ҳуқуқий баҳо бериш
        илтимоси билан Бош прокуратурасга сўров хати юборганини билдирган.
      </p>

      <p>
        Жиноят ишлари бўйича Учтепа туман суди 2024 йил 16 январда Nuz.uz мухбири Михаил Довлатовга
        нисбатан маъмурий ишни тугатган.
      </p>

      <p>
        Олий суднинг билдиришича, журналистнинг ҳаракатида маъмурий ҳуқуқбузарлик аломати йўқлиги
        сабабли, унга нисбатан Маъмурий жавобгарлик тўғрисидаги кодекснинг 183-моддаси (майда
        безорилик) ва 194-моддаси (ички ишлар органлари ходимининг қонуний талабларини бажармаслик)
        1-қисми билан юритилган маъмурий ҳуқуқбузарлик тўғрисидаги иш МЖтКнинг 271-моддаси (маъмурий
        ҳуқуқбузарлик тўғрисидаги ишларни юритишни истисно этувчи ҳолатлар) 1-бандига асосан
        тугатилган.
      </p>
    </div>
  ),
  78: (
    <div>
      <p>
        1988 йилда туғилган Санжар Икромов YouTube, Telegram ва Facebook тармоқларидаги
        сиёсий-иқтисодий чиқишлари билан танилган блогер.У Санжар Хўжа тахаллуси билан ижод қилади.
      </p>

      <p>
        2023 йил 8 август куни Ўзбекистон Ички ишлар вазирлиги ҳозирда Туркияда яшаётган блогер
        Санжар Икромовни қидирувга берган.
      </p>

      <p>
        Санжар Икромов Жиноят кодексининг 168-моддаси 3-қисми “а” банди (жуда кўп миқдордаги
        фирибгарлик)да айбланган.
      </p>

      <p>
        Мазкур айблов асосида блогер 8 йилдан 10 йилгача қамалиши ёки БҲМнинг 400 бараваридан 600
        бараваригача миқдорда жаримага тортилиши мумкин.
      </p>

      <p>Ҳозирда Санжар Хўжа Туркияда яшаб, ижод қилишни давом эттирмоқда.</p>
    </div>
  ),
  79: (
    <div>
      <p>
        2023 йил 8 август куни Ўзбекистон Ички ишлар вазирлиги Detektiv Uz YouTube-канали муаллифи
        Шерали Комиловни қидирувга берган.
      </p>

      <p>
        Шерали Комилов 168-модда 3-қисми “б” банди (ўта хавфли рецидивист томонидан фирибгарлик
        содир этилиши) ва 140-модда 3-қисми “а” банди (ҳақорат қилиш жабрланувчини ўз хизмат ёки
        фуқаролик бурчини бажариши муносабати билан боғлиқ ҳолда) айбланган.
      </p>

      <p>
        Мазкур айблов асосида блогер 8 йилдан 10 йилгача қамалиши ёки БҲМнинг 400 бараваридан 600
        бараваригача миқдорда жаримага тортилиши мумкин.
      </p>

      <p>
        1979 йилда туғилган Шерали Комилов Detektiv Uz муаллифи бўлиб, унинг YouTube-каналида 17,8
        минг, Facebook`да — 8140 обуначиси бор. Унинг кўплаб постларида диний блогер Аброр
        Абдуазимов (Аброр Мухтор Алий) танқид қилинади.
      </p>
    </div>
  ),
  80: (
    <div>
      <p>
        2023 йил 3 апрель куни Лондондан Тошкентга учиб борган мустақил журналист ва ҳужжатли кино
        продюсери Шоҳида Ёқуб (Тўлаганова) Ўзбекистонга киритилмади.
      </p>

      <p>
        Британия фуқаролигига эга асли ўзбекистонлик Шоҳида Ёқубнинг Озодликка айтишича, Тошкент
        аэропорти расмийлари унинг нима учун мамлакатга киритилмагани юзасидан ҳеч қандай тушунтириш
        беришмаган.
      </p>

      <p>
        Узоқ кутишдан сўнг 49 ёшли журналист икки фарзанди билан биргаликда ўз ёнидан чипта харид
        қилиб, Ригага учишга мажбур бўлган.
      </p>

      <p>
        Шоҳида Ёқуб узоқ йиллардан кейин икки фарзандига Ўзбекистонни кўрсатиш ва онаси, яқинлари
        билан видолашиш учун келганини билдирган.
      </p>

      <p>
        Қароргоҳи Нью-Йоркда жойлашган Журналистларни ҳимоя қилиш қўмитаси (CPJ) 2023 йил 6 апрель
        куни тарқатган баёнотида журналистнинг Ўзбекистонга қўйилмаганини қоралаган.
      </p>

      <p>
        CPJ дастурий директори Карлос Мартинес де ла Сернага кўра, ўзбек расмийлари Шоҳида Ёқуб
        мамлакатга киритилмаганига қонуний асос тақдим этишлари ёки журналистга Ўзбекистондаги
        яқинларини кўриб келиш имконини беришлари лозим.
      </p>

      <p>
        “Инсон ҳуқуқлари билан боғлиқ ўта муҳим мавзуларни ёритаётган журналистлардан хафа бўлишга,
        президент Шавкат Мирзиёев иддао қилаётганидек, очиқ ва демократик Ўзбекистонда жой
        бўлмаслиги керак”, деган CPJ вакили.
      </p>

      <p>
        Шоҳида Ёқуб Ўзбекистонга киритилмагани ортида ўзининг журналистик фаолияти турганига
        ишонади. Унинг сўзларига кўра, ўзбек ҳукумати шу тариқа унинг 2005 йил майидаги Андижон
        қирғини ҳамда 2007 йилда отиб кетилган ўшлик журналист Алишер Соипов қотиллигини ёритганини
        “кечира олмаган”.
      </p>

      <p>
        “Шунингдек, улар билан ҳамкорлик қилишдан бош тортганим ҳам бунга сабаб бўлиши мумкин”, дея
        тахминларини илгари сурди журналист.
      </p>

      <p>
        Унинг айтишича, ўзи билан юз берган ҳодиса Андижон қирғинига алоқадор шахслар ҳалигача
        амалда эканидан дарак беради.
      </p>

      <p>
        Шоҳида Ёқуб 2021 йилнинг август ойида ҳам Тошкент аэропортидан ватанига киритилмасдан, ортга
        қайтариб юборилган эди.
      </p>

      <p>Ўзбекистон пойтахти Тошкентда туғилган Шоҳида Ёқуб 1996 йили мамлакатни тарк этган.</p>
    </div>
  ),
  81: (
    <div>
      <p>Таниқли журналист ва ёзувчи Ҳамид Исмоил 2017 йил 1 март куни Ўзбекистонга киритилмади.</p>
      <p>
        Ўша пайтда Би-Би-Си Марказий Осиë хизмати муҳаррири лавозимида ишлаётган Ҳамид Исмоил қўлида
        расмий таклифнома бўлишига қарамай Тошкент аэропортидан ортга қайтарилган.
      </p>
      <p>
        Делегация таркибини тасдиқлаб расман таклифнома берган Ўзбекистон Ташқи ишлар вазирлиги
        ўшанда ҳам, ундан кейин ҳам Ҳамид Исмоил нега Ўзбекистонга киритилмагани борасида изоҳ
        бермаган.
      </p>
      <p>
        Ҳамид Исмоилнинг ўзи 2019 йилда Ўзбекистон давлат ахборот агентлиги ЎзА мухбирининг интервью
        ҳақидаги сўровига жавобан ўзини Ўзбекистонга киритмаган расмийлардан кечирим сўрашларини
        кутаётганини билдирган.
      </p>
      <p>
        Ҳамид Исмоил давлат комиссияси ўзи суратга олишда иштирок этган ҳужжатли фильмни «маънавият
        тенденцияларига мос келмайди» деб топганидан сўнг¸ 1992 йилда Ўзбекистондан чиқиб кетишга
        мажбур бўлган.
      </p>
      <p>
        1992 йилда Би-Би-Си телевизион гуруҳи билан Ўзбекистон ҳақида фильм олиш устида ишлагани
        ортидан унга қарши жиноят иши қўзғатилган.
      </p>
      <p>Ҳамид Исмоилни қоралашга уриниш бу баëнотдан 30 йил ўтиб ҳам давом этмоқда.</p>
      <p>
        Ҳамид Исмоилнинг насрий асарлари дунёнинг кўплаб тилларига таржима қилинган ва ёзувчи 2019
        йилда “Жинлар базми” романи учун Лондондаги нуфузли ЕТТБ адабий мукофотига сазовор бўлган.
      </p>
      <p>
        Асар ёзувчининг мустақиллик йилларида Ўзбекистонда китоб ҳолида нашр этилган ягона
        романидир.
      </p>
      <p>
        Ўзбекистон Ëзувчилар уюшмаси наср кенгаши “Жинлар базми” романи ортида “сиёсий манфаатлар
        тургани”ни иддао қилган.
      </p>
      <p>Ҳамид Исмоил Би-би-си Жаҳон хизматининг биринчи фахрий ёзувчи-резиденти бўлган.</p>
      <p>
        Британиядаги The Guardian нашри 2020 йилда Ҳамид Исмоилнинг “Мбобо” романини “Россия ҳақида
        ёзилган энг яхши романлар ўнлиги”га киритган.
      </p>
      <p>
        Ҳамид Исмоил 2020 йил февралидан буён&#xa0; Озод Европа/Озодлик радиосининг Марказий Осиë
        бўйича бўйича минтақавий директори лавозимида ишлаб келади.
      </p>
    </div>
  ),
  82: (
    <div>
      <p>
        Ютубдаги баҳсли чиқишлари билан танилган блогер Искандар Македонский (Искандар Қодиров) 2021
        йил 10 июнь куни Ўзбекистонга киритилмади.
      </p>

      <p>
        Москвадан Қашқадарё маркази Қарши шаҳрига учиб борган блогер чегарадан ортга қайтарилган.
      </p>

      <p>
        Озодлик билан суҳбатда Македонский чегарачилар уни ҳеч қандай тушунтиришларсиз депортация
        қилганини сўзлаган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/e-Gngk-Kydg?si=WabfcO7ABSY2cMnl"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>Искандар Македонский анчадан буён Россияда ўқиб, меҳнат қилади.</p>

      <p>
        2018 йили Озодлик билан суҳбатда ўзини “сўз эркинлиги ҳимоячиси” ва “эркин дунёқараш
        тарафдори”, деб атаган Искандар охирги пайтларда таҳдидлар жиддий тус олганини айтган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/Z7CTGVb0I64?si=h7UR0sV9PR5tLQvB"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Македонский чиқишлари орқали Шавкат Мирзиёев ва Ўзбекистон ҳукумати қабул қилаётган айрим
        қарор-қонунларини танқид остига олиб келмоқда.
      </p>

      <p>
        Видеоблогер таҳдидлар тўхтамаётганига қарамасдан, ўз фаолиятини тўхтатиш ниятида эмаслигини
        айтган.
      </p>
    </div>
  ),
  83: (
    <div>
      <p>
        2020 йил 24 январь куни қирғизистонлик блогер ва ижтимоий фаол Баҳром Раҳмон Ўзбекистонга
        киритилмаган.
      </p>

      <p>
        Ўш ва Андижон ўртасидаги “Дўстлик” чегара пунктидан ўзбек чегарачилари томонидан ортга
        қайтарилган Баҳром Раҳмон Озодликка Ўзбекистон томони ўзига на бирор ҳужжат, на
        киритилмагани сабаблари борасида тушунтириш берганини айтган.
      </p>

      <p>
        “Мен Тошкентга Евросиё иқтисодий иттифоқига Ўзбекистоннинг қўшилиши масаласида журналистик
        тадқиқот ўтказиш учун бормоқчи эдим”, деган ўшанда Баҳром Раҳмон.
      </p>

      <p>
        Блогер Хитойдаги уйғурлар аҳволи ва Марказий Осиë ҳукуматларининг унга муносабати ҳақида
        билдирган танқидий фикрлари Ўзбекистон хавфсизлик идораларига ëқмаганини тахмин қилади.
      </p>
    </div>
  ),
  84: (
    <div>
      <p>
        2023 йилнинг 5 февраль куни Озодлик радиоси мухбири Умид Бобоматов Ўзбекистонга
        киритилмаган.
      </p>

      <p>Бобоматов “Ойбек” чегара-назорат постидан ўтказилмасдан ортга қайтариб юборилган.</p>

      <p>
        Озодлик мухбири бундан аввал 2019 йилда Москвадан учиб келганида ҳам Ўзбекистонга
        киритилмаган эди.
      </p>

      <p>
        Ҳар икки ҳолатда ҳам расмийлар журналистнинг нима учун Ўзбекистонга киритилмагани юзасидан
        изоҳ беришмаган.
      </p>

      <p>
        Журналист Умид Бобоматов чиқариб юборилиши сабаби унга маълум эмаслиги, бу унинг касбий
        фаолияти билан боғлиқ бўлиши мумкинлигини таъкидлаган.
      </p>
    </div>
  ),
  85: (
    <div>
      <p>
        Агнешка Пикулицка –&#xa0; The Guardian, Al Jazeera, The Diplomat ва Eurasianet нашрлари
        билан ҳамкорлик қилиб келган польшалик мустақил журналист.
      </p>

      <p>
        2021 йил 7-8-9 ноябрь кунлари Ўзбек-қозоқ чегарасида қолиб кетган Агнешка
        Пикулицка-Вильчевска, охир-оқибат Ўзбекистонга киритилмаган.
      </p>

      <p>
        2 совуқ тунни чегарада ўтказган журналистнинг айтишича, 2021 йил 9 ноябрь тонгда уни
        Ғишткўприк-Жибек жолу чегара постидан олиб, Тошкент аэропортига олиб боришган ва мажбуран
        Истанбулга учириб юборишган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/ijD8FNSTDPw?si=zNSso8AzyAPFNtnF"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      <p>
        Қатор халқаро ташкилотлар ва фаоллар, мустақил журналист Пикулицканинг мамлакатга
        киритилмагани - Шавкат Мирзиёев президентлигининг иккинчи муддати бошланган кезда юз
        берганига эътибор қаратган.
      </p>

      <p>
        Агнешка ёзган твитларга изоҳ қолдирган фаоллар матбуот ва сўз эркинлиги борасида кетма-кет
        ислоҳотларни ваъда қилган Мирзиёев ҳукуматининг бу ҳаракатини кескин қоралаган.
      </p>

      <p>
        Human Rights Watch ташкилотининг Европа ва Марказий Осиё бўлими директори Хю Виллиамсон
        Пикулицка масаласидаги хавотирларини Ўзбекистон Ташқи ишлар вазирлигига билдирганини маълум
        қилган.
      </p>

      <p>
        Ўзбекистондаги вазиятни ҳам фаол ёритиб келган журналист сўнгги вақтларда бот-бот Ўзбекистон
        жамоатчилиги диққатига тушган.
      </p>

      <p>
        У қатор жиддий муаммолар - журналист ва блогерлар фаолиятига чеклов, таъқиблар, жумладан,
        блогер Миразиз Бозоровнинг оммавий калтакланиши ҳамда қўлга олиниши, Интернет тармоқларининг
        блокланиши, бундан ташқари Тошкентда дарахтларнинг аёвсиз кесилиши каби долзарб масалаларни
        хорижий матбуот ва тармоқларда фаол ёритган.
      </p>

      <p>
        Бундай чиқишларидан сўнг, ҳар гал танқидларни тўхтатиш талаби билан ўзига нисбатан босим ва
        таҳдид бўлгани, ҳатто бир гал калтакланганини маълум қилган.
      </p>

      <p>
        Ўзбекистон Ташқи ишлар вазирлиги 2019 йилнинг июнь ойида - 3 йилдан буён Ўзбекистонда
        қолаётган мустақил журналист Пикулицканинг аккредитациясини узайтириш сўровини тамоман рад
        этган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/ODx1jy7mTO8?si=wSYn2B_-6OuulIZa"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Журналистнинг айтишича, унга нисбатан расмий тақиқнинг пайдо бўлиши ва хусусан,
        аккредитацияси узайтирилмаётгани сабаби, 2019 йил февраль ойида Ташқи ишлар вазирлиги
        ходимининг унга “шилқимлик қилгани” ва "босим ўтказгани" ҳақида ошкора баёнот бергани билан
        боғлиқ бўлиши мумкин. Хорижий журналистнинг сўзларига кўра, ўшанда вазирликнинг Рустам исмли
        ходими унга жинсий тегажоғлик қилган ва ижобий мақолалар ёзишини сўраб, босим ўтказган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/48VEqooC1CE?si=MJP1rD-u0c6ejJpI"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Пикулицка, ўзига нисбатан босим ва охир-оқибат уни мамлакатга киритмаслик қарори - Шавкат
        Мирзиёев бошқарувидаги бугунги Ўзбекистон ҳануз сўз эркинлигига тайёрмаслиги, танқидга ҳануз
        тоқатсиз эканидан далолатдир, деб таъкидлаган.
      </p>
    </div>
  ),
  86: (
    <div>
      <p>
        Ўзбекистонга шахсий сафар билан борган “Московский комсомолец” газетасининг мухбири
        Екатерина Сажнева 2016 йил 29 ноябрь куни беш соатлик ҳибсдан сўнг Тошкентдан Москвага
        экстрадиция қилинган.
      </p>

      <p>
        Журналистнинг Озодлик радиосига билдиришича, сайлов арафасида Ўзбекистон ватандошлари билан
        интервьюлар ўтказгани ортидан ҳуқуқ-тартибот тузилмалари уни мамлакатда бўлиш қоидаларни
        бузганликда айблаган.
      </p>

      <p>
        Екатерина Сажнева Озодлик радиосига Ўзбекистонга шахсий сафар билан борганини айтдган. Бироқ
        у ўз касбидан келиб чиққан ҳолда одамлар билан, жумладан, мухолифат вакиллари билан ҳам
        гаплашган. Мана шундай суҳбатларнинг биридан сўнг у Тошкентда қўлга олиниб, беш соатдан сўнг
        депортация қилинган.
      </p>

      <p>
        Журналистнинг айтишича, ундан ҳеч қандай тушунтиришларсиз телефон сим картасини,
        фотосуратларни ва матбуотда эълон қилиш мумкин, деб ҳисобланадиган қолган барча нарсаларни
        тортиб олишган.
      </p>

      <p>
        Екатерина Сажнева Озодликка дунёнинг кўплаб мамлакатларида, жумладан, уруш кетаётган Сурияда
        ҳам 4 марта бўлганини, аммо у ерда ҳам махсус хизматлар журналистларга бу қадар душманона
        муносабатда бўлмаганини айтган.
      </p>

      <p>
        Екатерина Сажневанинг айтишича, уни қўлга олган одамлар журналист Facebook саҳифасида эълон
        қилган ўрик данаги пўчоқлари фотосуратини танқид қилишган.
      </p>

      <p>
        &#xa0;“Сиз бу суратни ижтимоий тармоққа жойлаш орқали Ўзбекистонни шарманда қилмоқчи
        бўлгансиз. Фотосуратда данак пўчоқлари акс этган, бу билан сиз Ўзбекистонда мағзи тўлиқ
        данаклар йўқ демоқчи бўлгансиз”, каби гапларни айтишди, дейди журналист.
      </p>

      <p>
        Унга кўра, 2016 йил 27 ноябрида Тошкентга келганидан сўнг мунтазам равишда унинг ортидан
        номаълум шахслар кузатиб юрганини ҳис қилган.
      </p>
    </div>
  ),
  87: (
    <div>
      <p>
        Тошкентда немис журналисти Эдда Шлагер 2016 йил 10 ноябрь куни қўлга олинган ва 11 ноябрь
        куни Ўзбекистондан депортация қилинган.
      </p>

      <p>
        Германия жамоатчилик радиоси мухбири бўлган Шлагер Озодлик билан суҳбатда Тошкентга 2016 йил
        4 декабрида ўтадиган президентлик сайловини ёритиш ва Ислом Каримовдан кейинги Ўзбекистонда
        кечаётган жараёнлар билан немис жамоатчилигини таништириш учун борганлигини билдирган.
      </p>

      <p>
        Эдда Шлагер нашрга Ўзбекистон ташқи ишлар вазирлигидан аккредитация олиш мумкин бўлмагани
        туфайли Тошкентга 3 ноябрь куни сайёҳлик визаси билан келганини ва жамоатчилик вакиллари
        билан бир қатор учрашувлдар ўтказганини айтган.
      </p>

      <p>
        10 ноябрь куни уни меҳмонхонада милиция ва миллий хавфсизлик хизмати ходимларидан иборат 4
        киши уни ҳибсга олиб, бир неча соат сўроқ қилган.
      </p>

      <p>
        "Чегарасиз мухбирлар" халқаро ташкилоти ва Германия Ташқи ишлар вазирлиги аралашуви билан
        журналист озод этилиб, Ўзбекистондан чиқариб юборилган.
      </p>

      <p>
        Эдда Шлагер Озодлик билан{' '}
        <a href="https://www.ozodlik.org/a/shavkat-mirziyoyev-saylov-germaniya-muxbir-ozodlik/28114951.html">
          суҳбатда
        </a>{' '}
        Ўзбекистондаги жорий кайфиятни Шимолий Кореяга ўхшатган.
      </p>

      <p>
        <i>
          “МХХ ходимлари мени диктофонимни олиб қўйишди. Лекин менда қулоқ бор¸ кўз бор¸ ҳидлаш учун
          бурним бор. "Маҳалла сталинизми" деган калима Ўзбекистондаги бугунги вазиятни тўла
          ифодалайди. Мен ўзим собиқ ГДРдан бўлганим боис¸ қўрқув муҳитини бутун борлиғим билан
          сезаман. ГДРдаги қўрқув ва чақимчиликка асосланган муҳитни яхши эслайман. Ўзбекистон
          кўчаларида¸ бозорда оддий одамлар билан гаплашдим. Улардан оддий нарсаларни сўрасам ҳам¸
          чўчиб тушишади. Нега бунақа ғалати саволларни беряпсиз? Тинчлигимизга раҳна солмоқчимисиз¸
          дейишади. Одамларга ишонмаслик¸ шубҳа ва гумон Ўзбекистонни қамраган. Қўрқув ва гумон
          урчиган. Вазият Шимолий Кореяга ўхшайди. Балки Шимолий Корея каби даҳшатли эмасдир¸ балки
          у қадар мукаммаллик касб қилмагандир. Лекин барибир Шимолий Корея тутуми бу”
        </i>{' '}
        <a href="https://www.ozodlik.org/a/shavkat-mirziyoyev-saylov-germaniya-muxbir-ozodlik/28114951.html">
          деган
        </a>{' '}
        Ўзбекистондан депортация қилинган Эдда Шлагер.
      </p>
    </div>
  ),
  88: (
    <div>
      <p>
        Тошкентлик компьютер устаси бўлган Алексей Гаршин тармоқларни титратган махфий “Шоввозсой”
        қароргоҳи ҳақида биринчи бўлиб хабар қилган эди.
      </p>

      <p>
        Кейинчалик Озодлик олиб борган махсус суриштирув, Тошкент вилоятининг Оҳангарон тумани
        ҳудудидаги Угам-Чотқол тоғ тизмалари бағрига яширилган бу қароргоҳ, президент Мирзиёев учун
        махсус қурилгани, сунъий сув омборини ҳам ичига олган улкан мажмуа эканини ўртага чиқарган.
      </p>

      <p>
        Ана шу хабардан сўнг,&#xa0; Алексей Гаршин жуда қисқа муддатда - YouTube тармоғига
        видеоларни жойлаб, катта-кичик муаммоларни кўтариб келаётган блогер сифатида кенг
        жамоатчиликка танилди.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/XvwjKR2EOfk?si=nQI13pc23xDGRaKz"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2021 йил июнь ойида блогер Алексей Гаршин “Озод Ватан” партияси таъсис қурултойига ҳозирлик
        кўрилаётганини маълум қилган. Фаол YouTube каналида эълон қилган видеода, буни Ўзбекистонда
        халқ партиясига айлантириш истагини билдирган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/oKa46xzrRQg?si=hO_nRdg1mA-d1V_I"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Ўтган йиллар давомида блогер Гаршин ортидан кузатув бўлганидан шикоят қилиб келган. Масалан,
        2021 йилги президент сайлови арафасида YouTube тармоғига қўйилган видеода Гаршин давлат
        рақами билан ҳаракатланаётган автомобилдаги номаълум шахслар уни ўз уйи атрофи ва бораётган
        манзилларида таъқиб қилаётганини айтган.
      </p>

      <p>
        “Менинг шахсий ва мулкий дахлсизлигимни таъминлаши керак бўлган бу давлатда, бизнинг
        солиқларимиз ҳисобига давлат идорасига олинган машина репрессия билан шуғулланмоқда.
        Халойиқ, бу - репрессия. Бу кузатув учун сарф-харажат қилинади” деган у.
      </p>

      <p>
        Ўзбекистон Конституциясини ўзгартириш жараёнида, 2022 йил май ойида “Озод Ватан” сиёсий
        бирлашмасини тузиш ташаббускори бўлган Алексей Гаршин устидан маъмурий суд жараёни олиб
        борилган. Тошкентнинг Юнусобод туман суди Гаршиннинг бир аёлни интернетда ҳақорат қилгани
        ҳақидаги даъво аризасини кўриб чиққан.
      </p>

      <p>
        Озодлик билан суҳбатда у ўзига қўйилган айблов ортида сиёсий сабаблар турибди, деб ишонишини
        билдирган.
      </p>

      <p>Сиёсий фаол ва блогер таъқиблар ортидан Ўзбекистонни тарк этишга мажбур бўлган.</p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/MlRdwnqy83w?si=fFvielZ69fd2h0dK"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2024 йил февраль ойида&#xa0; Гаршин суд қарори билан АҚШда қолишга рухсат олган. Бундан
        олдин у 4 ой бу мамлакатнинг миграция изоляторида сақланган.
      </p>
    </div>
  ),
  89: (
    <div>
      <p>
        2020 йил 22 май куни “Sport” телеканали журналисти Бобур Акмалов “Ориат Доно” радиосидаги
        танқидий чиқиши учун ишдан бўшатилган.
      </p>

      <p>
        Бобур Акмалов 2020 йил 18 май кунги радиоэшиттиришда ҳамкасби Жамолиддин Бобожонов билан
        биргаликда “O‘zbekiston 24” телеканали тарқатаётган хабарлар реал ҳаётдан узоқлигини айтиб,
        танқид қилган эди.
      </p>

      <p>
        Бобур Акмалов “Sport” телеканалида муҳаррирлик қилиш билан бир пайтда “Ориат Доно”
        радиосидаги "Футбол плюс" эшиттиришининг бошловчиси ҳам эди.
      </p>

      <p>
        "Футбол плюс" эшиттиришининг 2020 йил 18 май кунги сонида Жамолиддин Бобожонов ва Бобур
        Акмалов “O‘zbekiston 24” телеканалини танқид қилгани видеоси ижтимоий тармоқларда тарқалган.
      </p>

      <p>
        Видеода Жамолиддин Бобожонов “Бизда қоғозда ва “O‘zbekiston 24” каналида ҳамма нарса зўр.
        Аммо ҳаёт бутунлай бошқа нарсани кўрсатяпти. Мен сардобаликлар сув тошқинидан хурсанд
        бўляпти, деб ўйлаб қолдим. Улар фалокатдан хурсанд бўлишяпти”, деб айтган. Бунга жавобан
        Бобур Акмалов: “O‘zbekiston 24” қандайдир Сусамбил давлатида ташкил этилганми?” тариқасида
        жавоб берган.
      </p>

      <p>
        "Футбол плюс" эшиттиришининг 2018 йил 18 майдаги сони "Ориат Доно" радиоканали сайтидан ҳам,
        Ютуб тармоғидаги саҳифасидан ҳам ўчириб ташланган.
      </p>

      <p>
        2020 йил 21 май куни Ўзбекистон Милиий телерадиокомпанияси (МТРК) раиси Алишер Хўжаев
        “O‘zbekiston 24” телеканалини танқид қилган Бобур Акмалов ва Жамолиддин Бобожоновни
        корпоратив этикага риоя қилмаганликда, мутлақо асоссиз ва ҳақиқатдан узоқ фикрларни
        айтганликда айблаган.
      </p>

      <p>
        “Газета.уз”нинг ёзишича, МТРК раиси Алишер Хўжаевнинг икки журналистни танқид қилган пости
        унинг Facebook саҳифасида эълон қилинган, бироқ кейинроқ у мазкур постни ўчириб ташлаган.
      </p>

      <p>
        Facebookдаги "Халқ назорати" гуруҳида Акмалов ва Бобожоновларнинг ишдан олинганига норозилик
        сифатида петиция эълон қилинган.
      </p>
    </div>
  ),
  90: (
    <div>
      <p>
        2020 йил 22 май куни “Sport” телеканали журналисти Жамолиддин Бобожонов “Ориат Доно”
        радиосидаги танқидий чиқиши учун ишдан бўшатилган.
      </p>

      <p>
        Жамолиддин Бобожонов 2020 йил 18 май кунги радиоэшиттиришда ҳамкасби Бобур Акмалов билан
        биргаликда “O‘zbekiston 24” телеканали тарқатаётган хабарлар реал ҳаётдан узоқлигини айтиб,
        танқид қилган эди.
      </p>

      <p>
        “Sport” телеканали бош режиссёри Жамолиддин Бобожонов “Ориат Доно” радиосидаги "Футбол плюс"
        эшиттиришининг доимий иштирокчиси бўлган.
      </p>

      <p>
        "Футбол плюс" эшиттиришининг 2020 йил 18 май кунги сонида Жамолиддин Бобожонов ва Бобур
        Акмалов “O‘zbekiston 24” телеканалини танқид қилгани видеоси ижтимоий тармоқларда тарқалган.
      </p>

      <p>
        Видеода Жамолиддин Бобожонов “Бизда қоғозда ва “O‘zbekiston 24” каналида ҳамма нарса зўр.
        Аммо ҳаёт бутунлай бошқа нарсани кўрсатяпти. Мен сардобаликлар сув тошқинидан хурсанд
        бўляпти, деб ўйлаб қолдим. Улар фалокатдан хурсанд бўлишяпти”, деб айтган. Бунга жавобан
        Бобур Акмалов: “O‘zbekiston 24” қандайдир Сусамбил давлатида ташкил этилганми?” тариқасида
        жавоб берган.
      </p>

      <p>
        "Футбол плюс" эшиттиришининг 2018 йил 18 майдаги сони "Ориат Доно" радиоканали сайтидан ҳам,
        Ютуб тармоғидаги саҳифасидан ҳам ўчириб ташланган.
      </p>

      <p>
        2020 йил 21 май куни Ўзбекистон Милиий телерадиокомпанияси (МТРК) раиси Алишер Хўжаев
        “O‘zbekiston 24” телеканалини танқид қилган Бобур Акмалов ва Жамолиддин Бобожоновни
        корпоратив этикага риоя қилмаганликда, мутлақо асоссиз ва ҳақиқатдан узоқ фикрларни
        айтганликда айблаган.
      </p>

      <p>
        “Газета.уз”нинг ёзишича, МТРК раиси Алишер Хўжаевнинг икки журналистни танқид қилган пости
        унинг Facebook саҳифасида эълон қилинган, бироқ кейинроқ у мазкур постни ўчириб ташлаган.
      </p>

      <p>
        Facebookдаги "Халқ назорати" гуруҳида Акмалов ва Бобожоновларнинг ишдан олинганига норозилик
        сифатида петиция эълон қилинган.
      </p>
    </div>
  ),
  91: (
    <div>
      <p>
        2024 йилнинг 28 февраль куни BBC Ўзбек хизмати журналисти Ибрат Сафо Тошкентнинг Чилонзор
        тумани ИИБга "суҳбат"га чақирилди. Бу ҳақда Британияда яшаётган журналист ўзининг Facebook
        саҳифасида{' '}
        <a href="https://www.facebook.com/ibrat.jumaboyev/posts/pfbid028Bx2rQfCx7E8iX2pVHBY7bcRhvfVcJUVV1mNrpKvhGzzc2bKPJ4jM5ehQ4ckfEkgl">
          ёзди.
        </a>
      </p>
      <p>
        Ибрат Сафонинг маълум қилишича, ўзбек ҳуқуқ-тартибот идоралари унинг 2024 йил 1 февралида
        Тошкент шаҳридаги Миллий боғда қуриб қолган кўл ва Magic City қурилиши ҳақида ижтимоий
        тармоқда қолдирган пости билан қизиққан.
      </p>
      <p>
        Журналистнинг ёзишича, Чилонзор тумани ИИО ФМБнинг Жасур исмли ходими унга интернетда
        Ўзбекистон ҳақида «негатив» ёзгани учун «Президент администрацияси қошидаги оммавий ахборот
        воситаларини мониторинг қилувчи марказ»дан топшириқ олганини айтган.
      </p>
      <p>
        Ибрат Сафога кўра, ИИО ходими «Ўзбекистон ҳукуматини обрўсизлантириш» ҳақидаги қонунга ишора
        қилган, бироқ бу қандай қонун эканини изоҳламаган. Айни пайтда журналист ўз постида бирор
        исм ёки шахсларни тилга олмаганини таъкидлайди.
      </p>
      <p>
        BBC журналисти ўзининг 20 йилдан бери Тошкентда яшамаслиги, 2017 йилдан буён Ўзбекистоннинг
        Лондондаги элчихонасида доимий рўйхатда туришини маълум қилган.
      </p>
      <p>
        Ибрат Сафо кейинроқ ушбу постини ўчириб ташлади. Пост ўрнида: «Баъзи процедурал сабабларга
        кўра, охирги постимни ҳозирча ўчирдим», деган ёзув пайдо бўлди ва кейинчалик пост яна
        тикланди.
      </p>
    </div>
  ),
  92: (
    <div>
      <p>
        Ижтимоий тармоқларда Фарҳод Темиртирноқ номи билан танилган ўзбекистонлик жамоатчилик фаоли
        ва блогер Фарҳоджон Умирзоқов 2023 йил 6 июль куни Москвада иш жойидан полиция ходимлари
        томонидан ушлаб кетилган. Бир кун ўтиб, Лефортово туман суди уни “миграция қонунчилигини
        бузгани” важи билан Россиядан бадарға қилиш ҳақида қарор чиқарган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/3af_PfJixGo?si=klz-R6UMW-QR6J-p"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Фарҳоджон Умирзоқовнинг яқинлари депортация қилинаётганини унинг Ўзбекистондаги норасмий
        “Ҳақиқат, Тараққиёт ва Бирдамлик” демократик партияси билан алоқаларига боғлаган. У
        мигрантлар орасида профессор Хидирназар Аллақулов партиясини рўйхатдан ўтказиш учун имзо
        йиғиш кампаниясида фаол қатнашган.
      </p>

      <p>
        Фарҳод Умирзоқов бир неча йилдан буён ижтимоий тармоқларда ўзининг танқидий чиқишлари ва
        сиёсий масалаларга оид кескин фикр-мулоҳазалари билан жамоатчиликка танилди. У, шунингдек,
        Россиядаги меҳнат муҳожирлари ҳуқуқий ҳимояси билан ҳам шуғулланган.
      </p>
    </div>
  ),
  93: (
    <div>
      <p>
        Андижонлик блогер Фотима Жўраева 2021 йил 22 ноябрь куни Facebook тармоғидаги ўз саҳифасида
        Улуғнор тумани электр тармоқлари корхонаси бош ҳисобчиси томонидан калтакланганига оид
        видеони жойлаштирган.
      </p>

      <p>
        Блогернинг айтишича, у фермер хўжаликларидан бирининг электр энергиясидан қарздорлиги сунъий
        равишда оширилгани тўғрисидаги гумонларни текшириш учун Улуғнор тумани электр тармоқлари
        корхонасига борган.
      </p>

      <p>
        Ф. Жўраева корхона бош ҳисобчисидан тегишли ҳужжатларни кўрсатишни талаб қилган, аммо бош
        ҳисобчи унга қўпол муомалада бўлган ва уни калтаклаган. Блогер ўз мурожаатида айбдор корхона
        ходимларига нисбатан қонуний чора кўришни сўраган.
      </p>

      <p>
        Суд-тиббий экспертизаси хулосасига мувофиқ, Жўраевада бош мия чайқалиши, бошнинг чап қовоқ
        соҳаси ёрилиши, чап елка, бел, қорин ва думба соҳаси юмшоқ тўқималарининг лат ейиши ва
        қонталашлар каби жароҳатлар аниқланган.
      </p>

      <p>
        Олиб борилган терговга қадар текширув натижасига кўра, Улуғнор тумани электр тармоқлари
        корхонаси бош ҳисобчиси С.М.га нисбатан туман ИИБ ҳузуридаги Тергов бўлинмаси томонидан
        Жиноят кодексининг 109-моддаси 2-қисми (қасддан баданга енгил шикаст етказиш) билан жиноят
        иши қўзғатилган ҳамда Фотима Жўраева жиноят ишида жабрланувчи дея эътироф этилган.
      </p>

      <p>Блогер Фотима Жўраева хотин-қизлар ҳуқуқлари ҳимояси билан фаол шуғулланиб келади.</p>
    </div>
  ),
  94: (
    <div>
      <p>
        Фэйсбукнинг ўзбек сегментида аввалига эр-хотин, куёв-қайнона муносабатларига оид ҳажвий
        постлари билан танилган фарғоналик блогер Дима Қаюм (Дилшод Болтабов) кейинроқ долзарб
        ижтимоий муаммоларни кўтара бошлади. Ўз постларида Дима Қаюм нафақат ўзи яшаётган Риштон
        тумани, балки бутун Ўзбекистон учун характерли бўлган, ҳеч кимга сир бўлмаган муаммолар -
        ёнилғию ёқилғи, электр қуввати тақчиллиги ҳақида ёзади.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/RoVlt1C1Xjk?si=BffsqoJMbyf2QxgP"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Блогер Дима Қаюм 2020 йил 26 октябрда танқидий постлари учун таъқиб қилинаётганига ишора
        қилган.
      </p>

      <p>
        “Мен Юртни, шу Юрт фуқороларини севаман! Танқидий постларимни фақат юрт ривожланишини хоҳлаб
        ёзаман! Президентимиз кўп бора танқид қилинглар, кейин ривожланиш бўлади деган гапларига
        ишонаман! Юртдан қочиб кетиш ниятим йўқ! Эҳсонлар ҳисоботини бериб боряпман! Кимлардандир
        пул келмайди менга! Кутубхонамда ноқонуний китоблар йўқ! Қонунни бузсам жавобгарликка ўзим
        бораман! Йўқотадиган ҳеч нарсам йўқ!” дейди таниқли блогер Дима Қаюм 2020 йил 26 октябрида
        эълон қилган видеопостида.
      </p>

      <p>
        Озодлик билан суҳбатда Дима Қаюм туман хавфсизлик хизмати ходими ундан постларини назоратдан
        ўтганидан кейин эълон қилишни талаб қилганини айтган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/_b0_gSIl9fM?si=-l4baL2Mv37wyRko"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        2021 йил 24 октябрь кунги президент сайлови арафасида ўзбек тилли ахборот маконида саноқли
        мустақил ахборот манбаси бўлиб қолаëтган Озодликка қарши виртуал хуружлар кучайди. Ўша
        кунларда блогер Дима Қаюм хуруж нишонига айланган. ДХХ троллари томонидан тарқатилган
        постларда фарғоналик блогер қаттиқ ҳақорат қилинган.
      </p>
    </div>
  ),
  95: (
    <div>
      <p>
        Тошкентлик блогер Отабек Жўраев 2019 йил 5 август куни Самарқанд шаҳрига борган пайти
        номаълум шахслар томонидан калтакланган. У Самарқандга фирибгарлар 250 миллион сўмга чув
        туширгани ҳақида шикоят қилган аёлнинг мурожаатини ўрганишга борган пайти ҳужумга учраган.
      </p>

      <p>
        Блогерга кўра, аёлнинг уйи ўнгида турган пайти "тўсатдан" пайдо бўлган шахс, арматура билан
        унинг бошига урган. Ҳужум натижасида ҳушидан кетган Отабек Жўраевнинг боши ёрилган.
      </p>

      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/wJp_1-hhrmw?si=ybZDo5SBH3imo8yM"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      <p>
        Озодлик билан суҳбатда Отабек Жўраев ҳужумни ўзининг блогерлик фаолияти билан боғлаган ва
        унга суиқасд уриниши бўлганини иддао қилган:
      </p>

      <p>
        - Мақсад мени оғзимни ёпиш бўлган бўлса керак-да. Лекин, мени келганимни қаердан билди,
        шунга ҳайронман. Бу аёл мошенниклар уни 250 миллион сўмга чув туширгани ҳақида милицияга,
        прокуратурага арз қилган, лекин улар ишни ёпти-ёпти қилган. Шу иш бўйича шуғулланаётганим
        уларга ёқмаган бўлса керак. Улар жиноят фош бўлишидан қўрқишган, чунки улар милицияни ҳам
        жиноят ишини ёптиришга кўндиришган экан-да, - деган Отабек Жўраев.
      </p>

      <p>
        Блогер Отабек Жўраев Ўзбекистонда ҳуқуқлари поймол бўлаётганлар муаммоларини кўтариб чиққан.
      </p>
    </div>
  ),
  96: (
    <div>
      <p>
        Қишлоқ хўжалиги вазирлигига қарашли “Ўзбекистон қишлоқ хўжалиги” журнали мухбири Бахтиёр
        Эсонов 2020 йил 21 ноябрь куни номаълум шахслар томонидан калтакланиб, дала четидаги ариққа
        ташлаб кетилган.
      </p>

      <p>
        Тошкент вилояти Зангиота тумани ИИБ тергов бўлимидан олинган маълумотга кўра, журналистга
        ҳужум қилган икки нафар шахс қўлга олинган. Уларнинг ёнидан журналист Бахтиёр Эсоновнинг 1,1
        миллион сўм пули, Redmi русумли уяли алоқа телефони ҳамда хизмат гувоҳномаси топилган.
      </p>

      <p>
        Дастлабки суриштирувларга кўра, 2020 йил 21 ноябрь куни ишдан қайтаётган мухбир хусусий
        киракашлар машинасига ўтирган. Ҳайдовчи Тошкент вилояти Зангиота тумани Назарбек қўрғонига
        етмасдан рулни яйдоқ дала четига буриб, журналистдан пул ва бошқа ашёларини чиқаришини талаб
        қилган. Сўнгра уни икки номаълум шахс уни уриб, “ўлди” деган гумон билан дала четидаги
        ариққа ташлаб кетишган.
      </p>

      <p>
        Шифокорлар хулосасига кўра, калтакланиш оқибатида журналистнинг тишлари синган, танасида
        оғир гематома асоратлари бор, бош қисмида эса жиддий жароҳатлар мавжуд.
      </p>

      <p>
        Тошкент вилояти Зангиота тумани ИИБ навбатчилик қисми журналистнинг калтакланишига оид
        вазиятга изоҳ бермаслиги, бу ҳодиса унинг касбий фаолияти билан боғлиқми-йўқлигига оид
        маълумотларга эга эмаслигини билдирган.
      </p>
    </div>
  ),
  97: (
    <div>
      <p>
        Qalampir.uz сайти журналисти Феруза Нажмиддинова 2021 йил август ойида танқидий чиқиши
        ортидан бўҳтон қурбони бўлган.
      </p>

      <p>
        2021 йил 7 августда ижтимоий тармоқларда тарқалган бир видеода Тошкентдаги кўп қаватли
        уйлардан бирининг балконида жинсий алоқа қилаётган жуфтлик акс этган. Унга берилган изоҳда
        видеодаги аёл Qalampir.uz журналисти Феруза Нажмиддинова дея тақдим қилинган.
      </p>

      <p>
        Ушбу видео тарқалишидан бир кун аввал Qalampir.uz нашрида Феруза Нажмиддинованинг “Tashkent
        City”даги айрим ресторанлар карантин қоидаларига амал қилмасдан соат 20:00дан кейин ҳам
        ишлаётгани танқид қилинган видео эълон қилиниб, Тошкент шаҳар ҳокимлиги танқил қилинган.
      </p>

      <p>
        Олий Мажлиси Сенати, Ўзбекистон журналистлари уюшмаси, Ўзбекистон Президенти Администрацияси
        ҳузуридаги Ахборот ва оммавий коммуникациялар агентлиги, “Юксалиш” умуммиллий ҳаракати ва
        Миллий масс-медиани қўллаб-қувватлаш ва ривожлантириш фонди ушбу воқеани{' '}
        <a href="https://www.ozodlik.org/a/men_feruzaman-tanqidiy-maqolasi-sabab-tahqirlangan-jurnalistni-qo-llash-aktsiyasi-boshlandi-/31399243.html">
          қоралаб чиқишган
        </a>
        .
      </p>

      <p>
        2021 йил 7 августда Интернетнинг ўзбек сегментида #Men_Feruzaman номли норозилик акцияси
        бошланган. Ушбу акцияга Ўзбекистон президентининг тўнғич қизи Саида Мирзиёева ҳам қўшилган.
      </p>

      <p>
        Ўзбек журналистлари, блогерлари Ф.Нажмиддиновани таҳқирловчи видео тарқалганига норозилик
        билдириб, айбдорлар жазоланишини талаб қилган.
      </p>

      <p>
        Феруза Нажмиддинова тарқатилган видеони “ўзининг шаъни ва обрўсига қилинган бўҳтон”, дея
        баҳолаб, бунга қонуний чора кўришни сўраб, ички ишлар бўлимига ариза билан мурожаат қилган.
      </p>

      <p>
        Тошкент шаҳар Ички ишлар бош бошқармаси Нажмиддинованинг мурожаати бўйича терговга қадар
        текширув бошланганини маълум қилган, аммо пировардида барибир айбдорлар топилмаган.
      </p>
    </div>
  ),
  98: (
    <div>
      <p>
        &#xa0;Effect.uz таҳририятининг Фарғона вилоят, Қува туманидаги тасвирчиси Ғиёсбек Эшов 2020
        йил 13 май, кеч соат 7 атрофида номаълум шахслар ҳужумига учраган.
      </p>

      <p>
        Нашр баёнотида айтилишича, журналистлар уйи бузилишга тушган ногирон аёл арзи юзасидан Қува
        тумани ҳокимлигида бўлиб, аризачининг уйига кетаётган пайтда ҳужумга учраган. Номаълум
        шахслар операторнинг кўзларига газ сепган, машинасининг ойналарини синдирган,
        видеокамерасини олиб қочган.
      </p>

      <p>
        2020 йил 14 май куннинг иккинчи ярмида Ўзбекистон Бош прокуратураси Қува туман ИИБ ва
        прокуратураси билан ҳамкорликда дастлабки тергов ҳаракатлари бошлангани, вазият назоратга
        олинганини билдирган. Бош прокуратура матбуот котиби Ҳаёт Шамсуддинов ўзининг Телеграм
        каналида сайт ходимининг ҳужумга учрагани юзасидан Ўзбекистон Жиноят кодексининг 166-моддаси
        (талончилик) бўйича жиноят иши қўзғатилгани, 4 нафар шахс гумонланувчи сифатида жалб
        қилинганини маълум қилган.
      </p>
    </div>
  ),
  99: (
    <div>
      <p>
        &#xa0;Kun.uz сайти журналисти Алишер Рўзиохунов 2020 йил 23 октябрь тунида ички ишлар ходими
        можаро сабаб унга нисбатан куч ишлатгани ҳақида маълум қилган. Унинг ўз Telegram каналидаги
        мурожаати «Вазир Бобожонов, илтимос истеъфо беринг, негаки сизнинг ходимларингиз фуқароларни
        ҳақоратлаб, калтаклашда давом этяпти. Сиз тизимни ўзгартира олмаяпсиз», сўзлари билан
        бошланади.
      </p>

      <p>
        Журналистнинг хабар беришича, у 2020 йил 23 октябрь тунги вақтда чорраҳадан ўтаётганида йўл
        ҳаракати ходимлари билан юзага келган англашилмовчилик пайти&#xa0;&#xa0; бир ходим дубинка
        билан унинг қорнига урган.
      </p>

      <p>
        “Хуллас, вазир жаноблари, иккиюзламачи, ўзбошимча ва ваколатини суиистеъмол қилиб, одам
        урадиган, ҳақоратлайдиган ходимларингизни ислоҳ қилолмаяпсиз. Буни эплайдиган одамга
        ўрнингизни бўшатиб беринг",&#xa0; деб талаб қилган Алишер Рўзиохунов ўз Telegram каналида.
      </p>

      <p>
        Ушбу ҳолат бўйича Миллий масс-медиани қўллаб-қувватлаш ва ривожлантириш жамоат фонди
        Васийлик кенгаши раиси Комил Алламжонов ва унинг ўринбосари Саида Мирзиёева муносабат
        билдириб, “журналист Алишер Рўзиохунов билан бўлиб ўтган ҳолат” юзасидан хавотир изҳор
        қилган.
      </p>
    </div>
  ),
  100: (
    <div>
      <p>
        Болтабой Матқурбонов "Муштум" ҳажвий журналининг Хоразм вилояти бўйича мухбири. У Хоразм
        вилоятидаги иқтисодий ва ижтимоий муаммоларни ҳажвий мақолалари орқали ёритиб келади.
      </p>

      <p>
        2019 йил 21 июль куни Хоразм вилоят, Қўшкўпир туман ички ишлар ходимлари айни туманнинг
        Ғозиобод қишлоғида истиқомат қилувчи Болтабой Матқурбоновнинг уйига бориб, унга тегишли
        ноутбук ва қўл телефонини олиб кетган.
      </p>

      <p>
        Бу ҳақда Озодликка хабар қилган Болтабой Матқурбоновнинг айтишича, икки нафар ички ишлар
        ходими унинг ноутбуки ва телефони ўрганиш учун олинаётганини билдирган, бироқ журналистга
        ҳеч қандай баённома тақдим этмаган.
      </p>
    </div>
  ),
};
